(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire629d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire629d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hCUQ1", function(module, exports) {
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
"use strict";

module.exports = (parcelRequire("1Iuhh")).polyfill();

});
parcelRegister("1Iuhh", function(module, exports) {

var $tmjiR = parcelRequire("tmjiR");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $tmjiR !== "undefined" && ({}).toString.call($tmjiR) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $tmjiR.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});
parcelRegister("tmjiR", function(module, exports) {
// shim for using process in browser
var $058403eabb2890c9$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $058403eabb2890c9$var$cachedSetTimeout;
var $058403eabb2890c9$var$cachedClearTimeout;
function $058403eabb2890c9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $058403eabb2890c9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $058403eabb2890c9$var$cachedSetTimeout = setTimeout;
        else $058403eabb2890c9$var$cachedSetTimeout = $058403eabb2890c9$var$defaultSetTimout;
    } catch (e) {
        $058403eabb2890c9$var$cachedSetTimeout = $058403eabb2890c9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $058403eabb2890c9$var$cachedClearTimeout = clearTimeout;
        else $058403eabb2890c9$var$cachedClearTimeout = $058403eabb2890c9$var$defaultClearTimeout;
    } catch (e) {
        $058403eabb2890c9$var$cachedClearTimeout = $058403eabb2890c9$var$defaultClearTimeout;
    }
})();
function $058403eabb2890c9$var$runTimeout(fun) {
    if ($058403eabb2890c9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($058403eabb2890c9$var$cachedSetTimeout === $058403eabb2890c9$var$defaultSetTimout || !$058403eabb2890c9$var$cachedSetTimeout) && setTimeout) {
        $058403eabb2890c9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $058403eabb2890c9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $058403eabb2890c9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $058403eabb2890c9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $058403eabb2890c9$var$runClearTimeout(marker) {
    if ($058403eabb2890c9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($058403eabb2890c9$var$cachedClearTimeout === $058403eabb2890c9$var$defaultClearTimeout || !$058403eabb2890c9$var$cachedClearTimeout) && clearTimeout) {
        $058403eabb2890c9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $058403eabb2890c9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $058403eabb2890c9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $058403eabb2890c9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $058403eabb2890c9$var$queue = [];
var $058403eabb2890c9$var$draining = false;
var $058403eabb2890c9$var$currentQueue;
var $058403eabb2890c9$var$queueIndex = -1;
function $058403eabb2890c9$var$cleanUpNextTick() {
    if (!$058403eabb2890c9$var$draining || !$058403eabb2890c9$var$currentQueue) return;
    $058403eabb2890c9$var$draining = false;
    if ($058403eabb2890c9$var$currentQueue.length) $058403eabb2890c9$var$queue = $058403eabb2890c9$var$currentQueue.concat($058403eabb2890c9$var$queue);
    else $058403eabb2890c9$var$queueIndex = -1;
    if ($058403eabb2890c9$var$queue.length) $058403eabb2890c9$var$drainQueue();
}
function $058403eabb2890c9$var$drainQueue() {
    if ($058403eabb2890c9$var$draining) return;
    var timeout = $058403eabb2890c9$var$runTimeout($058403eabb2890c9$var$cleanUpNextTick);
    $058403eabb2890c9$var$draining = true;
    var len = $058403eabb2890c9$var$queue.length;
    while(len){
        $058403eabb2890c9$var$currentQueue = $058403eabb2890c9$var$queue;
        $058403eabb2890c9$var$queue = [];
        while(++$058403eabb2890c9$var$queueIndex < len)if ($058403eabb2890c9$var$currentQueue) $058403eabb2890c9$var$currentQueue[$058403eabb2890c9$var$queueIndex].run();
        $058403eabb2890c9$var$queueIndex = -1;
        len = $058403eabb2890c9$var$queue.length;
    }
    $058403eabb2890c9$var$currentQueue = null;
    $058403eabb2890c9$var$draining = false;
    $058403eabb2890c9$var$runClearTimeout(timeout);
}
$058403eabb2890c9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $058403eabb2890c9$var$queue.push(new $058403eabb2890c9$var$Item(fun, args));
    if ($058403eabb2890c9$var$queue.length === 1 && !$058403eabb2890c9$var$draining) $058403eabb2890c9$var$runTimeout($058403eabb2890c9$var$drainQueue);
};
// v8 likes predictible objects
function $058403eabb2890c9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$058403eabb2890c9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$058403eabb2890c9$var$process.title = "browser";
$058403eabb2890c9$var$process.browser = true;
$058403eabb2890c9$var$process.env = {};
$058403eabb2890c9$var$process.argv = [];
$058403eabb2890c9$var$process.version = ""; // empty string to avoid regexp issues
$058403eabb2890c9$var$process.versions = {};
function $058403eabb2890c9$var$noop() {}
$058403eabb2890c9$var$process.on = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.addListener = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.once = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.off = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.removeListener = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.removeAllListeners = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.emit = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.prependListener = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.prependOnceListener = $058403eabb2890c9$var$noop;
$058403eabb2890c9$var$process.listeners = function(name) {
    return [];
};
$058403eabb2890c9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$058403eabb2890c9$var$process.cwd = function() {
    return "/";
};
$058403eabb2890c9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$058403eabb2890c9$var$process.umask = function() {
    return 0;
};

});



parcelRegister("7gLyp", function(module, exports) {

$parcel$export(module.exports, "initializeTracking", function () { return $5cb19d7c3ad50710$export$cea2347b0cbd5cc2; });
$parcel$export(module.exports, "logEvent", function () { return $5cb19d7c3ad50710$export$5e9eec8001665ac5; });
$parcel$export(module.exports, "trackGA4Event", function () { return (parcelRequire("btdOp")).trackGA4Event; });
$parcel$export(module.exports, "GA4Event", function () { return (parcelRequire("b2K9z")).GA4Event; });
// import { urlToObject } from './utils';

var $btdOp = parcelRequire("btdOp");

var $b2K9z = parcelRequire("b2K9z");
async function $5cb19d7c3ad50710$export$cea2347b0cbd5cc2(_site, /** Optional Google Analytics 4 Measurement ID */ ga4MeasurementId) {
    // site = _site;
    $5cb19d7c3ad50710$var$setupAutomatedTracking();
    (0, $btdOp.listenForChatbotEvents)(ga4MeasurementId);
}
async function $5cb19d7c3ad50710$export$5e9eec8001665ac5({ name: name, data: data }) {
// const commonEventData = {
//   site,
//   pageTitle: document.title,
//   pageUrl: urlToObject(new URL(window.location.href)),
// };
// TODO: Send request to backend to track event
}
/**
 * Set up automated tracking
 */ function $5cb19d7c3ad50710$var$setupAutomatedTracking() {
    /**
   * Auto detect page changes
   */ $5cb19d7c3ad50710$export$5e9eec8001665ac5({
        name: "page_view"
    });
    window.addEventListener("changestate", ()=>{
        $5cb19d7c3ad50710$export$5e9eec8001665ac5({
            name: "page_view"
        });
    });
    /**
   * Auto detect link clicks
   */ document.addEventListener("click", function(e) {
        const el = e.target;
        const anchorEl = el.closest("a");
        if (!anchorEl) return;
        const href = anchorEl.href || "";
        if (href.startsWith("tel:")) $5cb19d7c3ad50710$export$5e9eec8001665ac5({
            name: "website_tel_clicked",
            data: {
                href: href,
                phoneNumber: $5cb19d7c3ad50710$var$cleanParams(href.substring(4))
            }
        });
        else if (href.startsWith("sms:")) $5cb19d7c3ad50710$export$5e9eec8001665ac5({
            name: "website_sms_clicked",
            data: {
                href: href,
                phoneNumber: $5cb19d7c3ad50710$var$cleanParams(href.substring(4))
            }
        });
        else if (href.startsWith("mailto:")) $5cb19d7c3ad50710$export$5e9eec8001665ac5({
            name: "website_email_clicked",
            data: {
                href: href,
                email: $5cb19d7c3ad50710$var$cleanParams(href.substring(7))
            }
        });
        else // If none of the above match, we assume it's a normal website link
        $5cb19d7c3ad50710$export$5e9eec8001665ac5({
            name: "website_link_clicked",
            data: {
                href: href
            }
        });
    });
}
/**
 * Utility function to remove any query params appended to a string
 * e.g. a "subject" param added to a "mailto:"" link
 */ function $5cb19d7c3ad50710$var$cleanParams(str) {
    const startOfParams = str.indexOf("?");
    if (startOfParams > -1) return str.substring(0, startOfParams);
    return str;
}

});
parcelRegister("btdOp", function(module, exports) {

$parcel$export(module.exports, "setGoogleAnalyticsUserId", function () { return $79f0286d3897fc6b$export$8832c81f5273e33e; });
$parcel$export(module.exports, "setGoogleAnalyticsPageview", function () { return $79f0286d3897fc6b$export$b3bca09d65e46192; });
$parcel$export(module.exports, "trackGA4Event", function () { return $79f0286d3897fc6b$export$59852178691f8f81; });
$parcel$export(module.exports, "decorateCrossDomainLink", function () { return $79f0286d3897fc6b$export$58a6d4c00bbccd6e; });
$parcel$export(module.exports, "listenForChatbotEvents", function () { return $79f0286d3897fc6b$export$c5e3140ab8667a48; });

var $bG9Ei = parcelRequire("bG9Ei");

var $e3viL = parcelRequire("e3viL");

var $bmx1q = parcelRequire("bmx1q");
function $79f0286d3897fc6b$export$8832c81f5273e33e(id) {
    try {
        window.gtag("set", "user_id", id);
    } catch (error) {
        console.warn("Error setting Google Analytics `user_id`: ", error);
    }
}
function $79f0286d3897fc6b$export$b3bca09d65e46192(pageview) {
    try {
        window.gtag("set", "page_location", pageview.page.url.href);
        window.gtag("set", "page_title", pageview.page.title);
    } catch (error) {
        console.warn("Error setting Google Analytics page_location and page_title: ", error);
    }
}
function $79f0286d3897fc6b$export$59852178691f8f81(/** Name of Google Analytics event */ eventName, /** Event parameters */ params, /** Send event to parent window GA4 properties (aka client) */ sendToClient) {
    try {
        const eventParameters = {
            send_to: (0, $e3viL.GA4_MEASUREMENT_ID),
            site: (0, $bG9Ei.SITE_SLUG),
            conversation_id: (0, $bmx1q.STORAGE).conversationId,
            web_session_id: (0, $bmx1q.STORAGE).webSessionId,
            ...params || {}
        };
        window.gtag("event", eventName, eventParameters);
        if (sendToClient) {
            /** Prepend this to the event name for client trackers */ const prepended = "chatbot_";
            const parentWindowParams = {
                ...eventParameters
            };
            delete parentWindowParams.send_to;
            parentWindowParams.chatbot_version = (0, $e3viL.VERSION);
            // send to parent window via `window.parent.postMessage`
            $79f0286d3897fc6b$var$sendChatbotEventToParentWindow(prepended + eventName, parentWindowParams);
        }
    } catch (error) {
        console.error("[TOMIS Chatbot] Error sending GA4 event", error);
    }
}
/** Post Message for parent window to receive.
 *
 * Make sure parent window knows to listen for messages
 * from the ChatBot iframe, matching the data here.
 *
 * Not using "penpal", which allows us to send GA4 events
 * from anywhere more easily, without needing to use React context.
 */ function $79f0286d3897fc6b$var$sendChatbotEventToParentWindow(eventName, params) {
    try {
        window.parent.postMessage({
            event: "chatbot_event",
            eventName: eventName,
            params: params
        }, "*");
    } catch (error) {
        console.error("[TOMIS Chatbot] Error sending GA4 event to parent window", error);
    }
}
function $79f0286d3897fc6b$export$e5b4e6ba909b0593() {
    try {
        /** Google Analytics 4 Measurement IDs */ let measurementIds = [];
        /** Google Analytics 4 includes this script for each measurement id.
     * Even if loaded via GTM, GTM will add this script to the DOM */ document.querySelectorAll("script[src^='https://www.googletagmanager.com/gtag/js?id=G-']").forEach(function getGA4Information(script) {
            const measurementId = new URL(script.src).searchParams.get("id");
            measurementIds.push(measurementId);
        });
        if (measurementIds.length === 0) {
            // If gtag scripts aren't loaded on the site for some reason, try to get
            // GA4 Measurement IDs from cookies
            const gaCookies = document.cookie.split("; ").filter(function getGA4(pair) {
                return pair.split("=", 1)[0].indexOf("_ga_") > -1;
            });
            if (gaCookies.length > 0) {
                const ga4MeasurementIds = gaCookies.map((c)=>`G-${c.split("_ga_")[1].split("=")[0]}`);
                measurementIds = ga4MeasurementIds;
            } else console.warn("[TOMIS Chatbot] Google Analytics 4 is not found on this website");
        }
        return measurementIds;
    } catch (error) {
        console.warn("[TOMIS Chatbot] Error occurred when trying to search for GA4 on the site");
        return [];
    }
}
function $79f0286d3897fc6b$export$58a6d4c00bbccd6e(url) {
    const tempAnchorEl = document.createElement("a");
    tempAnchorEl.setAttribute("type", "hidden");
    tempAnchorEl.setAttribute("href", url);
    tempAnchorEl.setAttribute("onclick", "event.preventDefault(); return false");
    document.body.appendChild(tempAnchorEl);
    tempAnchorEl.dispatchEvent(new MouseEvent("mousedown", {
        bubbles: true
    }));
    const urlWithLinker = tempAnchorEl.href;
    tempAnchorEl.remove();
    return urlWithLinker;
}
function $79f0286d3897fc6b$export$c5e3140ab8667a48(ga4MeasurementId) {
    window.dataLayer = window.dataLayer || [];
    /** Create `gtag` command if client website is using GTM */ window.gtag = window.gtag || function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
    };
    window.addEventListener("message", function handleChatbotEvents(event) {
        /** We only want to listen to messages from our chatbot, not other iframes
     * that may exist on the site */ const allowedOrigins = [
            "https://tomis-bot.firebaseapp.com",
            "https://tomis-bot-dev.firebaseapp.com",
            (0, $e3viL.DEV_ORIGIN)
        ];
        if (allowedOrigins.includes(event.origin) && event.data && typeof event.data === "object" && event.data.event === "chatbot_event") try {
            const { eventName: eventName, params: params } = event.data;
            /** If a GA4 ID is provided, use it ONLY
         * 
         * How to provide a single GA4 ID for a chatbot: 
         * 
              var tomis = TOMIS({
                site: "site-slug", 
                googleAnalyticsId: "G-XXXXXXX"
              });
              tomis.setupBot();
         */ // If a GA4 ID is provided, use it ONLY
            if (ga4MeasurementId) params.send_to = ga4MeasurementId.trim();
            else // Otherwise, send to all GA4 IDs found on the site
            params.send_to = $79f0286d3897fc6b$export$e5b4e6ba909b0593();
            /** Calling `window.gtag` automatically pushes to dataLayer.
         * 
         * Example of GTM dataLayer after the gtag event: 
         * 
          dataLayer.push({
            event: "chatbot_window_opened",
            eventModel: {
              site: "site-slug",
              conversation_id: "XXXXXXX",
              web_session_id: "XXXXXX-XX-XXXX-XXXX-XXXXXXXXXX"
            },
            gtm.uniqueEventId: 6
          })
         * 
         * Therefore, event parameters can be converted to GTM variables by 
         * accessing `eventModel[paramName]`
         */ window.gtag("event", eventName, params);
        // Don't need this code below, because `gtag` pushes to dataLayer for us
        // window.dataLayer.push({ event: eventName, ...params });
        } catch (error) {
            console.error("[TOMIS Chatbot] Could not process chatbot event", error);
        }
    });
}

});
parcelRegister("bG9Ei", function(module, exports) {

$parcel$export(module.exports, "SITE_SLUG", function () { return $4f30dc75a6dc09e7$export$d06c53f219a863bc; });
$parcel$export(module.exports, "initialParentWidth", function () { return $4f30dc75a6dc09e7$export$3cd04d4a242785f4; });
$parcel$export(module.exports, "initialParentHeight", function () { return $4f30dc75a6dc09e7$export$75dec61024c8d12e; });
$parcel$export(module.exports, "mainButtonSize", function () { return $4f30dc75a6dc09e7$export$fd575f189f0b3ab9; });
$parcel$export(module.exports, "themeBlue", function () { return $4f30dc75a6dc09e7$export$287af85e65d7c75e; });
$parcel$export(module.exports, "chatWindowHeaderHeight", function () { return $4f30dc75a6dc09e7$export$438217ce9f7766fc; });
$parcel$export(module.exports, "chatWindowHeaderShadowHeight", function () { return $4f30dc75a6dc09e7$export$eceae1c8eca54cb9; });
$parcel$export(module.exports, "SEARCH", function () { return $4f30dc75a6dc09e7$export$a6b9aaee40d49fd0; });
$parcel$export(module.exports, "CheckAvailabilitySearchPrefix", function () { return $4f30dc75a6dc09e7$export$4fb788f3fdddd9be; });
$parcel$export(module.exports, "DEFAULT_CHECK_AVAILABILITY_PRODUCTS", function () { return $4f30dc75a6dc09e7$export$4188bce314c97160; });
const $4f30dc75a6dc09e7$export$3658bc9a5259382a = new URL(window.location.href);
const $4f30dc75a6dc09e7$export$d06c53f219a863bc = $4f30dc75a6dc09e7$export$3658bc9a5259382a.searchParams.get("site");
const $4f30dc75a6dc09e7$export$3cd04d4a242785f4 = Number($4f30dc75a6dc09e7$export$3658bc9a5259382a.searchParams.get("initialParentWidth"));
const $4f30dc75a6dc09e7$export$75dec61024c8d12e = Number($4f30dc75a6dc09e7$export$3658bc9a5259382a.searchParams.get("initialParentHeight"));
const $4f30dc75a6dc09e7$export$fd575f189f0b3ab9 = 52;
const $4f30dc75a6dc09e7$export$287af85e65d7c75e = "rgb(0,112,255)";
const $4f30dc75a6dc09e7$export$438217ce9f7766fc = 60;
const $4f30dc75a6dc09e7$export$eceae1c8eca54cb9 = 6;
const $4f30dc75a6dc09e7$export$42ab219579f9ded3 = "All Products";
const $4f30dc75a6dc09e7$export$a6b9aaee40d49fd0 = "Search";
const $4f30dc75a6dc09e7$export$4fb788f3fdddd9be = "Check availability search...";
const $4f30dc75a6dc09e7$export$4188bce314c97160 = {
    category: "",
    products: []
};

});

parcelRegister("e3viL", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ID", function () { return $52d9d0cbcf4d919e$export$da6f46390e1a426f; });
$parcel$export(module.exports, "ENVIRONMENT", function () { return $52d9d0cbcf4d919e$export$be46596bc6608f3b; });
$parcel$export(module.exports, "VERSION", function () { return $52d9d0cbcf4d919e$export$a4ad2735b021c132; });
$parcel$export(module.exports, "IS_DEV", function () { return $52d9d0cbcf4d919e$export$3fce19fdf0c5de73; });
$parcel$export(module.exports, "DEV_ORIGIN", function () { return $52d9d0cbcf4d919e$export$89fc1849db205e90; });
$parcel$export(module.exports, "CLOUD_FUNCTIONS_BASE_URI", function () { return $52d9d0cbcf4d919e$export$b651aa1d1bd2ac2c; });
$parcel$export(module.exports, "TOMIS_GA4_MEASUREMENT_ID", function () { return $52d9d0cbcf4d919e$export$a0ff89c5e513687a; });
$parcel$export(module.exports, "TOMIS_DEV_GA4_MEASUREMENT_ID", function () { return $52d9d0cbcf4d919e$export$ba228d8cca7182ce; });
$parcel$export(module.exports, "GA4_MEASUREMENT_ID", function () { return $52d9d0cbcf4d919e$export$7828cda48901e9b7; });
/** Google Cloud project id ("tomis-bot" or "tomis-bot-dev")  */ const $52d9d0cbcf4d919e$export$da6f46390e1a426f = "tomis-bot";
const $52d9d0cbcf4d919e$export$be46596bc6608f3b = {
    "tomis-bot": "production",
    "tomis-bot-dev": "development"
}[$52d9d0cbcf4d919e$export$da6f46390e1a426f];
const $52d9d0cbcf4d919e$export$a4ad2735b021c132 = "2.34.3";
const $52d9d0cbcf4d919e$export$3fce19fdf0c5de73 = false;
const $52d9d0cbcf4d919e$export$7fad4a095116031a = Boolean(undefined);
const $52d9d0cbcf4d919e$export$89fc1849db205e90 = $52d9d0cbcf4d919e$export$7fad4a095116031a ? "https://tomis.ngrok.io" : "http://localhost:1234";
const $52d9d0cbcf4d919e$export$b651aa1d1bd2ac2c = $52d9d0cbcf4d919e$export$3fce19fdf0c5de73 ? `http://localhost:5007/${$52d9d0cbcf4d919e$export$da6f46390e1a426f}/us-central1/` : `https://us-central1-${$52d9d0cbcf4d919e$export$da6f46390e1a426f}.cloudfunctions.net/`;
const $52d9d0cbcf4d919e$export$a0ff89c5e513687a = "G-YT7KJT8ZQC";
const $52d9d0cbcf4d919e$export$ba228d8cca7182ce = "G-W7MK7RTR55";
const $52d9d0cbcf4d919e$export$7828cda48901e9b7 = $52d9d0cbcf4d919e$export$da6f46390e1a426f === "tomis-bot" ? $52d9d0cbcf4d919e$export$a0ff89c5e513687a : $52d9d0cbcf4d919e$export$ba228d8cca7182ce;

});

parcelRegister("bmx1q", function(module, exports) {

$parcel$export(module.exports, "STORAGE", function () { return $4f7a569ba340b1a7$export$e52920da3d8ae458; });
/** Important global variables that are required for the ChatBot to operate.
 * Previously these were derived from iframe local and session storage, which prevented
 * bot from loading on sites that blocked third party cookies.
 *
 * Now, we are using this global variable to ensure the ChatBot loads even
 * if third party cookies are blocked.
 */ const $4f7a569ba340b1a7$export$e52920da3d8ae458 = {
    /** Used to identify users across sessions and potentially across sites.
   * This will be used as the Firebase UID. */ tomisDeviceId: "",
    /** Web Session is purely for tracking purposes */ webSessionId: "",
    /** Conversation ID is necessary to subscribe to correct conversation */ conversationId: ""
};

});


parcelRegister("b2K9z", function(module, exports) {

$parcel$export(module.exports, "GA4Event", function () { return $0465e7eeba9ed01a$export$44e39e2cd22f96e6; });
var $0465e7eeba9ed01a$export$b519be5af25a5081;
(function(UniversalAnalyticsEvent) {
    UniversalAnalyticsEvent["Loaded"] = "Loaded";
    UniversalAnalyticsEvent["ReceivedWelcomeMessage"] = "Received Welcome Message";
    UniversalAnalyticsEvent["CustomerMessage"] = "Customer Message";
    UniversalAnalyticsEvent["ChatbotMessage"] = "Chatbot Message";
    UniversalAnalyticsEvent["SupportMessage"] = "Support Message";
    UniversalAnalyticsEvent["SupportAcceptedChat"] = "Support Accepted Live Chat";
    UniversalAnalyticsEvent["SupportMissedChat"] = "Support Missed Live Chat";
    UniversalAnalyticsEvent["LeadCaptured"] = "Lead Captured";
    UniversalAnalyticsEvent["WindowOpened"] = "Window Opened";
    UniversalAnalyticsEvent["WindowClosed"] = "Window Closed";
    UniversalAnalyticsEvent["RequestedLiveChat"] = "Requested Live Chat";
    UniversalAnalyticsEvent["PhoneClicked"] = "Phone Number Clicked";
    UniversalAnalyticsEvent["EmailClicked"] = "Email Clicked";
    UniversalAnalyticsEvent["UrlClicked"] = "URL Clicked";
})($0465e7eeba9ed01a$export$b519be5af25a5081 || ($0465e7eeba9ed01a$export$b519be5af25a5081 = {}));
var $0465e7eeba9ed01a$export$44e39e2cd22f96e6;
(function(GA4Event) {
    /** chatbot loads on the page */ GA4Event["Loaded"] = "loaded";
    /** Technical error occurred when trying to load the ChatBot:
   * - Error initializing chatbot (api) or other technical error
   * when trying to load chatbot iframe */ GA4Event["LoadFailed"] = "load_failed";
    /** Several reasons that chatbot shouldn't load on the page:
   * - Bot isn't allowed to load on parent window
   * - Crawler bots are detected and blocked (e.g. Googlebot)
   * - Chatbot is disabled
   * - Chatbot not found */ GA4Event["LoadPrevented"] = "load_prevented";
    /** Welcome Message is received by chatbot (from Dialogflow) */ GA4Event["MessageReceivedWelcome"] = "message_received_welcome";
    /** Chatbot responds to customer question */ GA4Event["MessageReceivedAutomated"] = "message_received_automated";
    /** Live Chat support sends a message */ GA4Event["MessageReceivedSupport"] = "message_received_support";
    /** Customer sends a message to chatbot */ GA4Event["MessageSentCustomer"] = "message_sent_customer";
    /** Customer requests live chat with support agent */ GA4Event["WebchatRequested"] = "webchat_requested";
    /** Live chat request is accepted by support agent */ GA4Event["WebchatAccepted"] = "webchat_accepted";
    /** Live chat request is missed by support agent */ GA4Event["WebchatMissed"] = "webchat_missed";
    /** Customer completes form to request SMS Chat */ GA4Event["LeadCapturedSMS"] = "lead_captured_sms";
    /** Customer completes form to request Live Chat */ GA4Event["LeadCapturedWebchat"] = "lead_captured_webchat";
    /** Chatbot window is opened */ GA4Event["WindowOpened"] = "window_opened";
    /** Chatbot window is closed */ GA4Event["WindowClosed"] = "window_closed";
    /** Customer clicked phone number link */ GA4Event["ClickedPhone"] = "clicked_phone";
    /** Customer clicked email address */ GA4Event["ClickedEmail"] = "clicked_email";
    /** Customer clicked url */ GA4Event["ClickedUrl"] = "clicked_url";
    /** Customer clicked on Powered By TOMIS logo */ GA4Event["ClickedPoweredByTomis"] = "clicked_powered_by_tomis";
    /** Customer clicked "Return to ChatBot conversation" */ GA4Event["ClickedReturnToChatbot"] = "clicked_return_to_chatbot";
    /** Customer clicked on "Request SMS Chat" link */ GA4Event["ClickedRequestSms"] = "clicked_return_to_request_sms";
    /** Customer clicked on a quick reply */ GA4Event["ClickedQuickReply"] = "clicked_quick_reply";
    /** Customer checked availability (all parameters are valid) */ GA4Event["CheckAvailabilitySearch"] = "check_availability_search";
    GA4Event["CheckAvailabilitySelectQuantity"] = "check_availability_select_quantity";
    GA4Event["CheckAvailabilitySelectDate"] = "check_availability_select_date";
    GA4Event["CheckAvailabilitySelectProduct"] = "check_availability_select_product";
    GA4Event["CheckAvailabilityClickMoreTimes"] = "check_availability_click_more_times";
    GA4Event["CheckAvailabilityLinkClick"] = "check_availability_link_click";
    /** Error boundary was reached */ GA4Event["Crashed"] = "crashed";
})($0465e7eeba9ed01a$export$44e39e2cd22f96e6 || ($0465e7eeba9ed01a$export$44e39e2cd22f96e6 = {}));

});


parcelRegister("2uMsc", function(module, exports) {
(function(global1) {
    /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */ var checkIfIteratorIsSupported = function() {
        try {
            return !!Symbol.iterator;
        } catch (error) {
            return false;
        }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
        if (iteratorSupported) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    };
    /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */ var serializeParam = function(value) {
        return encodeURIComponent(value).replace(/%20/g, "+");
    };
    var deserializeParam = function(value) {
        return decodeURIComponent(String(value).replace(/\+/g, " "));
    };
    var polyfillURLSearchParams = function() {
        var URLSearchParams = function(searchString) {
            Object.defineProperty(this, "_entries", {
                writable: true,
                value: {}
            });
            var typeofSearchString = typeof searchString;
            if (typeofSearchString === "undefined") ;
            else if (typeofSearchString === "string") {
                if (searchString !== "") this._fromString(searchString);
            } else if (searchString instanceof URLSearchParams) {
                var _this = this;
                searchString.forEach(function(value, name) {
                    _this.append(name, value);
                });
            } else if (searchString !== null && typeofSearchString === "object") {
                if (Object.prototype.toString.call(searchString) === "[object Array]") for(var i = 0; i < searchString.length; i++){
                    var entry = searchString[i];
                    if (Object.prototype.toString.call(entry) === "[object Array]" || entry.length !== 2) this.append(entry[0], entry[1]);
                    else throw new TypeError("Expected [string, any] as entry at index " + i + " of URLSearchParams's input");
                }
                else {
                    for(var key in searchString)if (searchString.hasOwnProperty(key)) this.append(key, searchString[key]);
                }
            } else throw new TypeError("Unsupported input's type for URLSearchParams");
        };
        var proto = URLSearchParams.prototype;
        proto.append = function(name, value) {
            if (name in this._entries) this._entries[name].push(String(value));
            else this._entries[name] = [
                String(value)
            ];
        };
        proto.delete = function(name) {
            delete this._entries[name];
        };
        proto.get = function(name) {
            return name in this._entries ? this._entries[name][0] : null;
        };
        proto.getAll = function(name) {
            return name in this._entries ? this._entries[name].slice(0) : [];
        };
        proto.has = function(name) {
            return name in this._entries;
        };
        proto.set = function(name, value) {
            this._entries[name] = [
                String(value)
            ];
        };
        proto.forEach = function(callback, thisArg) {
            var entries;
            for(var name in this._entries)if (this._entries.hasOwnProperty(name)) {
                entries = this._entries[name];
                for(var i = 0; i < entries.length; i++)callback.call(thisArg, entries[i], name, this);
            }
        };
        proto.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return createIterator(items);
        };
        proto.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return createIterator(items);
        };
        proto.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return createIterator(items);
        };
        if (iteratorSupported) proto[Symbol.iterator] = proto.entries;
        proto.toString = function() {
            var searchArray = [];
            this.forEach(function(value, name) {
                searchArray.push(serializeParam(name) + "=" + serializeParam(value));
            });
            return searchArray.join("&");
        };
        global1.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function() {
        try {
            var URLSearchParams = global1.URLSearchParams;
            return new URLSearchParams("?a=1").toString() === "a=1" && typeof URLSearchParams.prototype.set === "function" && typeof URLSearchParams.prototype.entries === "function";
        } catch (e) {
            return false;
        }
    };
    if (!checkIfURLSearchParamsSupported()) polyfillURLSearchParams();
    var proto = global1.URLSearchParams.prototype;
    if (typeof proto.sort !== "function") proto.sort = function() {
        var _this = this;
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
            if (!_this._entries) _this.delete(name);
        });
        items.sort(function(a, b) {
            if (a[0] < b[0]) return -1;
            else if (a[0] > b[0]) return 1;
            else return 0;
        });
        if (_this._entries) _this._entries = {};
        for(var i = 0; i < items.length; i++)this.append(items[i][0], items[i][1]);
    };
    if (typeof proto._fromString !== "function") Object.defineProperty(proto, "_fromString", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(searchString) {
            if (this._entries) this._entries = {};
            else {
                var keys = [];
                this.forEach(function(value, name) {
                    keys.push(name);
                });
                for(var i = 0; i < keys.length; i++)this.delete(keys[i]);
            }
            searchString = searchString.replace(/^\?/, "");
            var attributes = searchString.split("&");
            var attribute;
            for(var i = 0; i < attributes.length; i++){
                attribute = attributes[i].split("=");
                this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute[1]) : "");
            }
        }
    });
// HTMLAnchorElement
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : module.exports);
(function(global1) {
    /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */ var checkIfURLIsSupported = function() {
        try {
            var u = new global1.URL("b", "http://a");
            u.pathname = "c d";
            return u.href === "http://a/c%20d" && u.searchParams;
        } catch (e) {
            return false;
        }
    };
    var polyfillURL = function() {
        var _URL = global1.URL;
        var URL = function(url, base) {
            if (typeof url !== "string") url = String(url);
            if (base && typeof base !== "string") base = String(base);
            // Only create another document if the base is different from current location.
            var doc = document, baseElement;
            if (base && (global1.location === void 0 || base !== global1.location.href)) {
                base = base.toLowerCase();
                doc = document.implementation.createHTMLDocument("");
                baseElement = doc.createElement("base");
                baseElement.href = base;
                doc.head.appendChild(baseElement);
                try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                } catch (err) {
                    throw new Error("URL unable to set base " + base + " due to " + err);
                }
            }
            var anchorElement = doc.createElement("a");
            anchorElement.href = url;
            if (baseElement) {
                doc.body.appendChild(anchorElement);
                anchorElement.href = anchorElement.href; // force href to refresh
            }
            var inputElement = doc.createElement("input");
            inputElement.type = "url";
            inputElement.value = url;
            if (anchorElement.protocol === ":" || !/:/.test(anchorElement.href) || !inputElement.checkValidity() && !base) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: anchorElement
            });
            // create a linked searchParams which reflect its changes on URL
            var searchParams = new global1.URLSearchParams(this.search);
            var enableSearchUpdate = true;
            var enableSearchParamsUpdate = true;
            var _this = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(methodName) {
                var method = searchParams[methodName];
                searchParams[methodName] = function() {
                    method.apply(searchParams, arguments);
                    if (enableSearchUpdate) {
                        enableSearchParamsUpdate = false;
                        _this.search = searchParams.toString();
                        enableSearchParamsUpdate = true;
                    }
                };
            });
            Object.defineProperty(this, "searchParams", {
                value: searchParams,
                enumerable: true
            });
            var search = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function() {
                    if (this.search !== search) {
                        search = this.search;
                        if (enableSearchParamsUpdate) {
                            enableSearchUpdate = false;
                            this.searchParams._fromString(this.search);
                            enableSearchUpdate = true;
                        }
                    }
                }
            });
        };
        var proto = URL.prototype;
        var linkURLWithAnchorAttribute = function(attributeName) {
            Object.defineProperty(proto, attributeName, {
                get: function() {
                    return this._anchorElement[attributeName];
                },
                set: function(value) {
                    this._anchorElement[attributeName] = value;
                },
                enumerable: true
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(attributeName) {
            linkURLWithAnchorAttribute(attributeName);
        });
        Object.defineProperty(proto, "search", {
            get: function() {
                return this._anchorElement["search"];
            },
            set: function(value) {
                this._anchorElement["search"] = value;
                this._updateSearchParams();
            },
            enumerable: true
        });
        Object.defineProperties(proto, {
            "toString": {
                get: function() {
                    var _this = this;
                    return function() {
                        return _this.href;
                    };
                }
            },
            "href": {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function(value) {
                    this._anchorElement.href = value;
                    this._updateSearchParams();
                },
                enumerable: true
            },
            "pathname": {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function(value) {
                    this._anchorElement.pathname = value;
                },
                enumerable: true
            },
            "origin": {
                get: function() {
                    // get expected port from protocol
                    var expectedPort = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol];
                    // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''
                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (addPortToOrigin ? ":" + this._anchorElement.port : "");
                },
                enumerable: true
            },
            "password": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            },
            "username": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            }
        });
        URL.createObjectURL = function(blob) {
            return _URL.createObjectURL.apply(_URL, arguments);
        };
        URL.revokeObjectURL = function(url) {
            return _URL.revokeObjectURL.apply(_URL, arguments);
        };
        global1.URL = URL;
    };
    if (!checkIfURLIsSupported()) polyfillURL();
    if (global1.location !== void 0 && !("origin" in global1.location)) {
        var getOrigin = function() {
            return global1.location.protocol + "//" + global1.location.hostname + (global1.location.port ? ":" + global1.location.port : "");
        };
        try {
            Object.defineProperty(global1.location, "origin", {
                get: getOrigin,
                enumerable: true
            });
        } catch (e) {
            setInterval(function() {
                global1.location.origin = getOrigin();
            }, 100);
        }
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : module.exports);

});

parcelRegister("9mZp7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = module.exports.ERR_NOT_IN_IFRAME = module.exports.ERR_CONNECTION_TIMEOUT = module.exports.ERR_CONNECTION_DESTROYED = void 0;
var $6d25ccbc57432887$var$HANDSHAKE = "handshake";
var $6d25ccbc57432887$var$HANDSHAKE_REPLY = "handshake-reply";
var $6d25ccbc57432887$var$CALL = "call";
var $6d25ccbc57432887$var$REPLY = "reply";
var $6d25ccbc57432887$var$FULFILLED = "fulfilled";
var $6d25ccbc57432887$var$REJECTED = "rejected";
var $6d25ccbc57432887$var$MESSAGE = "message";
var $6d25ccbc57432887$var$DATA_CLONE_ERROR = "DataCloneError";
var $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED = "ConnectionDestroyed";
module.exports.ERR_CONNECTION_DESTROYED = $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED;
var $6d25ccbc57432887$var$ERR_CONNECTION_TIMEOUT = "ConnectionTimeout";
module.exports.ERR_CONNECTION_TIMEOUT = $6d25ccbc57432887$var$ERR_CONNECTION_TIMEOUT;
var $6d25ccbc57432887$var$ERR_NOT_IN_IFRAME = "NotInIframe";
module.exports.ERR_NOT_IN_IFRAME = $6d25ccbc57432887$var$ERR_NOT_IN_IFRAME;
var $6d25ccbc57432887$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = "IframeAlreadyAttachedToDom";
module.exports.ERR_IFRAME_ALREADY_ATTACHED_TO_DOM = $6d25ccbc57432887$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM;
var $6d25ccbc57432887$var$CHECK_IFRAME_IN_DOC_INTERVAL = 60000;
var $6d25ccbc57432887$var$DEFAULT_PORTS = {
    "http:": "80",
    "https:": "443"
};
var $6d25ccbc57432887$var$URL_REGEX = /^(https?:|file:)?\/\/([^/:]+)?(:(\d+))?/;
var $6d25ccbc57432887$var$Penpal = {
    ERR_CONNECTION_DESTROYED: $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED,
    ERR_CONNECTION_TIMEOUT: $6d25ccbc57432887$var$ERR_CONNECTION_TIMEOUT,
    ERR_NOT_IN_IFRAME: $6d25ccbc57432887$var$ERR_NOT_IN_IFRAME,
    ERR_IFRAME_ALREADY_ATTACHED_TO_DOM: $6d25ccbc57432887$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM,
    /**
   * Promise implementation.
   * @type {Constructor}
   */ Promise: function() {
        try {
            return window ? window.Promise : null;
        } catch (e) {
            return null;
        }
    }(),
    /**
   * Whether debug messages should be logged.
   * @type {boolean}
   */ debug: false
};
/**
 * @return {number} A unique ID (not universally unique)
 */ var $6d25ccbc57432887$var$generateId = function() {
    var id = 0;
    return function() {
        return ++id;
    };
}();
/**
 * Logs a message.
 * @param {...*} args One or more items to log
 */ var $6d25ccbc57432887$var$log = function log() {
    if ($6d25ccbc57432887$var$Penpal.debug) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        (_console = console).log.apply(_console, [
            "[Penpal]"
        ].concat(args)); // eslint-disable-line no-console
    }
};
/**
 * Converts a URL into an origin.
 * @param {string} url
 * @return {string} The URL's origin
 */ var $6d25ccbc57432887$var$getOriginFromUrl = function getOriginFromUrl(url) {
    var location = document.location;
    var regexResult = $6d25ccbc57432887$var$URL_REGEX.exec(url);
    var protocol;
    var hostname;
    var port;
    if (regexResult) {
        // It's an absolute URL. Use the parsed info.
        // regexResult[1] will be undefined if the URL starts with //
        protocol = regexResult[1] ? regexResult[1] : location.protocol;
        hostname = regexResult[2];
        port = regexResult[4];
    } else {
        // It's a relative path. Use the current location's info.
        protocol = location.protocol;
        hostname = location.hostname;
        port = location.port;
    } // If the protocol is file, the origin is "null"
    // The origin of a document with file protocol is an opaque origin
    // and its serialization "null" [1]
    // [1] https://html.spec.whatwg.org/multipage/origin.html#origin
    if (protocol === "file:") return "null";
     // If the port is the default for the protocol, we don't want to add it to the origin string
    // or it won't match the message's event.origin.
    var portSuffix = port && port !== $6d25ccbc57432887$var$DEFAULT_PORTS[protocol] ? ":".concat(port) : "";
    return "".concat(protocol, "//").concat(hostname).concat(portSuffix);
};
/**
 * A simplified promise class only used internally for when destroy() is called. This is
 * used to destroy connections synchronously while promises typically resolve asynchronously.
 *
 * @param {Function} executor
 * @returns {Object}
 * @constructor
 */ var $6d25ccbc57432887$var$DestructionPromise = function DestructionPromise(executor) {
    var handlers = [];
    executor(function() {
        handlers.forEach(function(handler) {
            handler();
        });
    });
    return {
        then: function then(handler) {
            handlers.push(handler);
        }
    };
};
/**
 * Converts an error object into a plain object.
 * @param {Error} Error object.
 * @returns {Object}
 */ var $6d25ccbc57432887$var$serializeError = function serializeError(_ref) {
    var name = _ref.name, message = _ref.message, stack = _ref.stack;
    return {
        name: name,
        message: message,
        stack: stack
    };
};
/**
 * Converts a plain object into an error object.
 * @param {Object} Object with error properties.
 * @returns {Error}
 */ var $6d25ccbc57432887$var$deserializeError = function deserializeError(obj) {
    var deserializedError = new Error();
    Object.keys(obj).forEach(function(key) {
        return deserializedError[key] = obj[key];
    });
    return deserializedError;
};
/**
 * Augments an object with methods that match those defined by the remote. When these methods are
 * called, a "call" message will be sent to the remote, the remote's corresponding method will be
 * executed, and the method's return value will be returned via a message.
 * @param {Object} callSender Sender object that should be augmented with methods.
 * @param {Object} info Information about the local and remote windows.
 * @param {Array} methodNames Names of methods available to be called on the remote.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Object} The call sender object with methods that may be called.
 */ var $6d25ccbc57432887$var$connectCallSender = function connectCallSender(callSender, info, methodNames, destroy, destructionPromise) {
    var localName = info.localName, local = info.local, remote = info.remote, remoteOrigin = info.remoteOrigin;
    var destroyed = false;
    $6d25ccbc57432887$var$log("".concat(localName, ": Connecting call sender"));
    var createMethodProxy = function createMethodProxy(methodName) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            $6d25ccbc57432887$var$log("".concat(localName, ": Sending ").concat(methodName, "() call")); // This handles the case where the iframe has been removed from the DOM
            // (and therefore its window closed), the consumer has not yet
            // called destroy(), and the user calls a method exposed by
            // the remote. We detect the iframe has been removed and force
            // a destroy() immediately so that the consumer sees the error saying
            // the connection has been destroyed.
            if (remote.closed) destroy();
            if (destroyed) {
                var error = new Error("Unable to send ".concat(methodName, "() call due ") + "to destroyed connection");
                error.code = $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED;
                throw error;
            }
            return new $6d25ccbc57432887$var$Penpal.Promise(function(resolve, reject) {
                var id = $6d25ccbc57432887$var$generateId();
                var handleMessageEvent = function handleMessageEvent(event) {
                    if (event.source === remote && event.origin === remoteOrigin && event.data.penpal === $6d25ccbc57432887$var$REPLY && event.data.id === id) {
                        $6d25ccbc57432887$var$log("".concat(localName, ": Received ").concat(methodName, "() reply"));
                        local.removeEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
                        var returnValue = event.data.returnValue;
                        if (event.data.returnValueIsError) returnValue = $6d25ccbc57432887$var$deserializeError(returnValue);
                        (event.data.resolution === $6d25ccbc57432887$var$FULFILLED ? resolve : reject)(returnValue);
                    }
                };
                local.addEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
                remote.postMessage({
                    penpal: $6d25ccbc57432887$var$CALL,
                    id: id,
                    methodName: methodName,
                    args: args
                }, remoteOrigin);
            });
        };
    };
    destructionPromise.then(function() {
        destroyed = true;
    });
    methodNames.reduce(function(api, methodName) {
        api[methodName] = createMethodProxy(methodName);
        return api;
    }, callSender);
};
/**
 * Listens for "call" messages coming from the remote, executes the corresponding method, and
 * responds with the return value.
 * @param {Object} info Information about the local and remote windows.
 * @param {Object} methods The keys are the names of the methods that can be called by the remote
 * while the values are the method functions.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Function} A function that may be called to disconnect the receiver.
 */ var $6d25ccbc57432887$var$connectCallReceiver = function connectCallReceiver(info, methods, destructionPromise) {
    var localName = info.localName, local = info.local, remote = info.remote, remoteOrigin = info.remoteOrigin;
    var destroyed = false;
    $6d25ccbc57432887$var$log("".concat(localName, ": Connecting call receiver"));
    var handleMessageEvent = function handleMessageEvent(event) {
        if (event.source === remote && event.origin === remoteOrigin && event.data.penpal === $6d25ccbc57432887$var$CALL) {
            var _event$data = event.data, methodName = _event$data.methodName, args = _event$data.args, id = _event$data.id;
            $6d25ccbc57432887$var$log("".concat(localName, ": Received ").concat(methodName, "() call"));
            if (methodName in methods) {
                var createPromiseHandler = function createPromiseHandler(resolution) {
                    return function(returnValue) {
                        $6d25ccbc57432887$var$log("".concat(localName, ": Sending ").concat(methodName, "() reply"));
                        if (destroyed) {
                            // It's possible to throw an error here, but it would need to be thrown asynchronously
                            // and would only be catchable using window.onerror. This is because the consumer
                            // is merely returning a value from their method and not calling any function
                            // that they could wrap in a try-catch. Even if the consumer were to catch the error,
                            // the value of doing so is questionable. Instead, we'll just log a message.
                            $6d25ccbc57432887$var$log("".concat(localName, ": Unable to send ").concat(methodName, "() reply due to destroyed connection"));
                            return;
                        }
                        var message = {
                            penpal: $6d25ccbc57432887$var$REPLY,
                            id: id,
                            resolution: resolution,
                            returnValue: returnValue
                        };
                        if (resolution === $6d25ccbc57432887$var$REJECTED && returnValue instanceof Error) {
                            message.returnValue = $6d25ccbc57432887$var$serializeError(returnValue);
                            message.returnValueIsError = true;
                        }
                        try {
                            remote.postMessage(message, remoteOrigin);
                        } catch (err) {
                            // If a consumer attempts to send an object that's not cloneable (e.g., window),
                            // we want to ensure the receiver's promise gets rejected.
                            if (err.name === $6d25ccbc57432887$var$DATA_CLONE_ERROR) remote.postMessage({
                                penpal: $6d25ccbc57432887$var$REPLY,
                                id: id,
                                resolution: $6d25ccbc57432887$var$REJECTED,
                                returnValue: $6d25ccbc57432887$var$serializeError(err),
                                returnValueIsError: true
                            }, remoteOrigin);
                            throw err;
                        }
                    };
                };
                new $6d25ccbc57432887$var$Penpal.Promise(function(resolve) {
                    return resolve(methods[methodName].apply(methods, args));
                }).then(createPromiseHandler($6d25ccbc57432887$var$FULFILLED), createPromiseHandler($6d25ccbc57432887$var$REJECTED));
            }
        }
    };
    local.addEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
    destructionPromise.then(function() {
        destroyed = true;
        local.removeEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
    });
};
/**
 * @typedef {Object} Child
 * @property {Promise} promise A promise which will be resolved once a connection has
 * been established.
 * @property {HTMLIframeElement} iframe The created iframe element.
 * @property {Function} destroy A method that, when called, will remove the iframe element from
 * the DOM and clean up event listeners.
 */ /**
 * Creates an iframe, loads a webpage into the URL, and attempts to establish communication with
 * the iframe.
 * @param {Object} options
 * @param {string} options.url The URL of the webpage that should be loaded into the created iframe.
 * @param {HTMLElement} [options.appendTo] The container to which the iframe should be appended.
 * @param {Object} [options.methods={}] Methods that may be called by the iframe.
 * @param {Number} [options.timeout] The amount of time, in milliseconds, Penpal should wait
 * for the child to respond before rejecting the connection promise.
 * @return {Child}
 */ $6d25ccbc57432887$var$Penpal.connectToChild = function(_ref2) {
    var url = _ref2.url, appendTo = _ref2.appendTo, iframe = _ref2.iframe, _ref2$methods = _ref2.methods, methods = _ref2$methods === void 0 ? {} : _ref2$methods, timeout = _ref2.timeout;
    if (iframe && iframe.parentNode) {
        var error = new Error("connectToChild() must not be called with an iframe already attached to DOM");
        error.code = $6d25ccbc57432887$var$ERR_IFRAME_ALREADY_ATTACHED_TO_DOM;
        throw error;
    }
    var destroy;
    var connectionDestructionPromise = new $6d25ccbc57432887$var$DestructionPromise(function(resolveConnectionDestructionPromise) {
        destroy = resolveConnectionDestructionPromise;
    });
    var parent = window;
    iframe = iframe || document.createElement("iframe");
    iframe.src = url;
    var childOrigin = $6d25ccbc57432887$var$getOriginFromUrl(url);
    var promise = new $6d25ccbc57432887$var$Penpal.Promise(function(resolveConnectionPromise, reject) {
        var connectionTimeoutId;
        if (timeout !== undefined) connectionTimeoutId = setTimeout(function() {
            var error = new Error("Connection to child timed out after ".concat(timeout, "ms"));
            error.code = $6d25ccbc57432887$var$ERR_CONNECTION_TIMEOUT;
            reject(error);
            destroy();
        }, timeout);
         // We resolve the promise with the call sender. If the child reconnects (for example, after
        // refreshing or navigating to another page that uses Penpal, we'll update the call sender
        // with methods that match the latest provided by the child.
        var callSender = {};
        var receiverMethodNames;
        var destroyCallReceiver;
        var handleMessage = function handleMessage(event) {
            var child = iframe.contentWindow;
            if (event.source === child && event.origin === childOrigin && event.data.penpal === $6d25ccbc57432887$var$HANDSHAKE) {
                $6d25ccbc57432887$var$log("Parent: Received handshake, sending reply"); // If event.origin is "null", the remote protocol is file:
                // and we must post messages with "*" as targetOrigin [1]
                // [1] https://developer.mozilla.org/fr/docs/Web/API/Window/postMessage#Utiliser_window.postMessage_dans_les_extensions
                var remoteOrigin = event.origin === "null" ? "*" : event.origin;
                event.source.postMessage({
                    penpal: $6d25ccbc57432887$var$HANDSHAKE_REPLY,
                    methodNames: Object.keys(methods)
                }, remoteOrigin);
                var info = {
                    localName: "Parent",
                    local: parent,
                    remote: child,
                    remoteOrigin: remoteOrigin
                }; // If the child reconnected, we need to destroy the previous call receiver before setting
                // up a new one.
                if (destroyCallReceiver) destroyCallReceiver();
                 // When this promise is resolved, it will destroy the call receiver (stop listening to
                // method calls from the child) and delete its methods off the call sender.
                var callReceiverDestructionPromise = new $6d25ccbc57432887$var$DestructionPromise(function(resolveCallReceiverDestructionPromise) {
                    connectionDestructionPromise.then(resolveCallReceiverDestructionPromise);
                    destroyCallReceiver = resolveCallReceiverDestructionPromise;
                });
                $6d25ccbc57432887$var$connectCallReceiver(info, methods, callReceiverDestructionPromise); // If the child reconnected, we need to remove the methods from the previous call receiver
                // off the sender.
                if (receiverMethodNames) receiverMethodNames.forEach(function(receiverMethodName) {
                    delete callSender[receiverMethodName];
                });
                receiverMethodNames = event.data.methodNames;
                $6d25ccbc57432887$var$connectCallSender(callSender, info, receiverMethodNames, destroy, connectionDestructionPromise);
                clearTimeout(connectionTimeoutId);
                resolveConnectionPromise(callSender);
            }
        };
        parent.addEventListener($6d25ccbc57432887$var$MESSAGE, handleMessage);
        $6d25ccbc57432887$var$log("Parent: Loading iframe");
        (appendTo || document.body).appendChild(iframe); // This is to prevent memory leaks when the iframe is removed
        // from the document and the consumer hasn't called destroy().
        // Without this, event listeners attached to the window would
        // stick around and since the event handlers have a reference
        // to the iframe in their closures, the iframe would stick around
        // too.
        var checkIframeInDocIntervalId = setInterval(function() {
            if (!document.body.contains(iframe)) {
                clearInterval(checkIframeInDocIntervalId);
                destroy();
            }
        }, $6d25ccbc57432887$var$CHECK_IFRAME_IN_DOC_INTERVAL);
        connectionDestructionPromise.then(function() {
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
            parent.removeEventListener($6d25ccbc57432887$var$MESSAGE, handleMessage);
            clearInterval(checkIframeInDocIntervalId);
            var error = new Error("Connection destroyed");
            error.code = $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED;
            reject(error);
        });
    });
    return {
        promise: promise,
        iframe: iframe,
        destroy: destroy
    };
};
/**
 * @typedef {Object} Parent
 * @property {Promise} promise A promise which will be resolved once a connection has
 * been established.
 */ /**
 * Attempts to establish communication with the parent window.
 * @param {Object} options
 * @param {string} [options.parentOrigin=*] Valid parent origin used to restrict communication.
 * @param {Object} [options.methods={}] Methods that may be called by the parent window.
 * @param {Number} [options.timeout] The amount of time, in milliseconds, Penpal should wait
 * for the parent to respond before rejecting the connection promise.
 * @return {Parent}
 */ $6d25ccbc57432887$var$Penpal.connectToParent = function() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$parentOrigin = _ref3.parentOrigin, parentOrigin = _ref3$parentOrigin === void 0 ? "*" : _ref3$parentOrigin, _ref3$methods = _ref3.methods, methods = _ref3$methods === void 0 ? {} : _ref3$methods, timeout = _ref3.timeout;
    if (window === window.top) {
        var error = new Error("connectToParent() must be called within an iframe");
        error.code = $6d25ccbc57432887$var$ERR_NOT_IN_IFRAME;
        throw error;
    }
    var destroy;
    var connectionDestructionPromise = new $6d25ccbc57432887$var$DestructionPromise(function(resolveConnectionDestructionPromise) {
        destroy = resolveConnectionDestructionPromise;
    });
    var child = window;
    var parent = child.parent;
    var promise = new $6d25ccbc57432887$var$Penpal.Promise(function(resolveConnectionPromise, reject) {
        var connectionTimeoutId;
        if (timeout !== undefined) connectionTimeoutId = setTimeout(function() {
            var error = new Error("Connection to parent timed out after ".concat(timeout, "ms"));
            error.code = $6d25ccbc57432887$var$ERR_CONNECTION_TIMEOUT;
            reject(error);
            destroy();
        }, timeout);
        var handleMessageEvent = function handleMessageEvent(event) {
            if ((parentOrigin === "*" || parentOrigin === event.origin) && event.source === parent && event.data.penpal === $6d25ccbc57432887$var$HANDSHAKE_REPLY) {
                $6d25ccbc57432887$var$log("Child: Received handshake reply");
                child.removeEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
                var info = {
                    localName: "Child",
                    local: child,
                    remote: parent,
                    remoteOrigin: event.origin
                };
                var callSender = {};
                $6d25ccbc57432887$var$connectCallReceiver(info, methods, connectionDestructionPromise);
                $6d25ccbc57432887$var$connectCallSender(callSender, info, event.data.methodNames, destroy, connectionDestructionPromise);
                clearTimeout(connectionTimeoutId);
                resolveConnectionPromise(callSender);
            }
        };
        child.addEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
        connectionDestructionPromise.then(function() {
            child.removeEventListener($6d25ccbc57432887$var$MESSAGE, handleMessageEvent);
            var error = new Error("Connection destroyed");
            error.code = $6d25ccbc57432887$var$ERR_CONNECTION_DESTROYED;
            reject(error);
        });
        $6d25ccbc57432887$var$log("Child: Sending handshake");
        parent.postMessage({
            penpal: $6d25ccbc57432887$var$HANDSHAKE,
            methodNames: Object.keys(methods)
        }, parentOrigin);
    });
    return {
        promise: promise,
        destroy: destroy
    };
};
var $6d25ccbc57432887$var$_default = $6d25ccbc57432887$var$Penpal;
module.exports.default = $6d25ccbc57432887$var$_default;

});

parcelRegister("j9Ew9", function(module, exports) {

$parcel$export(module.exports, "urlToObject", function () { return $1ddaaaf90b7fbd6a$export$1f60e0374070c5ff; });
$parcel$export(module.exports, "createNewPageView", function () { return $1ddaaaf90b7fbd6a$export$caa72796e9382bc8; });
$parcel$export(module.exports, "getPageViewUserAction", function () { return $1ddaaaf90b7fbd6a$export$690e4722e6c16aff; });
$parcel$export(module.exports, "getGa4ClientId", function () { return $1ddaaaf90b7fbd6a$export$cc89c6436c31943a; });

var $hrWNq = parcelRequire("hrWNq");
const $1ddaaaf90b7fbd6a$export$1f60e0374070c5ff = (url)=>({
        hash: url.hash,
        host: url.host,
        hostname: url.hostname,
        href: url.href,
        origin: url.origin,
        pathname: url.pathname,
        port: url.port,
        protocol: url.protocol,
        search: url.search
    });
const $1ddaaaf90b7fbd6a$export$caa72796e9382bc8 = (page)=>({
        page: page,
        timeEntered: new Date()
    });
const $1ddaaaf90b7fbd6a$export$690e4722e6c16aff = (pageView)=>({
        type: (0, $hrWNq.UserActionType).PageView,
        timestamp: new Date(),
        data: pageView
    });
function $1ddaaaf90b7fbd6a$export$cc89c6436c31943a(siteSlug) {
    try {
        const clientId = $1ddaaaf90b7fbd6a$export$1675591f96e1f90f(siteSlug);
        if (clientId) return clientId;
        if (window.gaGlobal && typeof window.gaGlobal === "object") {
            const id = window.gaGlobal.vid || "";
            if (id) {
                $1ddaaaf90b7fbd6a$export$d09d3d5fa3530593(siteSlug, id);
                return id;
            } else {
                console.warn("[TOMIS ChatBot] Unable to find GA4 Client ID");
                return "";
            }
        } else {
            console.warn("[TOMIS ChatBot] Unable to find GA4 Client ID");
            return "";
        }
    } catch (error) {
        console.warn("[TOMIS ChatBot] Error getting GA4 Client ID: ", error);
        return "";
    }
}
const $1ddaaaf90b7fbd6a$export$1675591f96e1f90f = (site)=>{
    const ga4ClientIdKey = `${site}_ga4ClientId`;
    return window.sessionStorage.getItem(ga4ClientIdKey) || "";
};
const $1ddaaaf90b7fbd6a$export$d09d3d5fa3530593 = (site, clientId)=>{
    const ga4ClientIdKey = `${site}_ga4ClientId`;
    window.sessionStorage.setItem(ga4ClientIdKey, clientId);
};

});
parcelRegister("hrWNq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DialogflowActions = module.exports.DialogflowEvents = module.exports.UserActionType = module.exports.MessageType = module.exports.BotFeatures = module.exports.ConversationTags = module.exports.InboxWebhookActions = module.exports.InboxIntegration = module.exports.CustomerChannel = module.exports.InboxLiveAgent = module.exports.InboxNotificationSettings = module.exports.TranscriptTag = module.exports.ReservationSystem = module.exports.CollectionName = module.exports.AmplitudeEventName = module.exports.CloudFunction = void 0;
/**
 * Cloud Function Names
 */ /** TOMIS Cloud function names */ var $cb4290f8f19a1864$var$CloudFunction;
(function(CloudFunction) {
    CloudFunction["Api"] = "api";
    CloudFunction["ArchiveConversations"] = "archiveConversations";
    CloudFunction["AutoCloseInboxConversations"] = "autoCloseInboxConversations";
    CloudFunction["Dialogflow"] = "dialogflow";
    CloudFunction["InboxNotifications"] = "inboxNotifications";
    CloudFunction["LocalDevInboxNotifications"] = "localDevInboxNotifications";
    CloudFunction["NewCustomerMessage"] = "newCustomerMessage";
    CloudFunction["OnCreateDialogflowFulfillment"] = "onCreateDialogflowFulfillment";
    CloudFunction["OnCreateInboxMessage"] = "onCreateInboxMessage";
    CloudFunction["OnUpdateInboxConversation"] = "onUpdateInboxConversation";
    CloudFunction["Tomis"] = "tomis";
})($cb4290f8f19a1864$var$CloudFunction = module.exports.CloudFunction || (module.exports.CloudFunction = {}));
/**
 * Amplitude
 */ var $cb4290f8f19a1864$var$AmplitudeEventName;
(function(AmplitudeEventName) {
    AmplitudeEventName["PageView"] = "page_view";
    AmplitudeEventName["ChatMessageSent"] = "chat_message_sent";
    AmplitudeEventName["ChatMessageReceived"] = "chat_message_received";
    AmplitudeEventName["ChatWindowOpened"] = "chat_window_opened";
    AmplitudeEventName["ChatWindowClosed"] = "chat_window_closed";
    AmplitudeEventName["ChatMessageWebsiteLinkClicked"] = "chat_message_website_link_clicked";
    AmplitudeEventName["ChatMessagePhoneNumberClicked"] = "chat_message_phone_number_clicked";
    AmplitudeEventName["ChatMessageEmailClicked"] = "chat_message_email_clicked";
    AmplitudeEventName["ChatTomisLinkClicked"] = "chat_tomis_link_clicked";
})($cb4290f8f19a1864$var$AmplitudeEventName = module.exports.AmplitudeEventName || (module.exports.AmplitudeEventName = {}));
//
// Collections
//
/** Collection Names in Firebase */ var $cb4290f8f19a1864$var$CollectionName;
(function(CollectionName) {
    CollectionName["TwilioApiConfigs"] = "TwilioApiConfigs";
    CollectionName["UserDetails"] = "UserDetails";
    CollectionName["WebSessions"] = "WebSessions";
    CollectionName["UserActions"] = "UserActions";
    CollectionName["Sites"] = "Sites";
    CollectionName["Conversations"] = "Conversations";
    CollectionName["InboxConversations"] = "InboxConversations";
    CollectionName["Messages"] = "Messages";
    CollectionName["LiveAgents"] = "LiveAgents";
    CollectionName["Leads"] = "Leads";
    CollectionName["TomisUsers"] = "TomisUsers";
    CollectionName["MobileNotifications"] = "MobileNotifications";
    CollectionName["BrowserNotifications"] = "BrowserNotifications";
    CollectionName["ExpoPushReceipts"] = "ExpoPushReceipts";
    CollectionName["ExpoPushTickets"] = "ExpoPushTickets";
    CollectionName["AutomatedTripCommunications"] = "AutomatedTripCommunications";
    CollectionName["Reminders"] = "Reminders";
    CollectionName["SMS"] = "sms";
    CollectionName["Email"] = "email";
    CollectionName["API"] = "API";
    /** TOMIS API keys to be used by external integrations (e.g. PhoneTreeSMS) */ CollectionName["TomisApiConfigs"] = "TomisApiConfigs";
    CollectionName["InboxSettings"] = "InboxSettings";
    /** Dialogflow integrations such as Voiceflow knowledge base */ CollectionName["DialogflowFulfillments"] = "DialogflowFulfillments";
    /** Encrypted API keys for Voiceflow & other external integrations */ CollectionName["ExternalApiConfigs"] = "ExternalApiConfigs";
})($cb4290f8f19a1864$var$CollectionName = module.exports.CollectionName || (module.exports.CollectionName = {}));
/** TOMIS Reservation System Partners */ var $cb4290f8f19a1864$var$ReservationSystem;
(function(ReservationSystem) {
    ReservationSystem["XOLA"] = "XOLA";
    ReservationSystem["Rezdy"] = "Rezdy";
    ReservationSystem["Peek"] = "Peek";
    ReservationSystem["Singenuity"] = "Singenuity";
    ReservationSystem["Fareharbor"] = "Fareharbor";
    ReservationSystem["Other"] = "";
    ReservationSystem["Flybook"] = "Flybook";
    ReservationSystem["TourCMS"] = "TourCMS";
    ReservationSystem["Zaui"] = "Zaui";
    ReservationSystem["Ventrata"] = "Ventrata";
    ReservationSystem["Checkfront"] = "Checkfront";
    ReservationSystem["Bokun"] = "Bokun";
    ReservationSystem["AdventureOffice"] = "Adventure Office";
    ReservationSystem["Arctic"] = "Arctic";
    ReservationSystem["Origin"] = "Origin";
    ReservationSystem["Anchor"] = "Anchor";
})($cb4290f8f19a1864$var$ReservationSystem = module.exports.ReservationSystem || (module.exports.ReservationSystem = {}));
/** Customer-facing Voiceflow Transcript tags that are used for reporting purposes.
 *
 * Will allow TOMIS to add additional tags as needed, but we
 * have standardized a few that are necessary for reporting.
 */ var $cb4290f8f19a1864$var$TranscriptTag;
(function(TranscriptTag) {
    /** User requested to speak with a human. Not programmatically triggered, instead
     * usually controlled on client-by-client basis via Voiceflow canvas */ TranscriptTag["Human"] = "Human";
    /** User starts check availability flow by triggering check_availability intent  */ TranscriptTag["CheckAvailabilityStart"] = "check_availability_start";
    /** Customer completed all necessary fields and searched inside chat widget */ TranscriptTag["CheckAvailabilitySearch"] = "check_availability_search";
    /** Marked as reviewed via Voiceflow interface or TOMIS */ TranscriptTag["Reviewed"] = "system.reviewed";
    /** Marked as "positive" result */ TranscriptTag["Positive"] = "positive";
    /** Marked as "negative" result */ TranscriptTag["Negative"] = "negative";
    /** Usually applied to conversations started on app.tomis.tech,
     * or the hosted chat widget chat.tomis.tech */ TranscriptTag["Testing"] = "testing";
})($cb4290f8f19a1864$var$TranscriptTag = module.exports.TranscriptTag || (module.exports.TranscriptTag = {}));
/** All Inbox Notifications will be on by default.
 * All settings are user-specific. No company-wide settings!
 * ---
 * When building this interface, I closely followed the format of
 * HubSpot notifications. I think this will give us the most
 * flexibility going forward when we decide to add notifications
 * for additional actions such as mentioning a teammate.  */ class $cb4290f8f19a1864$var$InboxNotificationSettings {
    /** @param enabled Default `on` or `off` for all notifications */ constructor(enabled){
        this.desktop = {
            actions: {
                assigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                newUnassigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                reply: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                }
            },
            sounds: enabled
        };
        this.email = {
            actions: {
                assigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                newUnassigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                reply: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                }
            }
        };
        this.mobile = {
            actions: {
                assigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                newUnassigned: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                },
                reply: {
                    channels: [
                        "facebookMessenger",
                        "form",
                        "instagramMessenger",
                        "phone",
                        "webchat",
                        "whatsApp"
                    ],
                    enabled: enabled
                }
            }
        };
    }
}
module.exports.InboxNotificationSettings = $cb4290f8f19a1864$var$InboxNotificationSettings;
/** TOMIS employee or agent associated with a Site.
 * Includes fields that are relevant for TOMIS Unified Inbox.
 * ---
 * LiveAgent is a collection on the Firebase Site. Used primarily
 * for Inbox Notifications. Should be created when user logs
 * into a particular site for the first time on desktop. */ class $cb4290f8f19a1864$var$InboxLiveAgent {
    /** TOMIS employee or agent associated with a Site.
     * Includes fields that are relevant for TOMIS Unified Inbox.
     * ---
     * LiveAgent is a collection on the Firebase Site. Used primarily
     * for Inbox Notifications. Should be created when user logs
     * into a particular site for the first time on desktop.
     * @param id TOMIS User ID
     * @param name TOMIS User first_name */ constructor(id, name){
        this.displayName = name;
        this.fcmTokens = [];
        this.tomisId = id;
        this.mostRecentActivity = new Date();
        /** All notifications are on by default! */ this.inboxNotificationsSettings = new $cb4290f8f19a1864$var$InboxNotificationSettings(true);
    }
}
module.exports.InboxLiveAgent = $cb4290f8f19a1864$var$InboxLiveAgent;
/** Possible Customer Channels to reach TOMIS.
 * We should try to deprecate Call and SMS in
 * favor of "Phone" */ var $cb4290f8f19a1864$var$CustomerChannel;
(function(CustomerChannel) {
    CustomerChannel["SMS"] = "sms";
    CustomerChannel["WebsiteChatbot"] = "websiteChatbot";
    CustomerChannel["FacebookMessenger"] = "facebookMessenger";
    CustomerChannel["Unknown"] = "unknown";
    CustomerChannel["Call"] = "call";
    CustomerChannel["WhatsApp"] = "whatsApp";
    CustomerChannel["Phone"] = "phone";
    CustomerChannel["Instagram"] = "instagramMessenger";
})($cb4290f8f19a1864$var$CustomerChannel = module.exports.CustomerChannel || (module.exports.CustomerChannel = {}));
/** External integrations that are supported by the TOMIS Inbox.
 *
 * Integration names will be included in InboxConversation document IDs,
 * which shows in the Inbox URL. For that reason, don't include "dialogflow"
 * or "voiceflow" in the name.
 *
 * We may decide to add external integrations for other channels in the future.
 */ var $cb4290f8f19a1864$var$InboxIntegration;
(function(InboxIntegration) {
    InboxIntegration["DIALOGFLOW_CHATBOT"] = "tomis-v1";
    InboxIntegration["VOICEFLOW_CHATBOT"] = "tomis-v2";
})($cb4290f8f19a1864$var$InboxIntegration = module.exports.InboxIntegration || (module.exports.InboxIntegration = {}));
/** Webhook actions available for external integrations to subscribe to */ var $cb4290f8f19a1864$var$InboxWebhookActions;
(function(InboxWebhookActions) {
    /** InboxConversation created */ InboxWebhookActions["CONVERSATION_CREATED"] = "conversation_created";
    /** `assignedAgentId` has been updated in any way. This includes
     * when a user accepts a conversation, assigns to another user,
     * or unassign the conversation. */ InboxWebhookActions["CONVERSATION_ASSIGNED"] = "conversation_assigned";
    /** `status` field has been updated (i.e. opens or closes conversation)  */ InboxWebhookActions["CONVERSATION_STATUS"] = "conversation_status";
    /** An outgoing message was sent from TOMIS Inbox. Does NOT include internal comments (system). Also does not include incoming messages */ InboxWebhookActions["CONVERSATION_MESSAGE_SENT"] = "conversation_message_sent";
    /** TODO: implementation requires adding a new field on the InboxConversation document to track when a user is typing.
     * One common approach in React is to use a `onChange` event handler on the input field, and then set a `isTyping` flag to `true` when the user is typing.
     * Then, we can use a `setTimeout` to set `isTyping` to `false` after X seconds. This will prevent us from sending a `conversation_user_typing` event every time a user types a letter.
     *
     * This is a little challenging to implement in webhook fashion b/c we want our clients to receive webhook in the order they were sent.
     * Webhook subscriber probably needs to look at timestamp field to determine if the latest webhook request is the most recent one.
     *
     * Also consider debouncing.
     */ InboxWebhookActions["CONVERSATION_USER_TYPING"] = "conversation_user_typing";
})($cb4290f8f19a1864$var$InboxWebhookActions = module.exports.InboxWebhookActions || (module.exports.InboxWebhookActions = {}));
/** Track frequency of the most popular activities, for reporting purposes.
 *
 * This allows us to add a single field on conversations that we can query against,
 * instead of having a bunch of options fields on the conversation.
 */ var $cb4290f8f19a1864$var$ConversationTags;
(function(ConversationTags) {
    /** Knowledge base intent is matched & webhook triggered.
     * This includes successful and unsuccessful responses. */ ConversationTags["KnowledgeBase"] = "knowledge_base";
    /** Customer completed form to request Webchat */ ConversationTags["RequestWebChat"] = "request_web_chat";
    /** Customer completed form to request SMS Chat */ ConversationTags["RequestSmsChat"] = "request_sms_chat";
    /** Customer triggered `check_availability` intent in Dialogflow.
     * Customer may or may not have provided required parameters. */ ConversationTags["CheckAvailabilityStart"] = "check_availability_start";
    /** Check Availability search is triggered (query Res System API).
     * Only happens after all parameters are provided by customer. */ ConversationTags["CheckAvailabilitySearch"] = "check_availability_search";
    /** Customer clicked on a Quick Reply button */ ConversationTags["ClickQuickReply"] = "click_quick_reply";
    /** Customer opened chat widget. May or may not have sent a message */ ConversationTags["OpenChatWidget"] = "open_chat_widget";
    /** Conversation included at least one fallback message */ ConversationTags["FallbackMessage"] = "fallback_message";
})($cb4290f8f19a1864$var$ConversationTags = module.exports.ConversationTags || (module.exports.ConversationTags = {}));
/** At time of conversation creation, which features did this
 * conversation have access to? */ var $cb4290f8f19a1864$var$BotFeatures;
(function(BotFeatures) {
    BotFeatures["CheckAvailability"] = "check_availability";
    BotFeatures["WebChat"] = "web_chat";
    BotFeatures["SmsChat"] = "sms_chat";
    BotFeatures["KnowledgeBase"] = "knowledge_base";
    BotFeatures["BotIcon"] = "bot_icon";
})($cb4290f8f19a1864$var$BotFeatures = module.exports.BotFeatures || (module.exports.BotFeatures = {}));
var $cb4290f8f19a1864$var$MessageType;
(function(MessageType) {
    MessageType["User"] = "user";
    /** All automated communications + agents */ MessageType["BotAgent"] = "botAgent";
    MessageType["System"] = "system";
    MessageType["UserAction"] = "userAction";
    MessageType["Custom"] = "custom";
})($cb4290f8f19a1864$var$MessageType = module.exports.MessageType || (module.exports.MessageType = {}));
var $cb4290f8f19a1864$var$UserActionType;
(function(UserActionType) {
    UserActionType["PageView"] = "pageView";
    UserActionType["LinkClick"] = "linkClick";
    UserActionType["CheckAvailability"] = "checkAvailability";
    UserActionType["SubmitForm"] = "submitForm";
    UserActionType["PhoneCall"] = "phoneCall";
})($cb4290f8f19a1864$var$UserActionType = module.exports.UserActionType || (module.exports.UserActionType = {}));
/** Dialogflow Event Names */ var $cb4290f8f19a1864$var$DialogflowEvents;
(function(DialogflowEvents) {
    /** Chatbot was stumped a certain amount of times (usually 2 in a row) */ DialogflowEvents["CONSECUTIVE_UNMATCHED_INTENT_LIMIT_REACHED"] = "CONSECUTIVE_UNMATCHED_INTENT_LIMIT_REACHED";
    /** Currently unused, but should be added to "Human" intents */ DialogflowEvents["SPEAK_TO_HUMAN"] = "SPEAK_TO_HUMAN";
    /** Default welcome intent */ DialogflowEvents["WELCOME"] = "WELCOME";
    DialogflowEvents["MISSED_LIVE_CHAT"] = "MISSED_LIVE_CHAT";
    /** Goes with "Live Chat / Text Us" intent */ DialogflowEvents["REQUESTED_LIVE_CHAT"] = "REQUESTED_LIVE_CHAT";
    DialogflowEvents["WELCOME_LIVE_CHAT"] = "WELCOME_LIVE_CHAT";
    DialogflowEvents["WELCOME_SMS_LIVE_CHAT"] = "WELCOME_SMS_LIVE_CHAT";
    /** Followup intent to first knowledge base query,
     * this is used to extend the webhook timeframe */ DialogflowEvents["KNOWLEDGE_BASE_2"] = "KNOWLEDGE_BASE_2";
    /** Knowledge Base intent */ DialogflowEvents["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    /** Triggered when knowledge base is configured & Dialogflow & KB are stumped */ DialogflowEvents["FALLBACK_MESSAGE"] = "FALLBACK_MESSAGE";
    DialogflowEvents["CHECK_AVAILABILITY"] = "CHECK_AVAILABILITY";
    DialogflowEvents["CHECK_AVAILABILITY_SEARCH"] = "CHECK_AVAILABILITY_SEARCH";
    DialogflowEvents["WEBCHAT"] = "WEBCHAT";
    DialogflowEvents["WEBCHAT_REQUEST"] = "WEBCHAT_REQUEST";
    DialogflowEvents["CAPTURE_CUSTOMER_NAME"] = "CAPTURE_CUSTOMER_NAME";
    DialogflowEvents["CAPTURE_CONTACT_PREFERENCE_EMAIL"] = "CAPTURE_CONTACT_PREFERENCE_EMAIL";
    DialogflowEvents["CAPTURE_CONTACT_PREFERENCE_CALL"] = "CAPTURE_CONTACT_PREFERENCE_CALL";
    DialogflowEvents["CAPTURE_CONTACT_PREFERENCE_SMS"] = "CAPTURE_CONTACT_PREFERENCE_SMS";
    DialogflowEvents["CAPTURE_CONTACT_PREFERENCE_NONE"] = "CAPTURE_CONTACT_PREFERENCE_NONE";
    DialogflowEvents["CAPTURE_PHONE_NUMBER_CALL"] = "CAPTURE_PHONE_NUMBER_CALL";
    DialogflowEvents["CAPTURE_PHONE_NUMBER_SMS"] = "CAPTURE_PHONE_NUMBER_SMS";
    DialogflowEvents["CAPTURE_EMAIL_ADDRESS"] = "CAPTURE_EMAIL_ADDRESS";
})($cb4290f8f19a1864$var$DialogflowEvents = module.exports.DialogflowEvents || (module.exports.DialogflowEvents = {}));
/** Dialogflow Actions */ var $cb4290f8f19a1864$var$DialogflowActions;
(function(DialogflowActions) {
    /** Human intent, or Live Chat / Text Us intent */ DialogflowActions["SPEAK_TO_HUMAN"] = "speak_to_human";
    /** Default fallback intent (no knowledge base) */ DialogflowActions["INPUT_UNKNOWN"] = "input.unknown";
    /** This is the Human follow up "yes". User
     * confirms they want to speak to a human. */ DialogflowActions["SHOW_LEAD_FORM"] = "show_lead_form";
    /** Welcome message for Live Chat ONLY bots */ DialogflowActions["WELCOME_LIVE_CHAT"] = "welcome_live_chat";
    /** Welcome message for SMS bots. In SMS only mode */ DialogflowActions["WELCOME_SMS_LIVE_CHAT"] = "welcome_sms_live_chat";
    /** Default welcome intent */ DialogflowActions["WELCOME"] = "input.welcome";
    /** Used for all Knowledge Base intents.
     *
     * When knowledge base is implemented it takes the place of
     * the default fallback intent (and therefore `input.unknown` action) */ DialogflowActions["KNOWLEDGE_BASE"] = "knowledge_base";
    /** Intent to check availability is triggered */ DialogflowActions["CHECK_AVAILABILITY"] = "check_availability";
    /** All Check Availability parameters are collected, search via res system APIs */ DialogflowActions["CHECK_AVAILABILITY_SEARCH"] = "check_availability_search";
    /** Webchat request (customer has provided their name) */ DialogflowActions["WEBCHAT_REQUEST"] = "webchat_request";
    /** Webchat triggered */ DialogflowActions["WEBCHAT"] = "webchat";
})($cb4290f8f19a1864$var$DialogflowActions = module.exports.DialogflowActions || (module.exports.DialogflowActions = {}));

});


parcelRegister("4Hdep", function(module, exports) {

$parcel$export(module.exports, "View", function () { return $5b63a486827a0c7a$export$27a5bd065ad55220; });
$parcel$export(module.exports, "getIsMobile", function () { return $5b63a486827a0c7a$export$2ac00d7098bf223; });
$parcel$export(module.exports, "getIframePosition", function () { return $5b63a486827a0c7a$export$343625ab0a2886d2; });
$parcel$export(module.exports, "getActualSize", function () { return $5b63a486827a0c7a$export$e877cdb491742d02; });

var $2gOxk = parcelRequire("2gOxk");

var $bG9Ei = parcelRequire("bG9Ei");

var $5bhce = parcelRequire("5bhce");
var $5b63a486827a0c7a$export$27a5bd065ad55220;
(function(View) {
    View["ClosedWithoutPreview"] = "ClosedWithoutPreview";
    View["ClosedWithPreview"] = "ClosedWithPreview";
    View["ChatWindowOpen"] = "ChatWindowOpen";
})($5b63a486827a0c7a$export$27a5bd065ad55220 || ($5b63a486827a0c7a$export$27a5bd065ad55220 = {}));
const $5b63a486827a0c7a$export$2ac00d7098bf223 = (width)=>width < 768;
const $5b63a486827a0c7a$export$343625ab0a2886d2 = (view, isMobile, styleOptions = {
    allowFullScreenMobile: false,
    bottom: 0,
    bottomMobile: 0
})=>{
    const { widget: { closedSpace: closedSpace, padding: padding } } = (0, $5bhce.getTheme)(isMobile);
    const { allowFullScreenMobile: allowFullScreenMobile, bottom: bottom, bottomMobile: bottomMobile } = styleOptions;
    const fromBottom = isMobile ? bottomMobile + closedSpace : bottom + closedSpace;
    const mainButtonSpace = (0, $bG9Ei.mainButtonSize) + padding * 2;
    switch(view){
        case "ClosedWithoutPreview":
            return [
                [
                    mainButtonSpace,
                    mainButtonSpace
                ],
                [
                    fromBottom,
                    closedSpace
                ]
            ];
        case "ClosedWithPreview":
            return [
                [
                    isMobile ? "100%" : 400,
                    mainButtonSpace
                ],
                [
                    fromBottom,
                    closedSpace
                ]
            ];
        case "ChatWindowOpen":
            return [
                [
                    isMobile ? "100%" : 400,
                    allowFullScreenMobile && isMobile ? "100%" : "80%"
                ],
                [
                    0,
                    0
                ]
            ];
    }
};
const $5b63a486827a0c7a$export$e877cdb491742d02 = (orig, windowSize)=>{
    if (typeof orig === "string") {
        const int = parseInt(orig, 10);
        if ((0, $2gOxk.default)("%", orig)) return windowSize * int / 100;
        else if ((0, $2gOxk.default)("px", orig)) return int;
    } else if (typeof orig === "number") return orig;
    throw new Error(`must be a number, or a string ending in % or px. received "${orig}"`);
};

});
parcelRegister("2gOxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a7446e38d84cc39$export$2e2bcd8739ae039; });

var $gV4sV = parcelRequire("gV4sV");

var $elXj2 = parcelRequire("elXj2");

var $bOKND = parcelRequire("bOKND");
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $1a7446e38d84cc39$var$endsWith = /*#__PURE__*/ (0, $gV4sV.default)(function(suffix, list) {
    return (0, $elXj2.default)((0, $bOKND.default)(suffix.length, list), suffix);
});
var $1a7446e38d84cc39$export$2e2bcd8739ae039 = $1a7446e38d84cc39$var$endsWith;

});
parcelRegister("gV4sV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5156efa047a2a6b$export$2e2bcd8739ae039; });

var $5hCiX = parcelRequire("5hCiX");

var $g64dR = parcelRequire("g64dR");
function $c5156efa047a2a6b$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $g64dR.default)(a) ? f2 : (0, $5hCiX.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $g64dR.default)(a) && (0, $g64dR.default)(b) ? f2 : (0, $g64dR.default)(a) ? (0, $5hCiX.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $g64dR.default)(b) ? (0, $5hCiX.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("5hCiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8c40d1a291604e$export$2e2bcd8739ae039; });

var $g64dR = parcelRequire("g64dR");
function $3d8c40d1a291604e$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $g64dR.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("g64dR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb807b6667a8c90e$export$2e2bcd8739ae039; });
function $bb807b6667a8c90e$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

});



parcelRegister("elXj2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a73107cdac7456b7$export$2e2bcd8739ae039; });

var $gV4sV = parcelRequire("gV4sV");

var $d6Gcr = parcelRequire("d6Gcr");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $a73107cdac7456b7$var$equals = /*#__PURE__*/ (0, $gV4sV.default)(function equals(a, b) {
    return (0, $d6Gcr.default)(a, b, [], []);
});
var $a73107cdac7456b7$export$2e2bcd8739ae039 = $a73107cdac7456b7$var$equals;

});
parcelRegister("d6Gcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027665730ac31ba3$export$2e2bcd8739ae039; });

var $kXfbD = parcelRequire("kXfbD");

var $jGGvI = parcelRequire("jGGvI");

var $98J6x = parcelRequire("98J6x");

var $l1Ddg = parcelRequire("l1Ddg");

var $1RzVx = parcelRequire("1RzVx");

var $4bxNx = parcelRequire("4bxNx");

var $bJCBC = parcelRequire("bJCBC");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $027665730ac31ba3$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $kXfbD.default)(aIterator);
    var b = (0, $kXfbD.default)(bIterator);
    function eq(_a, _b) {
        return $027665730ac31ba3$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $jGGvI.default)(function(b, aItem) {
        return !(0, $jGGvI.default)(eq, aItem, b);
    }, b, a);
}
function $027665730ac31ba3$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $1RzVx.default)(a, b)) return true;
    var typeA = (0, $bJCBC.default)(a);
    if (typeA !== (0, $bJCBC.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $98J6x.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $1RzVx.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $1RzVx.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $027665730ac31ba3$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $027665730ac31ba3$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $4bxNx.default)(a);
    if (keysA.length !== (0, $4bxNx.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $l1Ddg.default)(key, b) && $027665730ac31ba3$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("kXfbD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f41519119cb149ca$export$2e2bcd8739ae039; });
function $f41519119cb149ca$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("jGGvI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e552ea4752058917$export$2e2bcd8739ae039; });
function $e552ea4752058917$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("98J6x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a77d93cd57eed24$export$2e2bcd8739ae039; });
function $6a77d93cd57eed24$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

});

parcelRegister("l1Ddg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4e81bdc3dc857a5$export$2e2bcd8739ae039; });
function $f4e81bdc3dc857a5$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("1RzVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b69c056b5d4daa$export$2e2bcd8739ae039; });
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $15b69c056b5d4daa$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $15b69c056b5d4daa$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $15b69c056b5d4daa$var$_objectIs;

});

parcelRegister("4bxNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c2681b5fb8e573$export$2e2bcd8739ae039; });

var $5hCiX = parcelRequire("5hCiX");

var $l1Ddg = parcelRequire("l1Ddg");

var $aTuPP = parcelRequire("aTuPP");
// cover IE < 9 keys issues
var $30c2681b5fb8e573$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $30c2681b5fb8e573$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $30c2681b5fb8e573$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $30c2681b5fb8e573$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $30c2681b5fb8e573$var$keys = typeof Object.keys === "function" && !$30c2681b5fb8e573$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $5hCiX.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $5hCiX.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $30c2681b5fb8e573$var$hasArgsEnumBug && (0, $aTuPP.default)(obj);
    for(prop in obj)if ((0, $l1Ddg.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($30c2681b5fb8e573$var$hasEnumBug) {
        nIdx = $30c2681b5fb8e573$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $30c2681b5fb8e573$var$nonEnumerableProps[nIdx];
            if ((0, $l1Ddg.default)(prop, obj) && !$30c2681b5fb8e573$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $30c2681b5fb8e573$export$2e2bcd8739ae039 = $30c2681b5fb8e573$var$keys;

});
parcelRegister("aTuPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee6f59856dd230c$export$2e2bcd8739ae039; });

var $l1Ddg = parcelRequire("l1Ddg");
var $7ee6f59856dd230c$var$toString = Object.prototype.toString;
var $7ee6f59856dd230c$var$_isArguments = /*#__PURE__*/ function() {
    return $7ee6f59856dd230c$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $7ee6f59856dd230c$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $l1Ddg.default)("callee", x);
    };
}();
var $7ee6f59856dd230c$export$2e2bcd8739ae039 = $7ee6f59856dd230c$var$_isArguments;

});


parcelRegister("bJCBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b1d7f3ffb541dc$export$2e2bcd8739ae039; });

var $5hCiX = parcelRequire("5hCiX");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $88b1d7f3ffb541dc$var$type = /*#__PURE__*/ (0, $5hCiX.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $88b1d7f3ffb541dc$export$2e2bcd8739ae039 = $88b1d7f3ffb541dc$var$type;

});



parcelRegister("bOKND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a8aaa04dea9e12$export$2e2bcd8739ae039; });

var $gV4sV = parcelRequire("gV4sV");

var $7QviT = parcelRequire("7QviT");
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $89a8aaa04dea9e12$var$takeLast = /*#__PURE__*/ (0, $gV4sV.default)(function takeLast(n, xs) {
    return (0, $7QviT.default)(n >= 0 ? xs.length - n : 0, xs);
});
var $89a8aaa04dea9e12$export$2e2bcd8739ae039 = $89a8aaa04dea9e12$var$takeLast;

});
parcelRegister("7QviT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b65abfc4179c8c4$export$2e2bcd8739ae039; });

var $gV4sV = parcelRequire("gV4sV");

var $7sxdO = parcelRequire("7sxdO");

var $3qOIs = parcelRequire("3qOIs");

var $8gawu = parcelRequire("8gawu");
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $5b65abfc4179c8c4$var$drop = /*#__PURE__*/ (0, $gV4sV.default)(/*#__PURE__*/ (0, $7sxdO.default)([
    "drop"
], (0, $3qOIs.default), function drop(n, xs) {
    return (0, $8gawu.default)(Math.max(0, n), Infinity, xs);
}));
var $5b65abfc4179c8c4$export$2e2bcd8739ae039 = $5b65abfc4179c8c4$var$drop;

});
parcelRegister("7sxdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56e4eb1483e2a71e$export$2e2bcd8739ae039; });

var $9Om8r = parcelRequire("9Om8r");

var $fuVUq = parcelRequire("fuVUq");
function $56e4eb1483e2a71e$export$2e2bcd8739ae039(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, $9Om8r.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, $fuVUq.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("9Om8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7249f42c32a00d7a$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $7249f42c32a00d7a$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

});

parcelRegister("fuVUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48693e40133896e$export$2e2bcd8739ae039; });
function $b48693e40133896e$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

});


parcelRegister("3qOIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27fb23f79e86cf42$export$2e2bcd8739ae039; });

var $gV4sV = parcelRequire("gV4sV");

var $eYg52 = parcelRequire("eYg52");
var $27fb23f79e86cf42$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $eYg52.default).init;
    XDrop.prototype["@@transducer/result"] = (0, $eYg52.default).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var $27fb23f79e86cf42$var$_xdrop = /*#__PURE__*/ (0, $gV4sV.default)(function _xdrop(n, xf) {
    return new $27fb23f79e86cf42$var$XDrop(n, xf);
});
var $27fb23f79e86cf42$export$2e2bcd8739ae039 = $27fb23f79e86cf42$var$_xdrop;

});
parcelRegister("eYg52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae63247fe86f7b8d$export$2e2bcd8739ae039; });
var $ae63247fe86f7b8d$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

});


parcelRegister("8gawu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6037fb00f115a85c$export$2e2bcd8739ae039; });

var $aRjgH = parcelRequire("aRjgH");

var $8ThqK = parcelRequire("8ThqK");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $6037fb00f115a85c$var$slice = /*#__PURE__*/ (0, $8ThqK.default)(/*#__PURE__*/ (0, $aRjgH.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $6037fb00f115a85c$export$2e2bcd8739ae039 = $6037fb00f115a85c$var$slice;

});
parcelRegister("aRjgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7dcce76e488573$export$2e2bcd8739ae039; });

var $9Om8r = parcelRequire("9Om8r");
function $7e7dcce76e488573$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $9Om8r.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("8ThqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6790fb1c6871c6c4$export$2e2bcd8739ae039; });

var $5hCiX = parcelRequire("5hCiX");

var $gV4sV = parcelRequire("gV4sV");

var $g64dR = parcelRequire("g64dR");
function $6790fb1c6871c6c4$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $g64dR.default)(a) ? f3 : (0, $gV4sV.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $g64dR.default)(a) && (0, $g64dR.default)(b) ? f3 : (0, $g64dR.default)(a) ? (0, $gV4sV.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $g64dR.default)(b) ? (0, $gV4sV.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $5hCiX.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $g64dR.default)(a) && (0, $g64dR.default)(b) && (0, $g64dR.default)(c) ? f3 : (0, $g64dR.default)(a) && (0, $g64dR.default)(b) ? (0, $gV4sV.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $g64dR.default)(a) && (0, $g64dR.default)(c) ? (0, $gV4sV.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $g64dR.default)(b) && (0, $g64dR.default)(c) ? (0, $gV4sV.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $g64dR.default)(a) ? (0, $5hCiX.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $g64dR.default)(b) ? (0, $5hCiX.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $g64dR.default)(c) ? (0, $5hCiX.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});





parcelRegister("5bhce", function(module, exports) {

$parcel$export(module.exports, "getTheme", function () { return $322244c8f288a913$export$89cbf1a0881c8b9c; });
const $322244c8f288a913$export$89cbf1a0881c8b9c = (isMobile, config = {})=>{
    const widget = {
        closedSpace: isMobile ? 0 : 24,
        padding: 10
    };
    const colors = {
        primary: config.primaryColor || "rgb(42, 167, 153)",
        greenBright: "rgb(140, 237, 140)",
        grayLightOutline: "rgb(227, 227, 227)",
        placeholderTextColor: "rgb(173, 173, 173)",
        link: "rgb(0, 161, 214)",
        linkHover: "rgb(0, 107, 143)"
    };
    const shadows = {
        widget: `0px 0px ${widget.padding}px 0px rgba(0,0,0,0.25)`
    };
    return {
        widget: widget,
        colors: colors,
        shadows: shadows
    };
};

});


parcelRegister("8grFr", function(module, exports) {

$parcel$export(module.exports, "toPx", function () { return $e55b1649cf8dfca4$export$6562491d7413c9c9; });
$parcel$export(module.exports, "requireIframe", function () { return $e55b1649cf8dfca4$export$e4d541d6f5f693ed; });
/** Convert a number or string to pixels */ const $e55b1649cf8dfca4$export$6562491d7413c9c9 = (val)=>typeof val === "string" ? val : `${val}px`;
function $e55b1649cf8dfca4$export$e4d541d6f5f693ed() {
    if (window.self === window.top) throw new Error("TOMIS ChatBot must be opened in an iframe");
}

});

parcelRegister("40gi4", function(module, exports) {

$parcel$export(module.exports, "Category", function () { return $c2eb52bdf54331a4$export$3a8840c5b2ecf003; });
$parcel$export(module.exports, "initSentry", function () { return $c2eb52bdf54331a4$export$f5ae3c4820871661; });
$parcel$export(module.exports, "logError", function () { return $c2eb52bdf54331a4$export$58da9968c3170cb1; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $c2eb52bdf54331a4$export$efda9a273d7a036d; });
/** Sentry should only be used inside the iframe.
 * If Sentry is used on the parent window, it may interfere with the parent window's Sentry configuration.
 *
 * In order to use Sentry in the parent window, check out the Sentry docs:
 * <https://docs.sentry.io/platforms/javascript/guides/react/best-practices/browser-extensions/>
 */ 
var $jdjqN = parcelRequire("jdjqN");
var $aYSwx = parcelRequire("aYSwx");
var $5CmDJ = parcelRequire("5CmDJ");
var $cx5HD = parcelRequire("cx5HD");

var $hrWNq = parcelRequire("hrWNq");

var $e3viL = parcelRequire("e3viL");
const $c2eb52bdf54331a4$export$3a8840c5b2ecf003 = {
    [(0, $hrWNq.CloudFunction).NewCustomerMessage]: `functions.${(0, $hrWNq.CloudFunction).NewCustomerMessage}`,
    [(0, $hrWNq.CollectionName).Sites]: `firestore.${(0, $hrWNq.CollectionName).Sites}`,
    [(0, $hrWNq.CollectionName).Conversations]: `firestore.${(0, $hrWNq.CollectionName).Conversations}`,
    [(0, $hrWNq.CollectionName).Messages]: `firestore.${(0, $hrWNq.CollectionName).Messages}`,
    Auth: "firebase.auth",
    IFrame: "iframe",
    Tracking: "tracking",
    CheckAvailability: "check.availability",
    Twilio: "twilio"
};
const $c2eb52bdf54331a4$var$IS_LOCALHOST = window.location.hostname.includes("localhost");
const $c2eb52bdf54331a4$export$6377864d12f7eeb3 = $c2eb52bdf54331a4$var$IS_LOCALHOST || (0, $e3viL.IS_DEV) ? "local" : (0, $e3viL.ENVIRONMENT);
const $c2eb52bdf54331a4$export$f5ae3c4820871661 = ()=>{
    $5CmDJ.init({
        dsn: "https://f22be3ad123b4ba6a402ee8c024970cc@o141882.ingest.us.sentry.io/1406211",
        // if `false`, no events are sent to Sentry
        enabled: true,
        // Which Sentry environment are we in?
        environment: $c2eb52bdf54331a4$export$6377864d12f7eeb3,
        // Additional Sentry features
        integrations: [
            $cx5HD.replayIntegration()
        ],
        // SKD will attempt to print out useful debugging information
        // debug: IS_LOCALHOST,
        release: `tomis-fire-web-client@${(0, $e3viL.VERSION)}`,
        ignoreErrors: [],
        ignoreTransactions: [],
        autoSessionTracking: true,
        sendClientReports: true,
        enableTracing: true,
        // 1.0 recommended in production
        tracesSampleRate: 1.0,
        // This sets the sample rate at 1%
        replaysSessionSampleRate: 0.01,
        // Change the sample rate to 100% when sampling sessions where errors occur.
        replaysOnErrorSampleRate: 1.0
    });
};
const $c2eb52bdf54331a4$var$logBreadcrumb = (breadcrumb)=>{
    if ($c2eb52bdf54331a4$var$IS_LOCALHOST) {
        const method = {
            log: "log",
            info: "log",
            debug: "log",
            warning: "warn",
            error: "error",
            fatal: "error"
        }[breadcrumb.level || "info"];
        console.groupCollapsed(breadcrumb.message);
        Object.keys(breadcrumb).forEach((key)=>{
            console[method](`${key}:`, breadcrumb[key]);
        });
        console.groupEnd();
    }
};
const $c2eb52bdf54331a4$export$58da9968c3170cb1 = (err, breadcrumb)=>{
    if (breadcrumb) $c2eb52bdf54331a4$export$efda9a273d7a036d(breadcrumb);
    if ($c2eb52bdf54331a4$var$IS_LOCALHOST) console.error(err);
    else $aYSwx.captureException(err);
};
const $c2eb52bdf54331a4$export$efda9a273d7a036d = (breadcrumb)=>{
    $c2eb52bdf54331a4$var$logBreadcrumb(breadcrumb);
    $jdjqN.addBreadcrumb(breadcrumb);
};

});
parcelRegister("jdjqN", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $dfce4dd555b48641$export$efda9a273d7a036d; });

var $eN7RA = parcelRequire("eN7RA");
var $iYIMl = parcelRequire("iYIMl");

var $gKECY = parcelRequire("gKECY");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $dfce4dd555b48641$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $dfce4dd555b48641$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $gKECY.getClient)();
    const isolationScope = (0, $gKECY.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $dfce4dd555b48641$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $iYIMl.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $eN7RA.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});
parcelRegister("eN7RA", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $ac4bbdca095e3d14$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $ac4bbdca095e3d14$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $ac4bbdca095e3d14$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $ac4bbdca095e3d14$export$af88d00dbe7f521; });

var $kqDzy = parcelRequire("kqDzy");

var $inoaW = parcelRequire("inoaW");
/** Prefix for logging strings */ const $ac4bbdca095e3d14$var$PREFIX = "Sentry Logger ";
const $ac4bbdca095e3d14$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $ac4bbdca095e3d14$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $ac4bbdca095e3d14$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $inoaW.GLOBAL_OBJ))) return callback();
    const console = (0, $inoaW.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($ac4bbdca095e3d14$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $ac4bbdca095e3d14$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $ac4bbdca095e3d14$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $kqDzy.DEBUG_BUILD) $ac4bbdca095e3d14$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $ac4bbdca095e3d14$export$cda52e2a8927a2ca(()=>{
                (0, $inoaW.GLOBAL_OBJ).console[name](`${$ac4bbdca095e3d14$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $ac4bbdca095e3d14$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $ac4bbdca095e3d14$export$af88d00dbe7f521 = $ac4bbdca095e3d14$var$makeLogger();

});
parcelRegister("kqDzy", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $edf4eea0719a0fdc$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $edf4eea0719a0fdc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("inoaW", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $d60d20bc60b8a06d$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $d60d20bc60b8a06d$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $d60d20bc60b8a06d$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $d60d20bc60b8a06d$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $d60d20bc60b8a06d$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("iYIMl", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $dd1090be719e8883$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $dd1090be719e8883$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $dd1090be719e8883$export$baf075a948ffc0bf; });

var $inoaW = parcelRequire("inoaW");
const $dd1090be719e8883$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $dd1090be719e8883$export$7740643b9eeaf0c4() {
    return Date.now() / $dd1090be719e8883$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $dd1090be719e8883$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $inoaW.GLOBAL_OBJ);
    if (!performance || !performance.now) return $dd1090be719e8883$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $dd1090be719e8883$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $dd1090be719e8883$export$ee52dced521e3e18 = $dd1090be719e8883$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $dd1090be719e8883$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $dd1090be719e8883$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $inoaW.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $dd1090be719e8883$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $dd1090be719e8883$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $dd1090be719e8883$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $dd1090be719e8883$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("gKECY", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $c32075085f6c66f0$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $c32075085f6c66f0$export$de9862929b76bf57; });
$parcel$export(module.exports, "getCurrentScope", function () { return $c32075085f6c66f0$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $c32075085f6c66f0$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $c32075085f6c66f0$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $c32075085f6c66f0$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $c32075085f6c66f0$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $c32075085f6c66f0$export$6bb76d6eba7e258c; });

var $inoaW = parcelRequire("inoaW");

var $4lZ7h = parcelRequire("4lZ7h");

var $7y29S = parcelRequire("7y29S");

var $1oIMD = parcelRequire("1oIMD");
/** Get the default current scope. */ function $c32075085f6c66f0$export$6f1b9191db9c4d5() {
    return (0, $inoaW.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $1oIMD.Scope)());
}
/** Get the default isolation scope. */ function $c32075085f6c66f0$export$de9862929b76bf57() {
    return (0, $inoaW.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $1oIMD.Scope)());
}
/**
 * Get the currently active scope.
 */ function $c32075085f6c66f0$export$c7be4b0125a10cba() {
    const carrier = (0, $7y29S.getMainCarrier)();
    const acs = (0, $4lZ7h.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context.
 */ function $c32075085f6c66f0$export$68f3af03034c9e90() {
    const carrier = (0, $7y29S.getMainCarrier)();
    const acs = (0, $4lZ7h.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $c32075085f6c66f0$export$aa55d5ab8e05984f() {
    return (0, $inoaW.getGlobalSingleton)("globalScope", ()=>new (0, $1oIMD.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c32075085f6c66f0$export$ec58d9285c204497(...rest) {
    const carrier = (0, $7y29S.getMainCarrier)();
    const acs = (0, $4lZ7h.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $c32075085f6c66f0$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $7y29S.getMainCarrier)();
    const acs = (0, $4lZ7h.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $c32075085f6c66f0$export$6bb76d6eba7e258c() {
    return $c32075085f6c66f0$export$c7be4b0125a10cba().getClient();
}

});
parcelRegister("4lZ7h", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $32b88803501f9eec$export$f639b0c2752203be; });

var $7y29S = parcelRequire("7y29S");

var $eAy2Q = parcelRequire("eAy2Q");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $32b88803501f9eec$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $7y29S.getMainCarrier)();
    const sentry = (0, $7y29S.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $32b88803501f9eec$export$f639b0c2752203be(carrier) {
    const sentry = (0, $7y29S.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $eAy2Q.getStackAsyncContextStrategy)();
}

});
parcelRegister("7y29S", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $57ed61f2e880ad24$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $57ed61f2e880ad24$export$c8bfa33e4e8ae492; });

var $inoaW = parcelRequire("inoaW");
/**
 * An object that contains a hub and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $57ed61f2e880ad24$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $57ed61f2e880ad24$export$c8bfa33e4e8ae492((0, $inoaW.GLOBAL_OBJ));
    return 0, $inoaW.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $57ed61f2e880ad24$export$c8bfa33e4e8ae492(carrier) {
    if (!carrier.__SENTRY__) carrier.__SENTRY__ = {
        extensions: {}
    };
    return carrier.__SENTRY__;
}

});

parcelRegister("eAy2Q", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $a9eed611e76b9169$export$329d4d4d54e42710; });

var $7cgDk = parcelRequire("7cgDk");

var $gKECY = parcelRequire("gKECY");

var $1oIMD = parcelRequire("1oIMD");

var $7y29S = parcelRequire("7y29S");
/**
 * This is an object that holds a stack of scopes.
 */ class $a9eed611e76b9169$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $1oIMD.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $1oIMD.Scope)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $7cgDk.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $a9eed611e76b9169$var$getAsyncContextStack() {
    const registry = (0, $7y29S.getMainCarrier)();
    // For now we continue to keep this as `hub` on the ACS,
    // as e.g. the Loader Script relies on this.
    // Eventually we may change this if/when we update the loader to not require this field anymore
    // Related, we also write to `hub` in {@link ./../sdk.ts registerClientOnGlobalHub}
    const sentry = (0, $7y29S.getSentryCarrier)(registry);
    if (sentry.hub) return sentry.hub;
    sentry.hub = new $a9eed611e76b9169$export$d36ec451f120cfba((0, $gKECY.getDefaultCurrentScope)(), (0, $gKECY.getDefaultIsolationScope)());
    return sentry.hub;
}
function $a9eed611e76b9169$var$withScope(callback) {
    return $a9eed611e76b9169$var$getAsyncContextStack().withScope(callback);
}
function $a9eed611e76b9169$var$withSetScope(scope, callback) {
    const hub = $a9eed611e76b9169$var$getAsyncContextStack();
    return hub.withScope(()=>{
        hub.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $a9eed611e76b9169$var$withIsolationScope(callback) {
    return $a9eed611e76b9169$var$getAsyncContextStack().withScope(()=>{
        return callback($a9eed611e76b9169$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $a9eed611e76b9169$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $a9eed611e76b9169$var$withIsolationScope,
        withScope: $a9eed611e76b9169$var$withScope,
        withSetScope: $a9eed611e76b9169$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $a9eed611e76b9169$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$a9eed611e76b9169$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$a9eed611e76b9169$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("7cgDk", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $53d68e6cd430a845$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $53d68e6cd430a845$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $53d68e6cd430a845$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $53d68e6cd430a845$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $53d68e6cd430a845$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $53d68e6cd430a845$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $53d68e6cd430a845$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $53d68e6cd430a845$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $53d68e6cd430a845$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $53d68e6cd430a845$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $53d68e6cd430a845$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $53d68e6cd430a845$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $53d68e6cd430a845$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $53d68e6cd430a845$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $53d68e6cd430a845$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $53d68e6cd430a845$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$e6127cc7fe7395c3(wat) {
    switch($53d68e6cd430a845$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $53d68e6cd430a845$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$var$isBuiltin(wat, className) {
    return $53d68e6cd430a845$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$9f9636d330b71954(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$ef9e2056653f0c8e(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$12e869b2a583f783(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$844ec244b1367d54(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$c3825b437cbdea5c(wat) {
    return wat === null || $53d68e6cd430a845$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$53b83ca8eaab0383(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $53d68e6cd430a845$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $53d68e6cd430a845$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$49841c62b9eff15(wat) {
    return $53d68e6cd430a845$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $53d68e6cd430a845$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$bc2894c7158efbac(wat) {
    return $53d68e6cd430a845$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $53d68e6cd430a845$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("1oIMD", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $104ac569f0d8299d$export$775b6bb06e53a214; });

var $iYIMl = parcelRequire("iYIMl");
var $7cgDk = parcelRequire("7cgDk");
var $eN7RA = parcelRequire("eN7RA");
var $ieXhv = parcelRequire("ieXhv");

var $dV569 = parcelRequire("dV569");

var $fi7Ie = parcelRequire("fi7Ie");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $104ac569f0d8299d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $104ac569f0d8299d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $104ac569f0d8299d$var$generatePropagationContext();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $104ac569f0d8299d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $fi7Ie._setSpanForScope)(newScope, (0, $fi7Ie._getSpanForScope)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $dV569.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $104ac569f0d8299d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $7cgDk.isPlainObject)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $fi7Ie._setSpanForScope)(this, undefined);
        this._attachments = [];
        this._propagationContext = $104ac569f0d8299d$var$generatePropagationContext();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $104ac569f0d8299d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $iYIMl.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $fi7Ie._getSpanForScope)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $ieXhv.uuid4)();
        if (!this._client) {
            (0, $eN7RA.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $ieXhv.uuid4)();
        if (!this._client) {
            (0, $eN7RA.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $ieXhv.uuid4)();
        if (!this._client) {
            (0, $eN7RA.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $104ac569f0d8299d$export$775b6bb06e53a214 = $104ac569f0d8299d$var$ScopeClass;
/**
 * Holds additional event information.
 */ function $104ac569f0d8299d$var$generatePropagationContext() {
    return {
        traceId: (0, $ieXhv.uuid4)(),
        spanId: (0, $ieXhv.uuid4)().substring(16)
    };
}

});
parcelRegister("ieXhv", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $d47784d116a5b826$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $d47784d116a5b826$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $d47784d116a5b826$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $d47784d116a5b826$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $d47784d116a5b826$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $d47784d116a5b826$export$3131421a7d01b4fb; });

var $9Nu6W = parcelRequire("9Nu6W");

var $l5pHy = parcelRequire("l5pHy");

var $inoaW = parcelRequire("inoaW");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $d47784d116a5b826$export$19f53698e68b2496() {
    const gbl = (0, $inoaW.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $d47784d116a5b826$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $d47784d116a5b826$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $d47784d116a5b826$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $d47784d116a5b826$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $d47784d116a5b826$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $d47784d116a5b826$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $d47784d116a5b826$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $d47784d116a5b826$export$d364f2020ab30578(input) {
    const match = input.match($d47784d116a5b826$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $d47784d116a5b826$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $l5pHy.snipLine)(line, 0));
    frame.context_line = (0, $l5pHy.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $l5pHy.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $d47784d116a5b826$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $9Nu6W.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $d47784d116a5b826$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("9Nu6W", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $72200c0f2014ee0d$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $72200c0f2014ee0d$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $72200c0f2014ee0d$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $72200c0f2014ee0d$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $72200c0f2014ee0d$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $72200c0f2014ee0d$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $72200c0f2014ee0d$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $72200c0f2014ee0d$export$d25f2688db1bb433; });

var $bwpQP = parcelRequire("bwpQP");

var $kqDzy = parcelRequire("kqDzy");

var $7cgDk = parcelRequire("7cgDk");

var $eN7RA = parcelRequire("eN7RA");

var $l5pHy = parcelRequire("l5pHy");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $72200c0f2014ee0d$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $72200c0f2014ee0d$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $72200c0f2014ee0d$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $kqDzy.DEBUG_BUILD) && (0, $eN7RA.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $72200c0f2014ee0d$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $72200c0f2014ee0d$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $72200c0f2014ee0d$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $72200c0f2014ee0d$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $72200c0f2014ee0d$export$62ff257738bf57f5(value) {
    if ((0, $7cgDk.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$72200c0f2014ee0d$var$getOwnProperties(value)
    };
    else if ((0, $7cgDk.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $72200c0f2014ee0d$var$serializeEventTarget(value.target),
            currentTarget: $72200c0f2014ee0d$var$serializeEventTarget(value.currentTarget),
            ...$72200c0f2014ee0d$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $7cgDk.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $72200c0f2014ee0d$var$serializeEventTarget(target) {
    try {
        return (0, $7cgDk.isElement)(target) ? (0, $bwpQP.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $72200c0f2014ee0d$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $72200c0f2014ee0d$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($72200c0f2014ee0d$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $l5pHy.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $l5pHy.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $72200c0f2014ee0d$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $72200c0f2014ee0d$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $72200c0f2014ee0d$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($72200c0f2014ee0d$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $72200c0f2014ee0d$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($72200c0f2014ee0d$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $72200c0f2014ee0d$var$isPojo(input) {
    if (!(0, $7cgDk.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $72200c0f2014ee0d$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7cgDk.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bwpQP", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $8636bc5b6130bee3$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $8636bc5b6130bee3$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $8636bc5b6130bee3$export$26727cfcc4d7e0fc; });

var $7cgDk = parcelRequire("7cgDk");

var $inoaW = parcelRequire("inoaW");
const $8636bc5b6130bee3$var$WINDOW = (0, $inoaW.GLOBAL_OBJ);
const $8636bc5b6130bee3$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8636bc5b6130bee3$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8636bc5b6130bee3$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8636bc5b6130bee3$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8636bc5b6130bee3$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($8636bc5b6130bee3$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        className = elem.className;
        if (className && (0, $7cgDk.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $8636bc5b6130bee3$export$1cfafeee2987818b() {
    try {
        return $8636bc5b6130bee3$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8636bc5b6130bee3$export$c660c1f3ab49225c(selector) {
    if ($8636bc5b6130bee3$var$WINDOW.document && $8636bc5b6130bee3$var$WINDOW.document.querySelector) return $8636bc5b6130bee3$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8636bc5b6130bee3$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8636bc5b6130bee3$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("l5pHy", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $f59e00659fcfd1e7$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $f59e00659fcfd1e7$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $f59e00659fcfd1e7$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $f59e00659fcfd1e7$export$a7a5ec66062ea5d; });

var $7cgDk = parcelRequire("7cgDk");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f59e00659fcfd1e7$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f59e00659fcfd1e7$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f59e00659fcfd1e7$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $7cgDk.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f59e00659fcfd1e7$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $7cgDk.isString)(value)) return false;
    if ((0, $7cgDk.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $7cgDk.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f59e00659fcfd1e7$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f59e00659fcfd1e7$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("dV569", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $a2248d9eb3065a86$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $a2248d9eb3065a86$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $a2248d9eb3065a86$export$56521d9ba90f62ee; });

var $9Nu6W = parcelRequire("9Nu6W");
var $iYIMl = parcelRequire("iYIMl");
var $ieXhv = parcelRequire("ieXhv");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $a2248d9eb3065a86$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $iYIMl.timestampInSeconds)();
    const session = {
        sid: (0, $ieXhv.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a2248d9eb3065a86$var$sessionToJSON(session)
    };
    if (context) $a2248d9eb3065a86$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $a2248d9eb3065a86$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $iYIMl.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $ieXhv.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $a2248d9eb3065a86$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $a2248d9eb3065a86$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $a2248d9eb3065a86$var$sessionToJSON(session) {
    return (0, $9Nu6W.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("fi7Ie", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $b21e84f85747c24c$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $b21e84f85747c24c$export$91f063ebb8eff307; });

var $9Nu6W = parcelRequire("9Nu6W");
const $b21e84f85747c24c$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $b21e84f85747c24c$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $9Nu6W.addNonEnumerableProperty)(scope, $b21e84f85747c24c$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$b21e84f85747c24c$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $b21e84f85747c24c$export$91f063ebb8eff307(scope) {
    return scope[$b21e84f85747c24c$var$SCOPE_SPAN_FIELD];
}

});






parcelRegister("aYSwx", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $7fe9cd454a9edd24$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureEvent", function () { return $7fe9cd454a9edd24$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $7fe9cd454a9edd24$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTag", function () { return $7fe9cd454a9edd24$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "lastEventId", function () { return $7fe9cd454a9edd24$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "addEventProcessor", function () { return $7fe9cd454a9edd24$export$9aac0b9f77928fbf; });
$parcel$export(module.exports, "startSession", function () { return $7fe9cd454a9edd24$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $7fe9cd454a9edd24$export$667e7b4d445d566b; });

var $inoaW = parcelRequire("inoaW");
var $7cgDk = parcelRequire("7cgDk");
var $eN7RA = parcelRequire("eN7RA");
var $iYIMl = parcelRequire("iYIMl");
var $ieXhv = parcelRequire("ieXhv");

var $bNGm4 = parcelRequire("bNGm4");

var $gKECY = parcelRequire("gKECY");

var $4CAiX = parcelRequire("4CAiX");

var $dV569 = parcelRequire("dV569");

var $bUnIF = parcelRequire("bUnIF");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $7fe9cd454a9edd24$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $gKECY.getCurrentScope)().captureException(exception, (0, $bUnIF.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $7fe9cd454a9edd24$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $gKECY.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $7fe9cd454a9edd24$export$1462b974fdcf6ba2(event, hint) {
    return (0, $gKECY.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7fe9cd454a9edd24$export$2f04de43fe27971a(name, context) {
    (0, $gKECY.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $7fe9cd454a9edd24$export$bb4922da0dd51b92(extras) {
    (0, $gKECY.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $7fe9cd454a9edd24$export$8e8e7789d42ed61d(key, extra) {
    (0, $gKECY.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $7fe9cd454a9edd24$export$74a8fb34822092e6(tags) {
    (0, $gKECY.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $7fe9cd454a9edd24$export$a37d07ee78eb4569(key, value) {
    (0, $gKECY.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $7fe9cd454a9edd24$export$8b6bb3dd62a01be2(user) {
    (0, $gKECY.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $7fe9cd454a9edd24$export$5d4e9fd7fac8e617() {
    return (0, $gKECY.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $7fe9cd454a9edd24$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $gKECY.getCurrentScope)();
    const client = (0, $gKECY.getClient)();
    if (!client) (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $ieXhv.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $7fe9cd454a9edd24$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $7fe9cd454a9edd24$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $iYIMl.timestampInSeconds)();
    function finishCheckIn(status) {
        $7fe9cd454a9edd24$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $iYIMl.timestampInSeconds)() - now
        });
    }
    return (0, $gKECY.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $7cgDk.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, ()=>{
            finishCheckIn("error");
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $7fe9cd454a9edd24$export$4909b86c8034bf73(timeout) {
    const client = (0, $gKECY.getClient)();
    if (client) return client.flush(timeout);
    (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $7fe9cd454a9edd24$export$8360e631d277ea4d(timeout) {
    const client = (0, $gKECY.getClient)();
    if (client) return client.close(timeout);
    (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $7fe9cd454a9edd24$export$3f95c6f800b78024() {
    return !!(0, $gKECY.getClient)();
}
/** If the SDK is initialized & enabled. */ function $7fe9cd454a9edd24$export$3b029eb57ac4d562() {
    const client = (0, $gKECY.getClient)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $7fe9cd454a9edd24$export$9aac0b9f77928fbf(callback) {
    (0, $gKECY.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $7fe9cd454a9edd24$export$c0d84948cecf78d8(context) {
    const client = (0, $gKECY.getClient)();
    const isolationScope = (0, $gKECY.getIsolationScope)();
    const currentScope = (0, $gKECY.getCurrentScope)();
    const { release: release, environment: environment = (0, $bNGm4.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $inoaW.GLOBAL_OBJ).navigator || {};
    const session = (0, $dV569.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $dV569.updateSession)(currentSession, {
        status: "exited"
    });
    $7fe9cd454a9edd24$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $7fe9cd454a9edd24$export$17a5be43989a0bc1() {
    const isolationScope = (0, $gKECY.getIsolationScope)();
    const currentScope = (0, $gKECY.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $dV569.closeSession)(session);
    $7fe9cd454a9edd24$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $7fe9cd454a9edd24$var$_sendSessionUpdate() {
    const isolationScope = (0, $gKECY.getIsolationScope)();
    const currentScope = (0, $gKECY.getCurrentScope)();
    const client = (0, $gKECY.getClient)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $7fe9cd454a9edd24$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $7fe9cd454a9edd24$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $7fe9cd454a9edd24$var$_sendSessionUpdate();
}

});
parcelRegister("bNGm4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $8975201b0b1d2fd3$export$849dbeeeda01ae98; });
const $8975201b0b1d2fd3$export$849dbeeeda01ae98 = "production";

});

parcelRegister("4CAiX", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $35d6df6606055328$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $35d6df6606055328$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("bUnIF", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $8ab752deaa1d39b3$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $8ab752deaa1d39b3$export$76b5f966996d1653; });

var $ieXhv = parcelRequire("ieXhv");
var $iYIMl = parcelRequire("iYIMl");
var $inoaW = parcelRequire("inoaW");
var $32A7B = parcelRequire("32A7B");
var $l5pHy = parcelRequire("l5pHy");

var $bNGm4 = parcelRequire("bNGm4");

var $gKECY = parcelRequire("gKECY");

var $KPGE5 = parcelRequire("KPGE5");

var $1oIMD = parcelRequire("1oIMD");

var $kqm6h = parcelRequire("kqm6h");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $8ab752deaa1d39b3$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $ieXhv.uuid4)(),
        timestamp: event.timestamp || (0, $iYIMl.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $8ab752deaa1d39b3$var$applyClientOptions(prepared, options);
    $8ab752deaa1d39b3$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $8ab752deaa1d39b3$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $8ab752deaa1d39b3$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $ieXhv.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $gKECY.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $kqm6h.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $kqm6h.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $kqm6h.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $KPGE5.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $8ab752deaa1d39b3$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $8ab752deaa1d39b3$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $8ab752deaa1d39b3$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $bNGm4.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $l5pHy.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $l5pHy.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $l5pHy.truncate)(request.url, maxValueLength);
}
const $8ab752deaa1d39b3$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $8ab752deaa1d39b3$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $inoaW.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $8ab752deaa1d39b3$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $8ab752deaa1d39b3$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $8ab752deaa1d39b3$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $8ab752deaa1d39b3$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $8ab752deaa1d39b3$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $32A7B.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $32A7B.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $32A7B.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $32A7B.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $32A7B.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $32A7B.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $8ab752deaa1d39b3$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $1oIMD.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $8ab752deaa1d39b3$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($8ab752deaa1d39b3$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($8ab752deaa1d39b3$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $8ab752deaa1d39b3$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $1oIMD.Scope) || typeof hint === "function";
}
const $8ab752deaa1d39b3$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $8ab752deaa1d39b3$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$8ab752deaa1d39b3$var$captureContextKeys.includes(key));
}

});
parcelRegister("32A7B", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $236d93fabe787922$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $236d93fabe787922$export$23fbbb20bed71033; });

var $7cgDk = parcelRequire("7cgDk");

var $aa5mM = parcelRequire("aa5mM");

var $9Nu6W = parcelRequire("9Nu6W");

var $fW2sf = parcelRequire("fW2sf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $236d93fabe787922$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $236d93fabe787922$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $236d93fabe787922$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $236d93fabe787922$export$a3295358bff77e(object, depth);
    if ($236d93fabe787922$var$jsonSize(normalized) > maxSize) return $236d93fabe787922$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $236d93fabe787922$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $aa5mM.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !Number.isNaN(value)) return value;
    const stringified = $236d93fabe787922$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $236d93fabe787922$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $9Nu6W.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $236d93fabe787922$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $236d93fabe787922$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $7cgDk.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $7cgDk.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $fW2sf.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $236d93fabe787922$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $236d93fabe787922$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $236d93fabe787922$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $236d93fabe787922$var$jsonSize(value) {
    return $236d93fabe787922$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $236d93fabe787922$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("aa5mM", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $765f0032df6b118d$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $765f0032df6b118d$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("fW2sf", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $b99e2d35a42529b3$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $b99e2d35a42529b3$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $b99e2d35a42529b3$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $b99e2d35a42529b3$export$aad197c7121a6651; });
const $b99e2d35a42529b3$var$STACKTRACE_FRAME_LIMIT = 50;
const $b99e2d35a42529b3$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $b99e2d35a42529b3$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b99e2d35a42529b3$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $b99e2d35a42529b3$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $b99e2d35a42529b3$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b99e2d35a42529b3$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b99e2d35a42529b3$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b99e2d35a42529b3$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $b99e2d35a42529b3$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $b99e2d35a42529b3$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $b99e2d35a42529b3$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($b99e2d35a42529b3$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($b99e2d35a42529b3$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $b99e2d35a42529b3$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || $b99e2d35a42529b3$export$27c7e15d453fc0ac
        }));
}
const $b99e2d35a42529b3$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $b99e2d35a42529b3$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $b99e2d35a42529b3$var$defaultFunctionName;
        return fn.name || $b99e2d35a42529b3$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b99e2d35a42529b3$var$defaultFunctionName;
    }
}

});


parcelRegister("KPGE5", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $08cc63ebb27b176f$export$bf2a096c3e883e79; });

var $7cgDk = parcelRequire("7cgDk");
var $eN7RA = parcelRequire("eN7RA");
var $3Yj72 = parcelRequire("3Yj72");

var $4CAiX = parcelRequire("4CAiX");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $08cc63ebb27b176f$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $3Yj72.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $4CAiX.DEBUG_BUILD) && processor.id && result === null && (0, $eN7RA.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $7cgDk.isThenable)(result)) result.then((final)=>$08cc63ebb27b176f$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $08cc63ebb27b176f$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("3Yj72", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $2e45cd09e09e4ee8$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $2e45cd09e09e4ee8$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $2e45cd09e09e4ee8$export$78e43115b553f358; });

var $7cgDk = parcelRequire("7cgDk");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $2e45cd09e09e4ee8$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($2e45cd09e09e4ee8$var$States || ($2e45cd09e09e4ee8$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $2e45cd09e09e4ee8$export$1fda8aa4d135f8aa(value) {
    return new $2e45cd09e09e4ee8$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $2e45cd09e09e4ee8$export$78e43115b553f358(reason) {
    return new $2e45cd09e09e4ee8$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $2e45cd09e09e4ee8$export$6f292d4960313241 {
    constructor(executor){
        $2e45cd09e09e4ee8$export$6f292d4960313241.prototype.__init.call(this);
        $2e45cd09e09e4ee8$export$6f292d4960313241.prototype.__init2.call(this);
        $2e45cd09e09e4ee8$export$6f292d4960313241.prototype.__init3.call(this);
        $2e45cd09e09e4ee8$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $2e45cd09e09e4ee8$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $2e45cd09e09e4ee8$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $2e45cd09e09e4ee8$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($2e45cd09e09e4ee8$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($2e45cd09e09e4ee8$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $2e45cd09e09e4ee8$var$States.PENDING) return;
            if ((0, $7cgDk.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $2e45cd09e09e4ee8$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $2e45cd09e09e4ee8$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $2e45cd09e09e4ee8$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("kqm6h", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $ede76106e80e0fd8$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $ede76106e80e0fd8$export$25ac7e259a513db4; });

var $ieXhv = parcelRequire("ieXhv");
var $9Nu6W = parcelRequire("9Nu6W");

var $7xJOM = parcelRequire("7xJOM");

var $2jO8g = parcelRequire("2jO8g");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ede76106e80e0fd8$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ede76106e80e0fd8$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ede76106e80e0fd8$var$applySpanToEvent(event, span);
    $ede76106e80e0fd8$var$applyFingerprintToEvent(event, fingerprint);
    $ede76106e80e0fd8$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ede76106e80e0fd8$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ede76106e80e0fd8$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $ede76106e80e0fd8$export$b1a120a2871faa46(data, "extra", extra);
    $ede76106e80e0fd8$export$b1a120a2871faa46(data, "tags", tags);
    $ede76106e80e0fd8$export$b1a120a2871faa46(data, "user", user);
    $ede76106e80e0fd8$export$b1a120a2871faa46(data, "contexts", contexts);
    $ede76106e80e0fd8$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ede76106e80e0fd8$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $ede76106e80e0fd8$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $9Nu6W.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $9Nu6W.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $9Nu6W.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $9Nu6W.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $ede76106e80e0fd8$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ede76106e80e0fd8$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $ede76106e80e0fd8$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $2jO8g.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $7xJOM.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $2jO8g.getRootSpan)(span);
    const transactionName = (0, $2jO8g.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ede76106e80e0fd8$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $ieXhv.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("7xJOM", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $57df27f8400db060$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $57df27f8400db060$export$a117f995597e25df; });

var $9Nu6W = parcelRequire("9Nu6W");

var $bNGm4 = parcelRequire("bNGm4");

var $gKECY = parcelRequire("gKECY");

var $f2mxj = parcelRequire("f2mxj");

var $2jO8g = parcelRequire("2jO8g");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $57df27f8400db060$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $57df27f8400db060$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $9Nu6W.addNonEnumerableProperty)(spanWithMaybeDsc, $57df27f8400db060$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $57df27f8400db060$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $9Nu6W.dropUndefinedKeys)({
        environment: options.environment || (0, $bNGm4.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $57df27f8400db060$export$a117f995597e25df(span) {
    const client = (0, $gKECY.getClient)();
    if (!client) return {};
    const dsc = $57df27f8400db060$export$366bad00d6815eed((0, $2jO8g.spanToJSON)(span).trace_id || "", client);
    const rootSpan = (0, $2jO8g.getRootSpan)(span);
    if (!rootSpan) return dsc;
    const frozenDsc = rootSpan[$57df27f8400db060$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    const jsonSpan = (0, $2jO8g.spanToJSON)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $f2mxj.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $f2mxj.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $2jO8g.spanIsSampled)(rootSpan));
    client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("f2mxj", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $af28862d95e5ae2f$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $af28862d95e5ae2f$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $af28862d95e5ae2f$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $af28862d95e5ae2f$export$cca8dd30f57f805e; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $af28862d95e5ae2f$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $af28862d95e5ae2f$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $af28862d95e5ae2f$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $af28862d95e5ae2f$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $af28862d95e5ae2f$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $af28862d95e5ae2f$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $af28862d95e5ae2f$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * The id of the profile that this span occured in.
 */ const $af28862d95e5ae2f$export$1efec95406bbe327 = "sentry.profile_id";
const $af28862d95e5ae2f$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $af28862d95e5ae2f$export$b016f89ac1066ec = "cache.hit";
const $af28862d95e5ae2f$export$3110e4c3f4386399 = "cache.key";
const $af28862d95e5ae2f$export$86be76deee227ff2 = "cache.item_size";

});

parcelRegister("2jO8g", function(module, exports) {

$parcel$export(module.exports, "spanToJSON", function () { return $1b043e56096be529$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $1b043e56096be529$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanIsSampled", function () { return $1b043e56096be529$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "getRootSpan", function () { return $1b043e56096be529$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $1b043e56096be529$export$1be426a8e585c83e; });

var $9Nu6W = parcelRequire("9Nu6W");
var $cjwbc = parcelRequire("cjwbc");
var $6dTkI = parcelRequire("6dTkI");
var $iYIMl = parcelRequire("iYIMl");

var $4lZ7h = parcelRequire("4lZ7h");

var $7y29S = parcelRequire("7y29S");

var $gKECY = parcelRequire("gKECY");

var $FUnYs = parcelRequire("FUnYs");

var $f2mxj = parcelRequire("f2mxj");



var $fi7Ie = parcelRequire("fi7Ie");

var $k7Qhb = parcelRequire("k7Qhb");

var $7xJOM = parcelRequire("7xJOM");
// These are aligned with OpenTelemetry trace flags
const $1b043e56096be529$export$208d5b368507fb8b = 0x0;
const $1b043e56096be529$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $1b043e56096be529$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $1b043e56096be529$export$92d8c23565496537(span);
    return (0, $9Nu6W.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $1b043e56096be529$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $1b043e56096be529$export$92d8c23565496537(span);
    return (0, $9Nu6W.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $1b043e56096be529$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $1b043e56096be529$export$5caecac1caaf3a71(span);
    return (0, $6dTkI.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a baggage header.
 */ function $1b043e56096be529$export$95cf936fdacaff7b(span) {
    const dsc = (0, $7xJOM.getDynamicSamplingContextFromSpan)(span);
    return (0, $cjwbc.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $1b043e56096be529$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $1b043e56096be529$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $1b043e56096be529$var$ensureTimestampInSeconds(input.getTime());
    return (0, $iYIMl.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $1b043e56096be529$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $1b043e56096be529$export$92d8c23565496537(span) {
    if ($1b043e56096be529$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($1b043e56096be529$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $9Nu6W.dropUndefinedKeys)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $1b043e56096be529$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $1b043e56096be529$export$3f7581298f56c6d7(endTime) || undefined,
                status: $1b043e56096be529$export$e238a77ea3a8cd66(status),
                op: attributes[0, $f2mxj.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                origin: attributes[0, $f2mxj.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                _metrics_summary: (0, $FUnYs.getMetricSummaryJsonForSpan)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $1b043e56096be529$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $1b043e56096be529$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $1b043e56096be529$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $1b043e56096be529$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $1b043e56096be529$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $k7Qhb.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $k7Qhb.SPAN_STATUS_OK)) return "ok";
    return status.message || "unknown_error";
}
const $1b043e56096be529$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $1b043e56096be529$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $1b043e56096be529$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$1b043e56096be529$var$ROOT_SPAN_FIELD] || span;
    (0, $9Nu6W.addNonEnumerableProperty)(childSpan, $1b043e56096be529$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$1b043e56096be529$var$CHILD_SPANS_FIELD] && span[$1b043e56096be529$var$CHILD_SPANS_FIELD].size < 1000) span[$1b043e56096be529$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $9Nu6W.addNonEnumerableProperty)(span, $1b043e56096be529$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $1b043e56096be529$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$1b043e56096be529$var$CHILD_SPANS_FIELD]) span[$1b043e56096be529$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $1b043e56096be529$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($1b043e56096be529$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$1b043e56096be529$var$CHILD_SPANS_FIELD] ? Array.from(span[$1b043e56096be529$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $1b043e56096be529$export$c4c6a79b1260ca1b(span) {
    return span[$1b043e56096be529$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $1b043e56096be529$export$1be426a8e585c83e() {
    const carrier = (0, $7y29S.getMainCarrier)();
    const acs = (0, $4lZ7h.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $fi7Ie._getSpanForScope)((0, $gKECY.getCurrentScope)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $1b043e56096be529$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $1b043e56096be529$export$1be426a8e585c83e();
    if (span) (0, $FUnYs.updateMetricSummaryOnSpan)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}

});
parcelRegister("cjwbc", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $8f703894670340dd$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $8f703894670340dd$export$56766feef403f365; });

var $kqDzy = parcelRequire("kqDzy");

var $7cgDk = parcelRequire("7cgDk");

var $eN7RA = parcelRequire("eN7RA");
const $8f703894670340dd$export$9ca9946bd449ac06 = "baggage";
const $8f703894670340dd$export$6e69537d67fa20f = "sentry-";
const $8f703894670340dd$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $8f703894670340dd$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $8f703894670340dd$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $8f703894670340dd$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($8f703894670340dd$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($8f703894670340dd$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $8f703894670340dd$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8f703894670340dd$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8f703894670340dd$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $8f703894670340dd$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $7cgDk.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8f703894670340dd$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    return $8f703894670340dd$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $8f703894670340dd$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $8f703894670340dd$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8f703894670340dd$export$bdd844ddb2def819) {
            (0, $kqDzy.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});

parcelRegister("6dTkI", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $487ee0feedafd92f$export$f35d907436da45cf; });

var $cjwbc = parcelRequire("cjwbc");

var $ieXhv = parcelRequire("ieXhv");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $487ee0feedafd92f$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $487ee0feedafd92f$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($487ee0feedafd92f$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $487ee0feedafd92f$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $487ee0feedafd92f$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $cjwbc.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $ieXhv.uuid4)(),
        spanId: (0, $ieXhv.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $ieXhv.uuid4)(),
        parentSpanId: parentSpanId || (0, $ieXhv.uuid4)().substring(16),
        spanId: (0, $ieXhv.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $487ee0feedafd92f$export$f35d907436da45cf(traceId = (0, $ieXhv.uuid4)(), spanId = (0, $ieXhv.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});

parcelRegister("FUnYs", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $07df9178a3d19def$export$2e7205e45c58797d; });
$parcel$export(module.exports, "updateMetricSummaryOnSpan", function () { return $07df9178a3d19def$export$102c7b059b14a4a; });

var $9Nu6W = parcelRequire("9Nu6W");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $07df9178a3d19def$var$SPAN_METRIC_SUMMARY;
function $07df9178a3d19def$var$getMetricStorageForSpan(span) {
    return $07df9178a3d19def$var$SPAN_METRIC_SUMMARY ? $07df9178a3d19def$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $07df9178a3d19def$export$2e7205e45c58797d(span) {
    const storage = $07df9178a3d19def$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $9Nu6W.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $07df9178a3d19def$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const storage = $07df9178a3d19def$var$getMetricStorageForSpan(span) || new Map();
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
    if (!$07df9178a3d19def$var$SPAN_METRIC_SUMMARY) $07df9178a3d19def$var$SPAN_METRIC_SUMMARY = new WeakMap();
    $07df9178a3d19def$var$SPAN_METRIC_SUMMARY.set(span, storage);
}

});

parcelRegister("k7Qhb", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $ea6d030d3da357d7$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $ea6d030d3da357d7$export$58f7963109c806fc; });
const $ea6d030d3da357d7$export$136e25984ba4a383 = 0;
const $ea6d030d3da357d7$export$58f7963109c806fc = 1;
const $ea6d030d3da357d7$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $ea6d030d3da357d7$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $ea6d030d3da357d7$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $ea6d030d3da357d7$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $ea6d030d3da357d7$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $ea6d030d3da357d7$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $ea6d030d3da357d7$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

});






parcelRegister("5CmDJ", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $41721025790c1662$export$2cd8252107eb640b; });

var $b3VeL = parcelRequire("b3VeL");

var $4fs8d = parcelRequire("4fs8d");
/**
 * Inits the React SDK
 */ function $41721025790c1662$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $4fs8d.applySdkMetadata)(opts, "react");
    (0, $b3VeL.init)(opts);
}

});
parcelRegister("b3VeL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $80dc5f9b99938175$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $80dc5f9b99938175$export$3a8fd680da42627b; });

var $aYSwx = parcelRequire("aYSwx");
var $lRMOS = parcelRequire("lRMOS");
var $djOL5 = parcelRequire("djOL5");
var $gKECY = parcelRequire("gKECY");
var $iu6PQ = parcelRequire("iu6PQ");
var $g4E2Q = parcelRequire("g4E2Q");
var $hHbGC = parcelRequire("hHbGC");
var $hW6fi = parcelRequire("hW6fi");

var $eN7RA = parcelRequire("eN7RA");
var $fW2sf = parcelRequire("fW2sf");
var $16o93 = parcelRequire("16o93");

var $eshwa = parcelRequire("eshwa");

var $hJV4d = parcelRequire("hJV4d");

var $jgQy7 = parcelRequire("jgQy7");

var $j7Wuw = parcelRequire("j7Wuw");

var $9ok5C = parcelRequire("9ok5C");

var $bQwaF = parcelRequire("bQwaF");

var $9gLKb = parcelRequire("9gLKb");

var $9iMhZ = parcelRequire("9iMhZ");

var $i9uOy = parcelRequire("i9uOy");

var $PvT7G = parcelRequire("PvT7G");

var $3Zu0i = parcelRequire("3Zu0i");
/** Get the default integrations for the browser SDK. */ function $80dc5f9b99938175$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $hHbGC.inboundFiltersIntegration)(),
        (0, $djOL5.functionToStringIntegration)(),
        (0, $bQwaF.browserApiErrorsIntegration)(),
        (0, $9ok5C.breadcrumbsIntegration)(),
        (0, $9gLKb.globalHandlersIntegration)(),
        (0, $i9uOy.linkedErrorsIntegration)(),
        (0, $lRMOS.dedupeIntegration)(),
        (0, $9iMhZ.httpContextIntegration)()
    ];
}
function $80dc5f9b99938175$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $80dc5f9b99938175$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $j7Wuw.WINDOW).SENTRY_RELEASE && (0, $j7Wuw.WINDOW).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $j7Wuw.WINDOW).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $80dc5f9b99938175$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeChrome = (0, $j7Wuw.WINDOW);
    const isInsideChromeExtension = windowWithMaybeChrome && windowWithMaybeChrome.chrome && windowWithMaybeChrome.chrome.runtime && windowWithMaybeChrome.chrome.runtime.id;
    const windowWithMaybeBrowser = (0, $j7Wuw.WINDOW);
    const isInsideBrowserExtension = windowWithMaybeBrowser && windowWithMaybeBrowser.browser && windowWithMaybeBrowser.browser.runtime && windowWithMaybeBrowser.browser.runtime.id;
    return !!isInsideBrowserExtension || !!isInsideChromeExtension;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $80dc5f9b99938175$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $80dc5f9b99938175$var$applyDefaultOptions(browserOptions);
    if ($80dc5f9b99938175$var$shouldShowBrowserExtensionError()) {
        (0, $eN7RA.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $jgQy7.DEBUG_BUILD) {
        if (!(0, $16o93.supportsFetch)()) (0, $eN7RA.logger).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $fW2sf.stackParserFromStackParserOptions)(options.stackParser || (0, $PvT7G.defaultStackParser)),
        integrations: (0, $iu6PQ.getIntegrationsToSetup)(options),
        transport: options.transport || (0, $3Zu0i.makeFetchTransport)
    };
    (0, $hW6fi.initAndBind)((0, $hJV4d.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $80dc5f9b99938175$var$startSessionTracking();
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $80dc5f9b99938175$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $j7Wuw.WINDOW).document) {
        (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $gKECY.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $aYSwx.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $j7Wuw.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $g4E2Q.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $j7Wuw.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $j7Wuw.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $j7Wuw.WINDOW).document.head || (0, $j7Wuw.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $80dc5f9b99938175$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $80dc5f9b99938175$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $80dc5f9b99938175$var$startSessionTracking() {
    if (typeof (0, $j7Wuw.WINDOW).document === "undefined") {
        (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $aYSwx.startSession)({
        ignoreDuration: true
    });
    (0, $aYSwx.captureSession)();
    // We want to create a session for every navigation as well
    (0, $eshwa.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $aYSwx.startSession)({
                ignoreDuration: true
            });
            (0, $aYSwx.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $80dc5f9b99938175$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $gKECY.getClient)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}

});
parcelRegister("lRMOS", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $feb46ac621c5315c$export$6d39aa44cd0c7567; });

var $eN7RA = parcelRequire("eN7RA");

var $iu6PQ = parcelRequire("iu6PQ");

var $4CAiX = parcelRequire("4CAiX");
const $feb46ac621c5315c$var$INTEGRATION_NAME = "Dedupe";
const $feb46ac621c5315c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $feb46ac621c5315c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($feb46ac621c5315c$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $feb46ac621c5315c$export$6d39aa44cd0c7567 = (0, $iu6PQ.defineIntegration)($feb46ac621c5315c$var$_dedupeIntegration);
/** only exported for tests. */ function $feb46ac621c5315c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($feb46ac621c5315c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($feb46ac621c5315c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $feb46ac621c5315c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$feb46ac621c5315c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$feb46ac621c5315c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $feb46ac621c5315c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $feb46ac621c5315c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $feb46ac621c5315c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$feb46ac621c5315c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$feb46ac621c5315c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $feb46ac621c5315c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $feb46ac621c5315c$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $feb46ac621c5315c$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $feb46ac621c5315c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $feb46ac621c5315c$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $feb46ac621c5315c$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("iu6PQ", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $d75054aac00fbf53$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $d75054aac00fbf53$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $d75054aac00fbf53$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $d75054aac00fbf53$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $d75054aac00fbf53$export$2323046b9414659f; });

var $ieXhv = parcelRequire("ieXhv");
var $eN7RA = parcelRequire("eN7RA");

var $gKECY = parcelRequire("gKECY");

var $4CAiX = parcelRequire("4CAiX");
const $d75054aac00fbf53$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $d75054aac00fbf53$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $d75054aac00fbf53$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $ieXhv.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $d75054aac00fbf53$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $d75054aac00fbf53$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $d75054aac00fbf53$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $d75054aac00fbf53$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $d75054aac00fbf53$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $d75054aac00fbf53$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($d75054aac00fbf53$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $d75054aac00fbf53$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $d75054aac00fbf53$export$2d8f5188773bcddd(integration) {
    const client = (0, $gKECY.getClient)();
    if (!client) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $d75054aac00fbf53$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $d75054aac00fbf53$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("djOL5", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $9b246c4afc359a9d$export$7918117e9202e4fb; });

var $9Nu6W = parcelRequire("9Nu6W");

var $gKECY = parcelRequire("gKECY");

var $iu6PQ = parcelRequire("iu6PQ");
let $9b246c4afc359a9d$var$originalFunctionToString;
const $9b246c4afc359a9d$var$INTEGRATION_NAME = "FunctionToString";
const $9b246c4afc359a9d$var$SETUP_CLIENTS = new WeakMap();
const $9b246c4afc359a9d$var$_functionToStringIntegration = ()=>{
    return {
        name: $9b246c4afc359a9d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $9b246c4afc359a9d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $9Nu6W.getOriginalFunction)(this);
                    const context = $9b246c4afc359a9d$var$SETUP_CLIENTS.has((0, $gKECY.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $9b246c4afc359a9d$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $9b246c4afc359a9d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $9b246c4afc359a9d$export$7918117e9202e4fb = (0, $iu6PQ.defineIntegration)($9b246c4afc359a9d$var$_functionToStringIntegration);

});

parcelRegister("g4E2Q", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $bb3c151f2661f952$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $bb3c151f2661f952$export$671c7ed8e40a7a57; });

var $4u7r3 = parcelRequire("4u7r3");
var $9Nu6W = parcelRequire("9Nu6W");
const $bb3c151f2661f952$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $bb3c151f2661f952$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $bb3c151f2661f952$var$_getIngestEndpoint(dsn) {
    return `${$bb3c151f2661f952$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $bb3c151f2661f952$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $9Nu6W.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $bb3c151f2661f952$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $bb3c151f2661f952$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$bb3c151f2661f952$var$_getIngestEndpoint(dsn)}?${$bb3c151f2661f952$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $bb3c151f2661f952$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $4u7r3.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$bb3c151f2661f952$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $4u7r3.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("4u7r3", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $343fbb472fad6006$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $343fbb472fad6006$export$128827c3562ec0cb; });

var $kqDzy = parcelRequire("kqDzy");

var $eN7RA = parcelRequire("eN7RA");
/** Regular expression used to parse a Dsn. */ const $343fbb472fad6006$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $343fbb472fad6006$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $343fbb472fad6006$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $343fbb472fad6006$export$b892860177f70a30(str) {
    const match = $343fbb472fad6006$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $eN7RA.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $343fbb472fad6006$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $343fbb472fad6006$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $343fbb472fad6006$var$validateDsn(dsn) {
    if (!(0, $kqDzy.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $eN7RA.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $eN7RA.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$343fbb472fad6006$var$isValidProtocol(protocol)) {
        (0, $eN7RA.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $eN7RA.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $343fbb472fad6006$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $343fbb472fad6006$export$b892860177f70a30(from) : $343fbb472fad6006$var$dsnFromComponents(from);
    if (!components || !$343fbb472fad6006$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("hHbGC", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $ce1f84807952efc2$export$cb3c5c2ceb9818ba; });

var $ieXhv = parcelRequire("ieXhv");
var $eN7RA = parcelRequire("eN7RA");
var $l5pHy = parcelRequire("l5pHy");

var $4CAiX = parcelRequire("4CAiX");

var $iu6PQ = parcelRequire("iu6PQ");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $ce1f84807952efc2$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
/** Options for the InboundFilters integration */ const $ce1f84807952efc2$var$INTEGRATION_NAME = "InboundFilters";
const $ce1f84807952efc2$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $ce1f84807952efc2$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $ce1f84807952efc2$var$_mergeOptions(options, clientOptions);
            return $ce1f84807952efc2$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $ce1f84807952efc2$export$cb3c5c2ceb9818ba = (0, $iu6PQ.defineIntegration)($ce1f84807952efc2$var$_inboundFiltersIntegration);
function $ce1f84807952efc2$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $ce1f84807952efc2$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $ce1f84807952efc2$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $ce1f84807952efc2$var$_isSentryError(event)) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $ieXhv.getEventDescription)(event)}`);
        return true;
    }
    if ($ce1f84807952efc2$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $ieXhv.getEventDescription)(event)}`);
        return true;
    }
    if ($ce1f84807952efc2$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $ieXhv.getEventDescription)(event)}`);
        return true;
    }
    if ($ce1f84807952efc2$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $ieXhv.getEventDescription)(event)}.\nUrl: ${$ce1f84807952efc2$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$ce1f84807952efc2$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $ieXhv.getEventDescription)(event)}.\nUrl: ${$ce1f84807952efc2$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $ce1f84807952efc2$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $ce1f84807952efc2$var$_getPossibleEventMessages(event).some((message)=>(0, $l5pHy.stringMatchesSomePattern)(message, ignoreErrors));
}
function $ce1f84807952efc2$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $l5pHy.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $ce1f84807952efc2$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $ce1f84807952efc2$var$_getEventFilterUrl(event);
    return !url ? false : (0, $l5pHy.stringMatchesSomePattern)(url, denyUrls);
}
function $ce1f84807952efc2$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $ce1f84807952efc2$var$_getEventFilterUrl(event);
    return !url ? true : (0, $l5pHy.stringMatchesSomePattern)(url, allowUrls);
}
function $ce1f84807952efc2$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $ce1f84807952efc2$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $ce1f84807952efc2$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $ce1f84807952efc2$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $ce1f84807952efc2$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).error(`Cannot extract url for event ${(0, $ieXhv.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("hW6fi", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $d0ecb2b2b75a36d6$export$5333c3f1c58d9bc1; });

var $eN7RA = parcelRequire("eN7RA");

var $gKECY = parcelRequire("gKECY");

var $7y29S = parcelRequire("7y29S");

var $4CAiX = parcelRequire("4CAiX");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $d0ecb2b2b75a36d6$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $4CAiX.DEBUG_BUILD) (0, $eN7RA.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $eN7RA.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $gKECY.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $d0ecb2b2b75a36d6$export$ecb76f41d43c0e43(client);
    client.init();
}
/**
 * Make the given client the current client.
 */ function $d0ecb2b2b75a36d6$export$ecb76f41d43c0e43(client) {
    (0, $gKECY.getCurrentScope)().setClient(client);
    $d0ecb2b2b75a36d6$var$registerClientOnGlobalHub(client);
}
/**
 * Unfortunately, we still have to manually bind the client to the "hub" property set on the global
 * Sentry carrier object. This is because certain scripts (e.g. our loader script) obtain
 * the client via `window.__SENTRY__.hub.getClient()`.
 *
 * @see {@link ./asyncContext/stackStrategy.ts getAsyncContextStack}
 */ function $d0ecb2b2b75a36d6$var$registerClientOnGlobalHub(client) {
    const sentryGlobal = (0, $7y29S.getSentryCarrier)((0, $7y29S.getMainCarrier)());
    if (sentryGlobal.hub && typeof sentryGlobal.hub.getStackTop === "function") sentryGlobal.hub.getStackTop().client = client;
}

});

parcelRegister("16o93", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $0cd914b12cb5f7f4$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $0cd914b12cb5f7f4$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $0cd914b12cb5f7f4$export$c82d238e23c40b21; });

var $kqDzy = parcelRequire("kqDzy");

var $eN7RA = parcelRequire("eN7RA");

var $inoaW = parcelRequire("inoaW");
const $0cd914b12cb5f7f4$var$WINDOW = (0, $inoaW.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $0cd914b12cb5f7f4$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0cd914b12cb5f7f4$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $0cd914b12cb5f7f4$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$0cd914b12cb5f7f4$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($0cd914b12cb5f7f4$export$18cf36ed71d733e7($0cd914b12cb5f7f4$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $0cd914b12cb5f7f4$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $0cd914b12cb5f7f4$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $kqDzy.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$531055a6c684a70a() {
    return "ReportingObserver" in $0cd914b12cb5f7f4$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $0cd914b12cb5f7f4$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$0cd914b12cb5f7f4$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("eshwa", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $a86144e258018c8c$export$3f18c56c58114e75; });

var $aFvbw = parcelRequire("aFvbw");
var $9Nu6W = parcelRequire("9Nu6W");
var $dHahT = parcelRequire("dHahT");

var $7iN0o = parcelRequire("7iN0o");
let $a86144e258018c8c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a86144e258018c8c$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $a86144e258018c8c$var$instrumentHistory);
}
function $a86144e258018c8c$var$instrumentHistory() {
    if (!(0, $dHahT.supportsHistory)()) return;
    const oldOnPopState = (0, $7iN0o.WINDOW).onpopstate;
    (0, $7iN0o.WINDOW).onpopstate = function(...args) {
        const to = (0, $7iN0o.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $a86144e258018c8c$var$lastHref;
        $a86144e258018c8c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $aFvbw.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $a86144e258018c8c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $a86144e258018c8c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $aFvbw.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $9Nu6W.fill)((0, $7iN0o.WINDOW).history, "pushState", historyReplacementFunction);
    (0, $9Nu6W.fill)((0, $7iN0o.WINDOW).history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("aFvbw", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $7c45ec616732708f$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $7c45ec616732708f$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $7c45ec616732708f$export$b18c893e424d3127; });

var $kqDzy = parcelRequire("kqDzy");

var $eN7RA = parcelRequire("eN7RA");

var $fW2sf = parcelRequire("fW2sf");
// We keep the handlers globally
const $7c45ec616732708f$var$handlers = {};
const $7c45ec616732708f$var$instrumented = {};
/** Add a handler function. */ function $7c45ec616732708f$export$a4e09611e30da72e(type, handler) {
    $7c45ec616732708f$var$handlers[type] = $7c45ec616732708f$var$handlers[type] || [];
    $7c45ec616732708f$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $7c45ec616732708f$export$b17eab759a1cb5fe() {
    Object.keys($7c45ec616732708f$var$handlers).forEach((key)=>{
        $7c45ec616732708f$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $7c45ec616732708f$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7c45ec616732708f$var$instrumented[type]) {
        instrumentFn();
        $7c45ec616732708f$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $7c45ec616732708f$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7c45ec616732708f$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $kqDzy.DEBUG_BUILD) && (0, $eN7RA.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $fW2sf.getFunctionName)(handler)}\nError:`, e);
    }
}

});

parcelRegister("dHahT", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $9f874565ba94455c$export$67fc34576016d6ec; });

var $inoaW = parcelRequire("inoaW");
// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $9f874565ba94455c$var$WINDOW = (0, $inoaW.GLOBAL_OBJ);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $9f874565ba94455c$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $9f874565ba94455c$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $9f874565ba94455c$var$WINDOW && !!$9f874565ba94455c$var$WINDOW.history.pushState && !!$9f874565ba94455c$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("7iN0o", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $55103a435e54720f$export$56d8a8a25bd48b81; });

var $inoaW = parcelRequire("inoaW");
const $55103a435e54720f$export$56d8a8a25bd48b81 = (0, $inoaW.GLOBAL_OBJ);

});


parcelRegister("hJV4d", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $cea2e7f7348d817a$export$1df9218a526d318d; });

var $4fs8d = parcelRequire("4fs8d");
var $5wxYv = parcelRequire("5wxYv");

var $7sTJY = parcelRequire("7sTJY");
var $4u7r3 = parcelRequire("4u7r3");
var $2w0uK = parcelRequire("2w0uK");
var $eN7RA = parcelRequire("eN7RA");

var $jgQy7 = parcelRequire("jgQy7");

var $heRI4 = parcelRequire("heRI4");

var $j7Wuw = parcelRequire("j7Wuw");

var $44rLg = parcelRequire("44rLg");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $cea2e7f7348d817a$export$1df9218a526d318d extends (0, $5wxYv.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $j7Wuw.WINDOW).SENTRY_SDK_SOURCE || (0, $2w0uK.getSDKSource)();
        (0, $4fs8d.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $j7Wuw.WINDOW).document) (0, $j7Wuw.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $j7Wuw.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $heRI4.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $heRI4.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $44rLg.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $7sTJY.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $4u7r3.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}

});
parcelRegister("4fs8d", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $317e6275a530d3af$export$b9f95b027256052c; });

var $681gi = parcelRequire("681gi");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $317e6275a530d3af$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $681gi.SDK_VERSION)
            })),
        version: (0, $681gi.SDK_VERSION)
    };
    options._metadata = metadata;
}

});
parcelRegister("681gi", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $476477feadbb1a49$export$31499a9cd224b78c; });
const $476477feadbb1a49$export$31499a9cd224b78c = "8.2.1";

});


parcelRegister("5wxYv", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $405a4b986ee7428b$export$4f22f74eddb7716a; });

var $lTsFS = parcelRequire("lTsFS");
var $ieXhv = parcelRequire("ieXhv");
var $9Nu6W = parcelRequire("9Nu6W");
var $7cgDk = parcelRequire("7cgDk");
var $eN7RA = parcelRequire("eN7RA");
var $4u7r3 = parcelRequire("4u7r3");
var $3Yj72 = parcelRequire("3Yj72");
var $iIGqd = parcelRequire("iIGqd");

var $g4E2Q = parcelRequire("g4E2Q");

var $gKECY = parcelRequire("gKECY");

var $4CAiX = parcelRequire("4CAiX");

var $7Tqli = parcelRequire("7Tqli");

var $iu6PQ = parcelRequire("iu6PQ");

var $dV569 = parcelRequire("dV569");

var $7xJOM = parcelRequire("7xJOM");

var $bkih4 = parcelRequire("bkih4");

var $bUnIF = parcelRequire("bUnIF");
const $405a4b986ee7428b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $405a4b986ee7428b$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $4u7r3.makeDsn)(options.dsn);
        else (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $g4E2Q.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $ieXhv.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $ieXhv.checkOrSetAlreadyCaught)(exception)) {
            (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).log($405a4b986ee7428b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $ieXhv.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $7cgDk.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $7cgDk.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $ieXhv.uuid4)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $ieXhv.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).log($405a4b986ee7428b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $dV569.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $3Yj72.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $iu6PQ.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $iu6PQ.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $7Tqli.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $lTsFS.addItemToEnvelope)(env, (0, $lTsFS.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $7Tqli.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).error("Error while sending event:", reason);
            return reason;
        });
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).error("Transport disabled");
        return (0, $3Yj72.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $iu6PQ.setupIntegrations)(this, integrations);
        (0, $iu6PQ.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $dV569.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3Yj72.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $gKECY.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $bUnIF.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $9Nu6W.dropUndefinedKeys)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $7xJOM.getDynamicSamplingContextFromClient)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $4CAiX.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $eN7RA.logger).log(sentryError.message);
                else (0, $eN7RA.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $405a4b986ee7428b$var$isTransactionEvent(event);
        const isError = $405a4b986ee7428b$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $bkih4.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $3Yj72.rejectedSyncPromise)(new (0, $iIGqd.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $iIGqd.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $405a4b986ee7428b$var$processBeforeSend(options, prepared, hint);
            return $405a4b986ee7428b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $iIGqd.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $iIGqd.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $iIGqd.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $405a4b986ee7428b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $7cgDk.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $7cgDk.isPlainObject)(event) && event !== null) throw new (0, $iIGqd.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $iIGqd.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $7cgDk.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $iIGqd.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $405a4b986ee7428b$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($405a4b986ee7428b$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($405a4b986ee7428b$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) return beforeSendTransaction(event, hint);
    }
    return event;
}
function $405a4b986ee7428b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $405a4b986ee7428b$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

});
parcelRegister("lTsFS", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $ff04fa2caa36d004$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $ff04fa2caa36d004$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $ff04fa2caa36d004$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $ff04fa2caa36d004$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $ff04fa2caa36d004$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $ff04fa2caa36d004$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $ff04fa2caa36d004$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $ff04fa2caa36d004$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $ff04fa2caa36d004$export$92b6093782fe661b; });

var $4u7r3 = parcelRequire("4u7r3");

var $32A7B = parcelRequire("32A7B");

var $9Nu6W = parcelRequire("9Nu6W");

var $inoaW = parcelRequire("inoaW");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ff04fa2caa36d004$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ff04fa2caa36d004$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $ff04fa2caa36d004$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $ff04fa2caa36d004$export$604a45d95a155e2b(envelope, types) {
    return $ff04fa2caa36d004$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $ff04fa2caa36d004$var$encodeUTF8(input) {
    return (0, $inoaW.GLOBAL_OBJ).__SENTRY__ && (0, $inoaW.GLOBAL_OBJ).__SENTRY__.encodePolyfill ? (0, $inoaW.GLOBAL_OBJ).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $ff04fa2caa36d004$var$decodeUTF8(input) {
    return (0, $inoaW.GLOBAL_OBJ).__SENTRY__ && (0, $inoaW.GLOBAL_OBJ).__SENTRY__.decodePolyfill ? (0, $inoaW.GLOBAL_OBJ).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $ff04fa2caa36d004$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ff04fa2caa36d004$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $ff04fa2caa36d004$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $32A7B.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ff04fa2caa36d004$var$concatBuffers(parts);
}
function $ff04fa2caa36d004$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $ff04fa2caa36d004$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $ff04fa2caa36d004$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($ff04fa2caa36d004$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $ff04fa2caa36d004$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $ff04fa2caa36d004$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $ff04fa2caa36d004$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $9Nu6W.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $ff04fa2caa36d004$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $ff04fa2caa36d004$export$b11169581eeaf237(type) {
    return $ff04fa2caa36d004$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $ff04fa2caa36d004$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $ff04fa2caa36d004$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4u7r3.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $9Nu6W.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("iIGqd", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $da0d3e23119ee8b2$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $da0d3e23119ee8b2$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("7Tqli", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $5bf21a8d16e56c24$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $5bf21a8d16e56c24$export$c31057337a18010f; });

var $lTsFS = parcelRequire("lTsFS");
var $4u7r3 = parcelRequire("4u7r3");



var $2jO8g = parcelRequire("2jO8g");

var $7xJOM = parcelRequire("7xJOM");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $5bf21a8d16e56c24$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $5bf21a8d16e56c24$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $lTsFS.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4u7r3.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $lTsFS.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $5bf21a8d16e56c24$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $lTsFS.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $5bf21a8d16e56c24$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $lTsFS.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $lTsFS.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $5bf21a8d16e56c24$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $7xJOM.getDynamicSamplingContextFromSpan)(spans[0]);
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $2jO8g.spanToJSON)(span)) : (span)=>(0, $2jO8g.spanToJSON)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $lTsFS.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $lTsFS.createEnvelope)(headers, items);
}

});

parcelRegister("bkih4", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $83efbcdc1f02b5e3$export$a5bd2d81656d9546; });

var $eN7RA = parcelRequire("eN7RA");

var $4CAiX = parcelRequire("4CAiX");
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $83efbcdc1f02b5e3$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}

});


parcelRegister("7sTJY", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $56f662d40f957c4a$export$f3b9ed77c03eeb00; });

var $lTsFS = parcelRequire("lTsFS");

var $iYIMl = parcelRequire("iYIMl");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $56f662d40f957c4a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $iYIMl.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $lTsFS.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("2w0uK", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $1d4ef4362e1d2021$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $1d4ef4362e1d2021$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d4ef4362e1d2021$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d4ef4362e1d2021$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("jgQy7", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $e0784620e13d90ae$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0784620e13d90ae$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("heRI4", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $c8cd6824b8edcd57$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $c8cd6824b8edcd57$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $c8cd6824b8edcd57$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $c8cd6824b8edcd57$export$5425b53185d13d6c; });

var $gKECY = parcelRequire("gKECY");

var $ieXhv = parcelRequire("ieXhv");
var $9Nu6W = parcelRequire("9Nu6W");
var $7cgDk = parcelRequire("7cgDk");
var $32A7B = parcelRequire("32A7B");
var $3Yj72 = parcelRequire("3Yj72");
/**
 * This function creates an exception from a JavaScript Error
 */ function $c8cd6824b8edcd57$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $c8cd6824b8edcd57$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $c8cd6824b8edcd57$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $c8cd6824b8edcd57$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $gKECY.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $c8cd6824b8edcd57$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $32A7B.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c8cd6824b8edcd57$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $7cgDk.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c8cd6824b8edcd57$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c8cd6824b8edcd57$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c8cd6824b8edcd57$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c8cd6824b8edcd57$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $c8cd6824b8edcd57$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $c8cd6824b8edcd57$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c8cd6824b8edcd57$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $c8cd6824b8edcd57$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $c8cd6824b8edcd57$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c8cd6824b8edcd57$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $c8cd6824b8edcd57$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $c8cd6824b8edcd57$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $c8cd6824b8edcd57$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c8cd6824b8edcd57$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $ieXhv.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3Yj72.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $c8cd6824b8edcd57$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c8cd6824b8edcd57$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3Yj72.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $c8cd6824b8edcd57$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $7cgDk.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $c8cd6824b8edcd57$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $7cgDk.isDOMError)(exception) || (0, $7cgDk.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $c8cd6824b8edcd57$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $7cgDk.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c8cd6824b8edcd57$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $ieXhv.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $7cgDk.isError)(exception)) // we have a real Error object, do nothing
    return $c8cd6824b8edcd57$var$eventFromError(stackParser, exception);
    if ((0, $7cgDk.isPlainObject)(exception) || (0, $7cgDk.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $c8cd6824b8edcd57$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $ieXhv.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c8cd6824b8edcd57$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $ieXhv.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $ieXhv.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c8cd6824b8edcd57$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c8cd6824b8edcd57$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $7cgDk.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c8cd6824b8edcd57$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9Nu6W.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $7cgDk.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $7cgDk.isEvent)(exception)) {
        const className = $c8cd6824b8edcd57$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c8cd6824b8edcd57$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $c8cd6824b8edcd57$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("j7Wuw", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $decc0ae8ccbf7517$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $decc0ae8ccbf7517$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $decc0ae8ccbf7517$export$4997ffc0176396a6; });

var $aYSwx = parcelRequire("aYSwx");
var $gKECY = parcelRequire("gKECY");

var $ieXhv = parcelRequire("ieXhv");
var $9Nu6W = parcelRequire("9Nu6W");
var $inoaW = parcelRequire("inoaW");
const $decc0ae8ccbf7517$export$56d8a8a25bd48b81 = (0, $inoaW.GLOBAL_OBJ);
let $decc0ae8ccbf7517$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $decc0ae8ccbf7517$export$b79738ab10c590b2() {
    return $decc0ae8ccbf7517$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $decc0ae8ccbf7517$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $decc0ae8ccbf7517$var$ignoreOnError++;
    setTimeout(()=>{
        $decc0ae8ccbf7517$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $decc0ae8ccbf7517$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $9Nu6W.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$decc0ae8ccbf7517$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $decc0ae8ccbf7517$export$1265a142ff5ba165();
            (0, $gKECY.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $ieXhv.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $ieXhv.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $aYSwx.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9Nu6W.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9Nu6W.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("44rLg", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $2f6d11f16a877c54$export$24a4dfcb686ee5bf; });

var $lTsFS = parcelRequire("lTsFS");
var $4u7r3 = parcelRequire("4u7r3");
/**
 * Creates an envelope from a user feedback.
 */ function $2f6d11f16a877c54$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $4u7r3.dsnToString)(dsn)
        }
    };
    const item = $2f6d11f16a877c54$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $lTsFS.createEnvelope)(headers, [
        item
    ]);
}
function $2f6d11f16a877c54$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("9ok5C", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $6d65f050150a9fca$export$c079d904b326663a; });

var $cBSFr = parcelRequire("cBSFr");
var $eshwa = parcelRequire("eshwa");
var $9WwUc = parcelRequire("9WwUc");

var $jdjqN = parcelRequire("jdjqN");
var $iu6PQ = parcelRequire("iu6PQ");
var $gKECY = parcelRequire("gKECY");

var $azxyN = parcelRequire("azxyN");
var $9oV64 = parcelRequire("9oV64");
var $bwpQP = parcelRequire("bwpQP");
var $ieXhv = parcelRequire("ieXhv");
var $eN7RA = parcelRequire("eN7RA");
var $7z1W0 = parcelRequire("7z1W0");
var $l5pHy = parcelRequire("l5pHy");
var $5rvCg = parcelRequire("5rvCg");

var $jgQy7 = parcelRequire("jgQy7");

var $j7Wuw = parcelRequire("j7Wuw");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $6d65f050150a9fca$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $6d65f050150a9fca$var$INTEGRATION_NAME = "Breadcrumbs";
const $6d65f050150a9fca$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $6d65f050150a9fca$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $azxyN.addConsoleInstrumentationHandler)($6d65f050150a9fca$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $cBSFr.addClickKeypressInstrumentationHandler)($6d65f050150a9fca$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $9WwUc.addXhrInstrumentationHandler)($6d65f050150a9fca$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $9oV64.addFetchInstrumentationHandler)($6d65f050150a9fca$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $eshwa.addHistoryInstrumentationHandler)($6d65f050150a9fca$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $6d65f050150a9fca$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $6d65f050150a9fca$export$c079d904b326663a = (0, $iu6PQ.defineIntegration)($6d65f050150a9fca$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $6d65f050150a9fca$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $gKECY.getClient)() !== client) return;
        (0, $jdjqN.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $ieXhv.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $6d65f050150a9fca$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $gKECY.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $6d65f050150a9fca$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$6d65f050150a9fca$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6d65f050150a9fca$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6d65f050150a9fca$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $6d65f050150a9fca$var$_isEvent(event) ? event.target : event;
            target = (0, $bwpQP.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $bwpQP.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $jdjqN.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $6d65f050150a9fca$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $gKECY.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $5rvCg.severityLevelFromString)(handlerData.level),
            message: (0, $l5pHy.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $l5pHy.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $jdjqN.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $6d65f050150a9fca$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $gKECY.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $9WwUc.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $jdjqN.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $6d65f050150a9fca$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $gKECY.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $jdjqN.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $jdjqN.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $6d65f050150a9fca$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $gKECY.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $7z1W0.parseUrl)((0, $j7Wuw.WINDOW).location.href);
        let parsedFrom = from ? (0, $7z1W0.parseUrl)(from) : undefined;
        const parsedTo = (0, $7z1W0.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $jdjqN.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $6d65f050150a9fca$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("cBSFr", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $025e816da6b01a14$export$5aeffd3db2cf9df7; });

var $aFvbw = parcelRequire("aFvbw");
var $9Nu6W = parcelRequire("9Nu6W");
var $ieXhv = parcelRequire("ieXhv");

var $7iN0o = parcelRequire("7iN0o");
const $025e816da6b01a14$var$DEBOUNCE_DURATION = 1000;
let $025e816da6b01a14$var$debounceTimerID;
let $025e816da6b01a14$var$lastCapturedEventType;
let $025e816da6b01a14$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $025e816da6b01a14$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $025e816da6b01a14$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $025e816da6b01a14$export$3014bbf0af0e1d4a() {
    if (!(0, $7iN0o.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $aFvbw.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $025e816da6b01a14$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $7iN0o.WINDOW).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $7iN0o.WINDOW).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $7iN0o.WINDOW)[target] && (0, $7iN0o.WINDOW)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $9Nu6W.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $025e816da6b01a14$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $9Nu6W.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $025e816da6b01a14$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $025e816da6b01a14$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $025e816da6b01a14$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $025e816da6b01a14$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $025e816da6b01a14$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $025e816da6b01a14$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($025e816da6b01a14$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $9Nu6W.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $9Nu6W.addNonEnumerableProperty)(target, "_sentryId", (0, $ieXhv.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$025e816da6b01a14$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $025e816da6b01a14$var$lastCapturedEventType = event.type;
            $025e816da6b01a14$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($025e816da6b01a14$var$debounceTimerID);
        $025e816da6b01a14$var$debounceTimerID = (0, $7iN0o.WINDOW).setTimeout(()=>{
            $025e816da6b01a14$var$lastCapturedEventTargetId = undefined;
            $025e816da6b01a14$var$lastCapturedEventType = undefined;
        }, $025e816da6b01a14$var$DEBOUNCE_DURATION);
    };
}
function $025e816da6b01a14$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("9WwUc", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $73d30e26c777bde1$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $73d30e26c777bde1$export$26ace48dd54c9aea; });

var $aFvbw = parcelRequire("aFvbw");
var $9Nu6W = parcelRequire("9Nu6W");
var $7cgDk = parcelRequire("7cgDk");
var $iYIMl = parcelRequire("iYIMl");

var $7iN0o = parcelRequire("7iN0o");
const $73d30e26c777bde1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $73d30e26c777bde1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $73d30e26c777bde1$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $73d30e26c777bde1$export$c67d533bf77cbf54() {
    if (!(0, $7iN0o.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $9Nu6W.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = (0, $iYIMl.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $7cgDk.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $73d30e26c777bde1$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$73d30e26c777bde1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$73d30e26c777bde1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $iYIMl.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $aFvbw.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $9Nu6W.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $9Nu6W.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$73d30e26c777bde1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $7cgDk.isString)(header) && (0, $7cgDk.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $9Nu6W.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$73d30e26c777bde1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                startTimestamp: (0, $iYIMl.timestampInSeconds)() * 1000,
                xhr: this
            };
            (0, $aFvbw.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $73d30e26c777bde1$var$parseUrl(url) {
    if ((0, $7cgDk.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("azxyN", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $7b2734a2e5d4ba1f$export$1d6e0d073f9e6723; });

var $eN7RA = parcelRequire("eN7RA");

var $9Nu6W = parcelRequire("9Nu6W");

var $inoaW = parcelRequire("inoaW");

var $aFvbw = parcelRequire("aFvbw");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7b2734a2e5d4ba1f$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $7b2734a2e5d4ba1f$var$instrumentConsole);
}
function $7b2734a2e5d4ba1f$var$instrumentConsole() {
    if (!("console" in (0, $inoaW.GLOBAL_OBJ))) return;
    (0, $eN7RA.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $inoaW.GLOBAL_OBJ).console)) return;
        (0, $9Nu6W.fill)((0, $inoaW.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $eN7RA.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $aFvbw.triggerHandlers)("console", handlerData);
                const log = (0, $eN7RA.originalConsoleMethods)[level];
                log && log.apply((0, $inoaW.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("9oV64", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $6d82a532b49ce45f$export$f75d3c772c923df0; });

var $9Nu6W = parcelRequire("9Nu6W");

var $16o93 = parcelRequire("16o93");

var $iYIMl = parcelRequire("iYIMl");

var $inoaW = parcelRequire("inoaW");

var $aFvbw = parcelRequire("aFvbw");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6d82a532b49ce45f$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $6d82a532b49ce45f$var$instrumentFetch);
}
function $6d82a532b49ce45f$var$instrumentFetch() {
    if (!(0, $16o93.supportsNativeFetch)()) return;
    (0, $9Nu6W.fill)((0, $inoaW.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $6d82a532b49ce45f$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $iYIMl.timestampInSeconds)() * 1000
            };
            (0, $aFvbw.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $inoaW.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $iYIMl.timestampInSeconds)() * 1000,
                    response: response
                };
                (0, $aFvbw.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $iYIMl.timestampInSeconds)() * 1000,
                    error: error
                };
                (0, $aFvbw.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $6d82a532b49ce45f$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $6d82a532b49ce45f$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($6d82a532b49ce45f$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $6d82a532b49ce45f$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $6d82a532b49ce45f$var$getUrlFromResource(url),
            method: $6d82a532b49ce45f$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $6d82a532b49ce45f$var$getUrlFromResource(arg),
        method: $6d82a532b49ce45f$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("7z1W0", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $581d4d71e84adcf6$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $581d4d71e84adcf6$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $581d4d71e84adcf6$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $581d4d71e84adcf6$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $581d4d71e84adcf6$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("5rvCg", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $3f67ffa9b6557e87$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $3f67ffa9b6557e87$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $3f67ffa9b6557e87$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $3f67ffa9b6557e87$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("bQwaF", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $89fd819083f92c7c$export$59bfe9f1c76150e; });

var $iu6PQ = parcelRequire("iu6PQ");

var $9Nu6W = parcelRequire("9Nu6W");
var $fW2sf = parcelRequire("fW2sf");

var $j7Wuw = parcelRequire("j7Wuw");
const $89fd819083f92c7c$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $89fd819083f92c7c$var$INTEGRATION_NAME = "BrowserApiErrors";
const $89fd819083f92c7c$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $89fd819083f92c7c$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9Nu6W.fill)((0, $j7Wuw.WINDOW), "setTimeout", $89fd819083f92c7c$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9Nu6W.fill)((0, $j7Wuw.WINDOW), "setInterval", $89fd819083f92c7c$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9Nu6W.fill)((0, $j7Wuw.WINDOW), "requestAnimationFrame", $89fd819083f92c7c$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $j7Wuw.WINDOW)) (0, $9Nu6W.fill)(XMLHttpRequest.prototype, "send", $89fd819083f92c7c$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $89fd819083f92c7c$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($89fd819083f92c7c$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $89fd819083f92c7c$export$59bfe9f1c76150e = (0, $iu6PQ.defineIntegration)($89fd819083f92c7c$var$_browserApiErrorsIntegration);
function $89fd819083f92c7c$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $j7Wuw.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $fW2sf.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $89fd819083f92c7c$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $j7Wuw.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $fW2sf.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $89fd819083f92c7c$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9Nu6W.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $fW2sf.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $9Nu6W.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $fW2sf.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $j7Wuw.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $89fd819083f92c7c$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $j7Wuw.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $9Nu6W.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $j7Wuw.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $fW2sf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $j7Wuw.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $fW2sf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $9Nu6W.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("9gLKb", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $6bfaa498bb30c836$export$66acc70e8cf2b71a; });

var $aYSwx = parcelRequire("aYSwx");
var $iu6PQ = parcelRequire("iu6PQ");
var $gKECY = parcelRequire("gKECY");

var $3mG36 = parcelRequire("3mG36");
var $lWves = parcelRequire("lWves");
var $bwpQP = parcelRequire("bwpQP");
var $7cgDk = parcelRequire("7cgDk");
var $eN7RA = parcelRequire("eN7RA");
var $fW2sf = parcelRequire("fW2sf");

var $jgQy7 = parcelRequire("jgQy7");

var $heRI4 = parcelRequire("heRI4");

var $j7Wuw = parcelRequire("j7Wuw");
const $6bfaa498bb30c836$var$INTEGRATION_NAME = "GlobalHandlers";
const $6bfaa498bb30c836$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $6bfaa498bb30c836$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $6bfaa498bb30c836$var$_installGlobalOnErrorHandler(client);
                $6bfaa498bb30c836$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $6bfaa498bb30c836$var$_installGlobalOnUnhandledRejectionHandler(client);
                $6bfaa498bb30c836$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $6bfaa498bb30c836$export$66acc70e8cf2b71a = (0, $iu6PQ.defineIntegration)($6bfaa498bb30c836$var$_globalHandlersIntegration);
function $6bfaa498bb30c836$var$_installGlobalOnErrorHandler(client) {
    (0, $3mG36.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $6bfaa498bb30c836$var$getOptions();
        if ((0, $gKECY.getClient)() !== client || (0, $j7Wuw.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $6bfaa498bb30c836$var$_enhanceEventWithInitialFrame((0, $heRI4.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $aYSwx.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $6bfaa498bb30c836$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $lWves.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $6bfaa498bb30c836$var$getOptions();
        if ((0, $gKECY.getClient)() !== client || (0, $j7Wuw.shouldIgnoreOnError)()) return;
        const error = $6bfaa498bb30c836$var$_getUnhandledRejectionError(e);
        const event = (0, $7cgDk.isPrimitive)(error) ? $6bfaa498bb30c836$var$_eventFromRejectionWithPrimitive(error) : (0, $heRI4.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $aYSwx.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $6bfaa498bb30c836$var$_getUnhandledRejectionError(error) {
    if ((0, $7cgDk.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $6bfaa498bb30c836$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6bfaa498bb30c836$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $7cgDk.isString)(url) && url.length > 0 ? url : (0, $bwpQP.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $fW2sf.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $6bfaa498bb30c836$var$globalHandlerLog(type) {
    (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).log(`Global Handler attached: ${type}`);
}
function $6bfaa498bb30c836$var$getOptions() {
    const client = (0, $gKECY.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("3mG36", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $27340b37888c0e29$export$55b5c3ba2194f0c6; });

var $inoaW = parcelRequire("inoaW");

var $aFvbw = parcelRequire("aFvbw");
let $27340b37888c0e29$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $27340b37888c0e29$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $27340b37888c0e29$var$instrumentError);
}
function $27340b37888c0e29$var$instrumentError() {
    $27340b37888c0e29$var$_oldOnErrorHandler = (0, $inoaW.GLOBAL_OBJ).onerror;
    (0, $inoaW.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $aFvbw.triggerHandlers)("error", handlerData);
        if ($27340b37888c0e29$var$_oldOnErrorHandler && !$27340b37888c0e29$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $27340b37888c0e29$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $inoaW.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("lWves", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $041f57b4d570a9b1$export$8bf4fc6858821a4e; });

var $inoaW = parcelRequire("inoaW");

var $aFvbw = parcelRequire("aFvbw");
let $041f57b4d570a9b1$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $041f57b4d570a9b1$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $aFvbw.addHandler)(type, handler);
    (0, $aFvbw.maybeInstrument)(type, $041f57b4d570a9b1$var$instrumentUnhandledRejection);
}
function $041f57b4d570a9b1$var$instrumentUnhandledRejection() {
    $041f57b4d570a9b1$var$_oldOnUnhandledRejectionHandler = (0, $inoaW.GLOBAL_OBJ).onunhandledrejection;
    (0, $inoaW.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $aFvbw.triggerHandlers)("unhandledrejection", handlerData);
        if ($041f57b4d570a9b1$var$_oldOnUnhandledRejectionHandler && !$041f57b4d570a9b1$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $041f57b4d570a9b1$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $inoaW.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("9iMhZ", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $6c5b40b7e506b727$export$1378794447170364; });

var $iu6PQ = parcelRequire("iu6PQ");

var $j7Wuw = parcelRequire("j7Wuw");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $6c5b40b7e506b727$export$1378794447170364 = (0, $iu6PQ.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $j7Wuw.WINDOW).navigator && !(0, $j7Wuw.WINDOW).location && !(0, $j7Wuw.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $j7Wuw.WINDOW).location && (0, $j7Wuw.WINDOW).location.href;
            const { referrer: referrer } = (0, $j7Wuw.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $j7Wuw.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});

});

parcelRegister("i9uOy", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $d370f86064a8472b$export$ebabb00eb7f3a395; });

var $iu6PQ = parcelRequire("iu6PQ");

var $eheyB = parcelRequire("eheyB");

var $heRI4 = parcelRequire("heRI4");
const $d370f86064a8472b$var$DEFAULT_KEY = "cause";
const $d370f86064a8472b$var$DEFAULT_LIMIT = 5;
const $d370f86064a8472b$var$INTEGRATION_NAME = "LinkedErrors";
const $d370f86064a8472b$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d370f86064a8472b$var$DEFAULT_LIMIT;
    const key = options.key || $d370f86064a8472b$var$DEFAULT_KEY;
    return {
        name: $d370f86064a8472b$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $eheyB.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $heRI4.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $d370f86064a8472b$export$ebabb00eb7f3a395 = (0, $iu6PQ.defineIntegration)($d370f86064a8472b$var$_linkedErrorsIntegration);

});
parcelRegister("eheyB", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $a64df1f873ccb426$export$b91c38ed7d8ae9b2; });

var $7cgDk = parcelRequire("7cgDk");

var $l5pHy = parcelRequire("l5pHy");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $a64df1f873ccb426$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $7cgDk.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $a64df1f873ccb426$var$truncateAggregateExceptions($a64df1f873ccb426$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $a64df1f873ccb426$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $7cgDk.isInstanceOf)(error[key], Error)) {
        $a64df1f873ccb426$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $a64df1f873ccb426$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $a64df1f873ccb426$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $7cgDk.isInstanceOf)(childError, Error)) {
            $a64df1f873ccb426$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $a64df1f873ccb426$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $a64df1f873ccb426$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $a64df1f873ccb426$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $a64df1f873ccb426$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $a64df1f873ccb426$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $l5pHy.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("PvT7G", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $09ad7fd7d3161d3b$export$2b2b997d81bf3907; });

var $fW2sf = parcelRequire("fW2sf");
const $09ad7fd7d3161d3b$var$OPERA10_PRIORITY = 10;
const $09ad7fd7d3161d3b$var$OPERA11_PRIORITY = 20;
const $09ad7fd7d3161d3b$var$CHROME_PRIORITY = 30;
const $09ad7fd7d3161d3b$var$WINJS_PRIORITY = 40;
const $09ad7fd7d3161d3b$var$GECKO_PRIORITY = 50;
function $09ad7fd7d3161d3b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $fW2sf.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $09ad7fd7d3161d3b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $09ad7fd7d3161d3b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $09ad7fd7d3161d3b$var$chromeStackParserFn = (line)=>{
    const parts = $09ad7fd7d3161d3b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $09ad7fd7d3161d3b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $09ad7fd7d3161d3b$var$extractSafariExtensionDetails(parts[1] || (0, $fW2sf.UNKNOWN_FUNCTION), parts[2]);
        return $09ad7fd7d3161d3b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $09ad7fd7d3161d3b$export$263a749fff749872 = [
    $09ad7fd7d3161d3b$var$CHROME_PRIORITY,
    $09ad7fd7d3161d3b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $09ad7fd7d3161d3b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $09ad7fd7d3161d3b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $09ad7fd7d3161d3b$var$gecko = (line)=>{
    const parts = $09ad7fd7d3161d3b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $09ad7fd7d3161d3b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $fW2sf.UNKNOWN_FUNCTION);
        [func, filename] = $09ad7fd7d3161d3b$var$extractSafariExtensionDetails(func, filename);
        return $09ad7fd7d3161d3b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $09ad7fd7d3161d3b$export$cdba47a5dd2804d = [
    $09ad7fd7d3161d3b$var$GECKO_PRIORITY,
    $09ad7fd7d3161d3b$var$gecko
];
const $09ad7fd7d3161d3b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $09ad7fd7d3161d3b$var$winjs = (line)=>{
    const parts = $09ad7fd7d3161d3b$var$winjsRegex.exec(line);
    return parts ? $09ad7fd7d3161d3b$var$createFrame(parts[2], parts[1] || (0, $fW2sf.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $09ad7fd7d3161d3b$export$179460296da408e8 = [
    $09ad7fd7d3161d3b$var$WINJS_PRIORITY,
    $09ad7fd7d3161d3b$var$winjs
];
const $09ad7fd7d3161d3b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $09ad7fd7d3161d3b$var$opera10 = (line)=>{
    const parts = $09ad7fd7d3161d3b$var$opera10Regex.exec(line);
    return parts ? $09ad7fd7d3161d3b$var$createFrame(parts[2], parts[3] || (0, $fW2sf.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $09ad7fd7d3161d3b$export$f892b52c880ffc7a = [
    $09ad7fd7d3161d3b$var$OPERA10_PRIORITY,
    $09ad7fd7d3161d3b$var$opera10
];
const $09ad7fd7d3161d3b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $09ad7fd7d3161d3b$var$opera11 = (line)=>{
    const parts = $09ad7fd7d3161d3b$var$opera11Regex.exec(line);
    return parts ? $09ad7fd7d3161d3b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $fW2sf.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $09ad7fd7d3161d3b$export$af11af13f09fb0dc = [
    $09ad7fd7d3161d3b$var$OPERA11_PRIORITY,
    $09ad7fd7d3161d3b$var$opera11
];
const $09ad7fd7d3161d3b$export$7197c0fe6554c079 = [
    $09ad7fd7d3161d3b$export$263a749fff749872,
    $09ad7fd7d3161d3b$export$cdba47a5dd2804d
];
const $09ad7fd7d3161d3b$export$2b2b997d81bf3907 = (0, $fW2sf.createStackParser)(...$09ad7fd7d3161d3b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $09ad7fd7d3161d3b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $fW2sf.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3Zu0i", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $2e7e57b69bc6ba09$export$b2311068c46d7cc8; });

var $c3zms = parcelRequire("c3zms");

var $3Yj72 = parcelRequire("3Yj72");

var $1eFT5 = parcelRequire("1eFT5");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $2e7e57b69bc6ba09$export$b2311068c46d7cc8(options, nativeFetch = (0, $1eFT5.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $1eFT5.clearCachedFetchImplementation)();
            return (0, $3Yj72.rejectedSyncPromise)("No fetch implementation available");
        }
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $1eFT5.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3Yj72.rejectedSyncPromise)(e);
        }
    }
    return (0, $c3zms.createTransport)(options, makeRequest);
}

});
parcelRegister("c3zms", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $8c7131de94bba33f$export$d09f50d9ab7f7b69; });

var $lTsFS = parcelRequire("lTsFS");
var $l3hVr = parcelRequire("l3hVr");
var $eN7RA = parcelRequire("eN7RA");
var $jVfIK = parcelRequire("jVfIK");
var $3Yj72 = parcelRequire("3Yj72");
var $iIGqd = parcelRequire("iIGqd");

var $4CAiX = parcelRequire("4CAiX");
const $8c7131de94bba33f$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $8c7131de94bba33f$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $jVfIK.makePromiseBuffer)(options.bufferSize || $8c7131de94bba33f$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $lTsFS.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $lTsFS.envelopeItemTypeToDataCategory)(type);
            if ((0, $l3hVr.isRateLimited)(rateLimits, dataCategory)) {
                const event = $8c7131de94bba33f$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3Yj72.resolvedSyncPromise)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $lTsFS.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $lTsFS.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $8c7131de94bba33f$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $lTsFS.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $lTsFS.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $l3hVr.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $iIGqd.SentryError)) {
                (0, $4CAiX.DEBUG_BUILD) && (0, $eN7RA.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3Yj72.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $8c7131de94bba33f$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("l3hVr", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $f537c869b439f21f$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $f537c869b439f21f$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $f537c869b439f21f$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $f537c869b439f21f$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $f537c869b439f21f$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $f537c869b439f21f$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $f537c869b439f21f$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $f537c869b439f21f$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $f537c869b439f21f$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $f537c869b439f21f$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("jVfIK", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $e80f89001f0ead8f$export$85a4f67f852183e6; });

var $iIGqd = parcelRequire("iIGqd");

var $3Yj72 = parcelRequire("3Yj72");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e80f89001f0ead8f$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3Yj72.rejectedSyncPromise)(new (0, $iIGqd.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3Yj72.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3Yj72.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("1eFT5", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $0e6797357c70f196$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $0e6797357c70f196$export$d499686d2dd738c6; });

var $16o93 = parcelRequire("16o93");
var $eN7RA = parcelRequire("eN7RA");

var $jgQy7 = parcelRequire("jgQy7");

var $j7Wuw = parcelRequire("j7Wuw");
let $0e6797357c70f196$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $0e6797357c70f196$export$8be2119ce08e3379() {
    if ($0e6797357c70f196$var$cachedFetchImpl) return $0e6797357c70f196$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $16o93.isNativeFetch)((0, $j7Wuw.WINDOW).fetch)) return $0e6797357c70f196$var$cachedFetchImpl = (0, $j7Wuw.WINDOW).fetch.bind((0, $j7Wuw.WINDOW));
    const document = (0, $j7Wuw.WINDOW).document;
    let fetchImpl = (0, $j7Wuw.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $jgQy7.DEBUG_BUILD) && (0, $eN7RA.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    try {
        return $0e6797357c70f196$var$cachedFetchImpl = fetchImpl.bind((0, $j7Wuw.WINDOW));
    } catch (e) {
    // empty
    }
    return undefined;
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $0e6797357c70f196$export$d499686d2dd738c6() {
    $0e6797357c70f196$var$cachedFetchImpl = undefined;
}

});




parcelRegister("cx5HD", function(module, exports) {

$parcel$export(module.exports, "replayIntegration", function () { return $91fcfd915f89593c$export$d7706faf7ab354bf; });

var $fFkWd = parcelRequire("fFkWd");
var $6ZXTI = parcelRequire("6ZXTI");
var $iYIMl = parcelRequire("iYIMl");
var $eN7RA = parcelRequire("eN7RA");
var $lTsFS = parcelRequire("lTsFS");
var $9Nu6W = parcelRequire("9Nu6W");
var $inoaW = parcelRequire("inoaW");
var $bwpQP = parcelRequire("bwpQP");
var $evu26 = parcelRequire("evu26");
var $l3hVr = parcelRequire("l3hVr");
var $32A7B = parcelRequire("32A7B");
var $3Yj72 = parcelRequire("3Yj72");
var $l5pHy = parcelRequire("l5pHy");
var $ieXhv = parcelRequire("ieXhv");

var $jdjqN = parcelRequire("jdjqN");
var $aYSwx = parcelRequire("aYSwx");
var $2jO8g = parcelRequire("2jO8g");
var $gKECY = parcelRequire("gKECY");
var $d4yBm = parcelRequire("d4yBm");
var $bkih4 = parcelRequire("bkih4");
var $bUnIF = parcelRequire("bUnIF");
var $f2mxj = parcelRequire("f2mxj");

var $cBSFr = parcelRequire("cBSFr");
var $eshwa = parcelRequire("eshwa");
var $jmEwm = parcelRequire("jmEwm");
var $9WwUc = parcelRequire("9WwUc");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $91fcfd915f89593c$var$WINDOW = (0, $inoaW.GLOBAL_OBJ);
const $91fcfd915f89593c$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $91fcfd915f89593c$var$REPLAY_EVENT_NAME = "replay_event";
const $91fcfd915f89593c$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $91fcfd915f89593c$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $91fcfd915f89593c$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $91fcfd915f89593c$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $91fcfd915f89593c$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $91fcfd915f89593c$var$BUFFER_CHECKOUT_TIME = 60000;
const $91fcfd915f89593c$var$RETRY_BASE_INTERVAL = 5000;
const $91fcfd915f89593c$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $91fcfd915f89593c$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $91fcfd915f89593c$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $91fcfd915f89593c$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $91fcfd915f89593c$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $91fcfd915f89593c$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $91fcfd915f89593c$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $91fcfd915f89593c$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $91fcfd915f89593c$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $91fcfd915f89593c$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $91fcfd915f89593c$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $91fcfd915f89593c$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($91fcfd915f89593c$var$NodeType$1 || ($91fcfd915f89593c$var$NodeType$1 = {}));
function $91fcfd915f89593c$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $91fcfd915f89593c$var$isShadowRoot(n) {
    const host = $91fcfd915f89593c$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($91fcfd915f89593c$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $91fcfd915f89593c$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $91fcfd915f89593c$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $91fcfd915f89593c$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $91fcfd915f89593c$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $91fcfd915f89593c$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $91fcfd915f89593c$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $91fcfd915f89593c$var$stringifyRule(rule) {
    let importStringified;
    if ($91fcfd915f89593c$var$isCSSImportRule(rule)) try {
        importStringified = $91fcfd915f89593c$var$stringifyStylesheet(rule.styleSheet) || $91fcfd915f89593c$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($91fcfd915f89593c$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $91fcfd915f89593c$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $91fcfd915f89593c$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $91fcfd915f89593c$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $91fcfd915f89593c$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $91fcfd915f89593c$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $91fcfd915f89593c$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $91fcfd915f89593c$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $91fcfd915f89593c$var$createMirror() {
    return new $91fcfd915f89593c$var$Mirror();
}
function $91fcfd915f89593c$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $91fcfd915f89593c$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $91fcfd915f89593c$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $91fcfd915f89593c$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $91fcfd915f89593c$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $91fcfd915f89593c$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $91fcfd915f89593c$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$91fcfd915f89593c$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $91fcfd915f89593c$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $91fcfd915f89593c$var$toLowerCase(type) : null;
}
function $91fcfd915f89593c$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $91fcfd915f89593c$var$_id = 1;
const $91fcfd915f89593c$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $91fcfd915f89593c$var$IGNORED_NODE = -2;
function $91fcfd915f89593c$var$genId() {
    return $91fcfd915f89593c$var$_id++;
}
function $91fcfd915f89593c$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $91fcfd915f89593c$var$toLowerCase(element.tagName);
    if ($91fcfd915f89593c$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $91fcfd915f89593c$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $91fcfd915f89593c$var$canvasService;
let $91fcfd915f89593c$var$canvasCtx;
const $91fcfd915f89593c$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $91fcfd915f89593c$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $91fcfd915f89593c$var$URL_WWW_MATCH = /^www\..*/i;
const $91fcfd915f89593c$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $91fcfd915f89593c$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($91fcfd915f89593c$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($91fcfd915f89593c$var$URL_PROTOCOL_MATCH.test(filePath) || $91fcfd915f89593c$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($91fcfd915f89593c$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$91fcfd915f89593c$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $91fcfd915f89593c$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $91fcfd915f89593c$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $91fcfd915f89593c$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($91fcfd915f89593c$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($91fcfd915f89593c$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $91fcfd915f89593c$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $91fcfd915f89593c$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $91fcfd915f89593c$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $91fcfd915f89593c$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $91fcfd915f89593c$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $91fcfd915f89593c$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $91fcfd915f89593c$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $91fcfd915f89593c$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $91fcfd915f89593c$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $91fcfd915f89593c$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $91fcfd915f89593c$var$absoluteToStylesheet(value, $91fcfd915f89593c$var$getHref());
    else if (tagName === "object" && name === "data") return $91fcfd915f89593c$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $91fcfd915f89593c$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $91fcfd915f89593c$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $91fcfd915f89593c$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $91fcfd915f89593c$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $91fcfd915f89593c$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $91fcfd915f89593c$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($91fcfd915f89593c$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $91fcfd915f89593c$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $91fcfd915f89593c$var$distanceToMatch(el, $91fcfd915f89593c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $91fcfd915f89593c$var$distanceToMatch(el, $91fcfd915f89593c$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $91fcfd915f89593c$var$distanceToMatch(el, $91fcfd915f89593c$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $91fcfd915f89593c$var$distanceToMatch(el, $91fcfd915f89593c$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $91fcfd915f89593c$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $91fcfd915f89593c$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $91fcfd915f89593c$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $91fcfd915f89593c$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $91fcfd915f89593c$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $91fcfd915f89593c$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $91fcfd915f89593c$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $91fcfd915f89593c$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $91fcfd915f89593c$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $91fcfd915f89593c$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $91fcfd915f89593c$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $91fcfd915f89593c$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $91fcfd915f89593c$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($91fcfd915f89593c$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $91fcfd915f89593c$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $91fcfd915f89593c$var$absoluteToStylesheet(textContent, $91fcfd915f89593c$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $91fcfd915f89593c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $91fcfd915f89593c$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $91fcfd915f89593c$var$maskInputValue({
            isMasked: $91fcfd915f89593c$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $91fcfd915f89593c$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $91fcfd915f89593c$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $91fcfd915f89593c$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $91fcfd915f89593c$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$91fcfd915f89593c$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $91fcfd915f89593c$var$transformAttribute(doc, tagName, $91fcfd915f89593c$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $91fcfd915f89593c$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $91fcfd915f89593c$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $91fcfd915f89593c$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $91fcfd915f89593c$var$absoluteToStylesheet(cssText, $91fcfd915f89593c$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $91fcfd915f89593c$var$getInputType(el);
        const value = $91fcfd915f89593c$var$getInputValue(el, $91fcfd915f89593c$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $91fcfd915f89593c$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $91fcfd915f89593c$var$shouldMaskInput({
                type: type,
                tagName: $91fcfd915f89593c$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $91fcfd915f89593c$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$91fcfd915f89593c$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$91fcfd915f89593c$var$canvasService) {
            $91fcfd915f89593c$var$canvasService = doc.createElement("canvas");
            $91fcfd915f89593c$var$canvasCtx = $91fcfd915f89593c$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $91fcfd915f89593c$var$canvasService.width = image.naturalWidth;
                $91fcfd915f89593c$var$canvasService.height = image.naturalHeight;
                $91fcfd915f89593c$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $91fcfd915f89593c$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $91fcfd915f89593c$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $91fcfd915f89593c$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $91fcfd915f89593c$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $91fcfd915f89593c$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $91fcfd915f89593c$var$NodeType$1.Comment) return true;
    else if (sn.type === $91fcfd915f89593c$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($91fcfd915f89593c$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "application-name" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.rel) === "icon" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($91fcfd915f89593c$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "robots" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "googlebot" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "author" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "generator" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "framework" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "publisher" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "progid" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "verification" || $91fcfd915f89593c$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $91fcfd915f89593c$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $91fcfd915f89593c$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($91fcfd915f89593c$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $91fcfd915f89593c$var$IGNORED_NODE;
    else id = $91fcfd915f89593c$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $91fcfd915f89593c$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $91fcfd915f89593c$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Document || serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $91fcfd915f89593c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($91fcfd915f89593c$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $91fcfd915f89593c$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $91fcfd915f89593c$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $91fcfd915f89593c$var$isShadowRoot(n.parentNode) && $91fcfd915f89593c$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Element && serializedNode.tagName === "iframe") $91fcfd915f89593c$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $91fcfd915f89593c$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $91fcfd915f89593c$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $91fcfd915f89593c$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $91fcfd915f89593c$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $91fcfd915f89593c$var$snapshot(n, options) {
    const { mirror: mirror = new $91fcfd915f89593c$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $91fcfd915f89593c$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $91fcfd915f89593c$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $91fcfd915f89593c$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $91fcfd915f89593c$var$_mirror = {
    map: {},
    getId () {
        console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $91fcfd915f89593c$var$_mirror = new Proxy($91fcfd915f89593c$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($91fcfd915f89593c$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $91fcfd915f89593c$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $91fcfd915f89593c$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $91fcfd915f89593c$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $91fcfd915f89593c$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $91fcfd915f89593c$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$91fcfd915f89593c$var$hookSetter(target, key, original || {}, true);
}
function $91fcfd915f89593c$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $91fcfd915f89593c$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $91fcfd915f89593c$var$nowTimestamp = ()=>new Date().getTime();
function $91fcfd915f89593c$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $91fcfd915f89593c$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $91fcfd915f89593c$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $91fcfd915f89593c$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $91fcfd915f89593c$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $91fcfd915f89593c$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $91fcfd915f89593c$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $91fcfd915f89593c$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $91fcfd915f89593c$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $91fcfd915f89593c$var$distanceToMatch(el, $91fcfd915f89593c$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $91fcfd915f89593c$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $91fcfd915f89593c$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $91fcfd915f89593c$var$IGNORED_NODE;
}
function $91fcfd915f89593c$var$isAncestorRemoved(target, mirror) {
    if ($91fcfd915f89593c$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $91fcfd915f89593c$var$isAncestorRemoved(target.parentNode, mirror);
}
function $91fcfd915f89593c$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $91fcfd915f89593c$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $91fcfd915f89593c$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $91fcfd915f89593c$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $91fcfd915f89593c$var$hasShadowRoot(n) {
    return Boolean($91fcfd915f89593c$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $91fcfd915f89593c$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $fFkWd._nullishCoalesce)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $91fcfd915f89593c$var$getShadowHost(n) {
    let shadowHost = null;
    if ($91fcfd915f89593c$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $91fcfd915f89593c$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $91fcfd915f89593c$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $91fcfd915f89593c$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $91fcfd915f89593c$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $91fcfd915f89593c$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $91fcfd915f89593c$var$shadowHostInDom(n);
}
const $91fcfd915f89593c$var$cachedImplementations = {};
function $91fcfd915f89593c$var$getImplementation(name) {
    const cached = $91fcfd915f89593c$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $91fcfd915f89593c$var$cachedImplementations[name] = impl.bind(window);
}
function $91fcfd915f89593c$var$onRequestAnimationFrame(...rest) {
    return $91fcfd915f89593c$var$getImplementation("requestAnimationFrame")(...rest);
}
function $91fcfd915f89593c$var$setTimeout$1(...rest) {
    return $91fcfd915f89593c$var$getImplementation("setTimeout")(...rest);
}
function $91fcfd915f89593c$var$clearTimeout$1(...rest) {
    return $91fcfd915f89593c$var$getImplementation("clearTimeout")(...rest);
}
var $91fcfd915f89593c$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($91fcfd915f89593c$var$EventType || {});
var $91fcfd915f89593c$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($91fcfd915f89593c$var$IncrementalSource || {});
var $91fcfd915f89593c$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($91fcfd915f89593c$var$MouseInteractions || {});
var $91fcfd915f89593c$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($91fcfd915f89593c$var$PointerTypes || {});
function $91fcfd915f89593c$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $91fcfd915f89593c$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $91fcfd915f89593c$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $91fcfd915f89593c$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $91fcfd915f89593c$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $91fcfd915f89593c$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $91fcfd915f89593c$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $91fcfd915f89593c$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $91fcfd915f89593c$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $91fcfd915f89593c$var$IGNORED_NODE;
                while(nextId === $91fcfd915f89593c$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$91fcfd915f89593c$var$inDom(n)) return;
                const parentId = $91fcfd915f89593c$var$isShadowRoot(n.parentNode) ? this.mirror.getId($91fcfd915f89593c$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $91fcfd915f89593c$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($91fcfd915f89593c$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($91fcfd915f89593c$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($91fcfd915f89593c$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($91fcfd915f89593c$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$91fcfd915f89593c$var$isAncestorInSet(this.droppedSet, n) && !$91fcfd915f89593c$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($91fcfd915f89593c$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($91fcfd915f89593c$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$91fcfd915f89593c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $91fcfd915f89593c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $91fcfd915f89593c$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $91fcfd915f89593c$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $91fcfd915f89593c$var$getInputValue(target, tagName, type);
                            const isInputMasked = $91fcfd915f89593c$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $91fcfd915f89593c$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $91fcfd915f89593c$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($91fcfd915f89593c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$91fcfd915f89593c$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $91fcfd915f89593c$var$transformAttribute(this.doc, $91fcfd915f89593c$var$toLowerCase(target.tagName), $91fcfd915f89593c$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($91fcfd915f89593c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $91fcfd915f89593c$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($91fcfd915f89593c$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $91fcfd915f89593c$var$isIgnored(n, this.mirror) || !$91fcfd915f89593c$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $91fcfd915f89593c$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($91fcfd915f89593c$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$91fcfd915f89593c$var$moveKey(nodeId, parentId)]) $91fcfd915f89593c$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $91fcfd915f89593c$var$isShadowRoot(m.target) && $91fcfd915f89593c$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($91fcfd915f89593c$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$91fcfd915f89593c$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$91fcfd915f89593c$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($91fcfd915f89593c$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $91fcfd915f89593c$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$91fcfd915f89593c$var$deepDelete(addsSet, childN));
}
function $91fcfd915f89593c$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $91fcfd915f89593c$var$_isParentRemoved(removes, n, mirror);
}
function $91fcfd915f89593c$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $91fcfd915f89593c$var$_isParentRemoved(removes, parentNode, mirror);
}
function $91fcfd915f89593c$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $91fcfd915f89593c$var$_isAncestorInSet(set, n);
}
function $91fcfd915f89593c$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $91fcfd915f89593c$var$_isAncestorInSet(set, parentNode);
}
let $91fcfd915f89593c$var$errorHandler;
function $91fcfd915f89593c$var$registerErrorHandler(handler) {
    $91fcfd915f89593c$var$errorHandler = handler;
}
function $91fcfd915f89593c$var$unregisterErrorHandler() {
    $91fcfd915f89593c$var$errorHandler = undefined;
}
const $91fcfd915f89593c$var$callbackWrapper = (cb)=>{
    if (!$91fcfd915f89593c$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($91fcfd915f89593c$var$errorHandler && $91fcfd915f89593c$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $91fcfd915f89593c$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $91fcfd915f89593c$var$mutationBuffers = [];
function $91fcfd915f89593c$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $91fcfd915f89593c$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $91fcfd915f89593c$var$MutationBuffer();
    $91fcfd915f89593c$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $91fcfd915f89593c$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($91fcfd915f89593c$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $91fcfd915f89593c$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $91fcfd915f89593c$var$throttle$1($91fcfd915f89593c$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $91fcfd915f89593c$var$callbackWrapper($91fcfd915f89593c$var$throttle$1($91fcfd915f89593c$var$callbackWrapper((evt)=>{
        const target = $91fcfd915f89593c$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $91fcfd915f89593c$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $91fcfd915f89593c$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $91fcfd915f89593c$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $91fcfd915f89593c$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $91fcfd915f89593c$var$IncrementalSource.MouseMove : $91fcfd915f89593c$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $91fcfd915f89593c$var$on("mousemove", updatePosition, doc),
        $91fcfd915f89593c$var$on("touchmove", updatePosition, doc),
        $91fcfd915f89593c$var$on("drag", updatePosition, doc)
    ];
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $91fcfd915f89593c$var$getEventTarget(event);
            if ($91fcfd915f89593c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $91fcfd915f89593c$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $91fcfd915f89593c$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $91fcfd915f89593c$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $91fcfd915f89593c$var$PointerTypes.Touch) {
                    if ($91fcfd915f89593c$var$MouseInteractions[eventKey] === $91fcfd915f89593c$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($91fcfd915f89593c$var$MouseInteractions[eventKey] === $91fcfd915f89593c$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $91fcfd915f89593c$var$PointerTypes.Pen;
            } else if ($91fcfd915f89593c$var$legacy_isTouchEvent(event)) pointerType = $91fcfd915f89593c$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $91fcfd915f89593c$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $91fcfd915f89593c$var$PointerTypes.Mouse) pointerType = null;
            } else if ($91fcfd915f89593c$var$MouseInteractions[eventKey] === $91fcfd915f89593c$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $91fcfd915f89593c$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $91fcfd915f89593c$var$callbackWrapper(mouseInteractionCb)({
                type: $91fcfd915f89593c$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($91fcfd915f89593c$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $91fcfd915f89593c$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($91fcfd915f89593c$var$MouseInteractions[eventKey]){
            case $91fcfd915f89593c$var$MouseInteractions.MouseDown:
            case $91fcfd915f89593c$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $91fcfd915f89593c$var$MouseInteractions.TouchStart:
            case $91fcfd915f89593c$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($91fcfd915f89593c$var$on(eventName, handler, doc));
    });
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $91fcfd915f89593c$var$callbackWrapper($91fcfd915f89593c$var$throttle$1($91fcfd915f89593c$var$callbackWrapper((evt)=>{
        const target = $91fcfd915f89593c$var$getEventTarget(evt);
        if (!target || $91fcfd915f89593c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $91fcfd915f89593c$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $91fcfd915f89593c$var$on("scroll", updatePosition, doc);
}
function $91fcfd915f89593c$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $91fcfd915f89593c$var$callbackWrapper($91fcfd915f89593c$var$throttle$1($91fcfd915f89593c$var$callbackWrapper(()=>{
        const height = $91fcfd915f89593c$var$getWindowHeight();
        const width = $91fcfd915f89593c$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $91fcfd915f89593c$var$on("resize", updateDimension, win);
}
const $91fcfd915f89593c$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $91fcfd915f89593c$var$lastInputValueMap = new WeakMap();
function $91fcfd915f89593c$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $91fcfd915f89593c$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $91fcfd915f89593c$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $91fcfd915f89593c$var$INPUT_TAGS.indexOf(tagName) < 0 || $91fcfd915f89593c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $91fcfd915f89593c$var$getInputType(target);
        let text = $91fcfd915f89593c$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $91fcfd915f89593c$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $91fcfd915f89593c$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $91fcfd915f89593c$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $91fcfd915f89593c$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $91fcfd915f89593c$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $91fcfd915f89593c$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $91fcfd915f89593c$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $91fcfd915f89593c$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$91fcfd915f89593c$var$on(eventName, $91fcfd915f89593c$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$91fcfd915f89593c$var$hookSetter(p[0], p[1], {
            set () {
                $91fcfd915f89593c$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($91fcfd915f89593c$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $91fcfd915f89593c$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $91fcfd915f89593c$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $91fcfd915f89593c$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $91fcfd915f89593c$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $91fcfd915f89593c$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($91fcfd915f89593c$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($91fcfd915f89593c$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($91fcfd915f89593c$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($91fcfd915f89593c$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$91fcfd915f89593c$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$91fcfd915f89593c$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $91fcfd915f89593c$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $91fcfd915f89593c$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $91fcfd915f89593c$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $91fcfd915f89593c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($91fcfd915f89593c$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $91fcfd915f89593c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $91fcfd915f89593c$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $91fcfd915f89593c$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId($91fcfd915f89593c$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $91fcfd915f89593c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $91fcfd915f89593c$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $91fcfd915f89593c$var$getIdAndStyleId($91fcfd915f89593c$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $91fcfd915f89593c$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $91fcfd915f89593c$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $91fcfd915f89593c$var$callbackWrapper((type)=>$91fcfd915f89593c$var$throttle$1($91fcfd915f89593c$var$callbackWrapper((event)=>{
            const target = $91fcfd915f89593c$var$getEventTarget(event);
            if (!target || $91fcfd915f89593c$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $91fcfd915f89593c$var$on("play", handler(0), doc),
        $91fcfd915f89593c$var$on("pause", handler(1), doc),
        $91fcfd915f89593c$var$on("seeked", handler(2), doc),
        $91fcfd915f89593c$var$on("volumechange", handler(3), doc),
        $91fcfd915f89593c$var$on("ratechange", handler(4), doc)
    ];
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $91fcfd915f89593c$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $91fcfd915f89593c$var$setTimeout$1($91fcfd915f89593c$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $91fcfd915f89593c$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $91fcfd915f89593c$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $91fcfd915f89593c$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $91fcfd915f89593c$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $91fcfd915f89593c$var$on("selectionchange", updateSelection);
}
function $91fcfd915f89593c$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $91fcfd915f89593c$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $91fcfd915f89593c$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $91fcfd915f89593c$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $91fcfd915f89593c$var$initMoveObserver(o);
    const mouseInteractionHandler = $91fcfd915f89593c$var$initMouseInteractionObserver(o);
    const scrollHandler = $91fcfd915f89593c$var$initScrollObserver(o);
    const viewportResizeHandler = $91fcfd915f89593c$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $91fcfd915f89593c$var$initInputObserver(o);
    const mediaInteractionHandler = $91fcfd915f89593c$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $91fcfd915f89593c$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $91fcfd915f89593c$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $91fcfd915f89593c$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $91fcfd915f89593c$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $91fcfd915f89593c$var$initSelectionObserver(o);
    const customElementObserver = $91fcfd915f89593c$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $91fcfd915f89593c$var$callbackWrapper(()=>{
        $91fcfd915f89593c$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $91fcfd915f89593c$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $91fcfd915f89593c$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $91fcfd915f89593c$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $91fcfd915f89593c$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $91fcfd915f89593c$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $91fcfd915f89593c$var$CrossOriginIframeMirror($91fcfd915f89593c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $91fcfd915f89593c$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $91fcfd915f89593c$var$CrossOriginIframeMirror($91fcfd915f89593c$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $91fcfd915f89593c$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $91fcfd915f89593c$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $91fcfd915f89593c$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $91fcfd915f89593c$var$EventType.Meta:
            case $91fcfd915f89593c$var$EventType.Load:
            case $91fcfd915f89593c$var$EventType.DomContentLoaded:
                return false;
            case $91fcfd915f89593c$var$EventType.Plugin:
                return e;
            case $91fcfd915f89593c$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $91fcfd915f89593c$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $91fcfd915f89593c$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.Drag:
                    case $91fcfd915f89593c$var$IncrementalSource.TouchMove:
                    case $91fcfd915f89593c$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.ViewportResize:
                        return false;
                    case $91fcfd915f89593c$var$IncrementalSource.MediaInteraction:
                    case $91fcfd915f89593c$var$IncrementalSource.MouseInteraction:
                    case $91fcfd915f89593c$var$IncrementalSource.Scroll:
                    case $91fcfd915f89593c$var$IncrementalSource.CanvasMutation:
                    case $91fcfd915f89593c$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.StyleSheetRule:
                    case $91fcfd915f89593c$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.Font:
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $91fcfd915f89593c$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $91fcfd915f89593c$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $91fcfd915f89593c$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $91fcfd915f89593c$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $91fcfd915f89593c$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$91fcfd915f89593c$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $91fcfd915f89593c$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($91fcfd915f89593c$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $91fcfd915f89593c$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($91fcfd915f89593c$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($91fcfd915f89593c$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $91fcfd915f89593c$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $91fcfd915f89593c$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $91fcfd915f89593c$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $91fcfd915f89593c$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $91fcfd915f89593c$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $91fcfd915f89593c$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $91fcfd915f89593c$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $91fcfd915f89593c$var$wrappedEmit;
let $91fcfd915f89593c$var$_takeFullSnapshot;
const $91fcfd915f89593c$var$mirror = $91fcfd915f89593c$var$createMirror();
function $91fcfd915f89593c$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $91fcfd915f89593c$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $91fcfd915f89593c$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $91fcfd915f89593c$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $91fcfd915f89593c$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $91fcfd915f89593c$var$nowTimestamp();
        if ((0, $6ZXTI._optionalChain)([
            $91fcfd915f89593c$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $91fcfd915f89593c$var$EventType.FullSnapshot && !(e.type === $91fcfd915f89593c$var$EventType.IncrementalSnapshot && e.data.source === $91fcfd915f89593c$var$IncrementalSource.Mutation)) $91fcfd915f89593c$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $6ZXTI._optionalChain)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $91fcfd915f89593c$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $91fcfd915f89593c$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $91fcfd915f89593c$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
            data: {
                source: $91fcfd915f89593c$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
            data: {
                source: $91fcfd915f89593c$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
            data: {
                source: $91fcfd915f89593c$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
            data: {
                source: $91fcfd915f89593c$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $91fcfd915f89593c$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $91fcfd915f89593c$var$IframeManagerNoop() : new $91fcfd915f89593c$var$IframeManager({
        mirror: $91fcfd915f89593c$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $91fcfd915f89593c$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $91fcfd915f89593c$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $91fcfd915f89593c$var$ProcessedNodeManager();
    const canvasManager = $91fcfd915f89593c$var$_getCanvasManager(getCanvasManager, {
        mirror: $91fcfd915f89593c$var$mirror,
        win: window,
        mutationCb: (p)=>$91fcfd915f89593c$var$wrappedEmit({
                type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                data: {
                    source: $91fcfd915f89593c$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $91fcfd915f89593c$var$ShadowDomManagerNoop() : new $91fcfd915f89593c$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $91fcfd915f89593c$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $91fcfd915f89593c$var$getWindowWidth(),
                height: $91fcfd915f89593c$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $91fcfd915f89593c$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $91fcfd915f89593c$var$snapshot(document, {
            mirror: $91fcfd915f89593c$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($91fcfd915f89593c$var$isSerializedIframe(n, $91fcfd915f89593c$var$mirror)) iframeManager.addIframe(n);
                if ($91fcfd915f89593c$var$isSerializedStylesheet(n, $91fcfd915f89593c$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($91fcfd915f89593c$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $91fcfd915f89593c$var$wrappedEmit({
            type: $91fcfd915f89593c$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $91fcfd915f89593c$var$getWindowScroll(window)
            }
        });
        $91fcfd915f89593c$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $91fcfd915f89593c$var$mirror.getId(document));
    };
    $91fcfd915f89593c$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $91fcfd915f89593c$var$callbackWrapper($91fcfd915f89593c$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $91fcfd915f89593c$var$wrappedEmit({
                        type: $91fcfd915f89593c$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $91fcfd915f89593c$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $91fcfd915f89593c$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $6ZXTI._optionalChain)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$91fcfd915f89593c$var$wrappedEmit({
                                        type: $91fcfd915f89593c$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($91fcfd915f89593c$var$on("DOMContentLoaded", ()=>{
                $91fcfd915f89593c$var$wrappedEmit({
                    type: $91fcfd915f89593c$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($91fcfd915f89593c$var$on("load", ()=>{
                $91fcfd915f89593c$var$wrappedEmit({
                    type: $91fcfd915f89593c$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $91fcfd915f89593c$var$_takeFullSnapshot = undefined;
            $91fcfd915f89593c$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $91fcfd915f89593c$var$takeFullSnapshot(isCheckout) {
    if (!$91fcfd915f89593c$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $91fcfd915f89593c$var$_takeFullSnapshot(isCheckout);
}
$91fcfd915f89593c$var$record.mirror = $91fcfd915f89593c$var$mirror;
$91fcfd915f89593c$var$record.takeFullSnapshot = $91fcfd915f89593c$var$takeFullSnapshot;
function $91fcfd915f89593c$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $91fcfd915f89593c$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $91fcfd915f89593c$var$CanvasManagerNoop();
    }
}
const $91fcfd915f89593c$var$ReplayEventTypeIncrementalSnapshot = 3;
const $91fcfd915f89593c$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $91fcfd915f89593c$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $91fcfd915f89593c$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $91fcfd915f89593c$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $91fcfd915f89593c$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $32A7B.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $91fcfd915f89593c$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $91fcfd915f89593c$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($91fcfd915f89593c$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $91fcfd915f89593c$var$getClickTargetNode(event) {
    const target = $91fcfd915f89593c$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $91fcfd915f89593c$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $91fcfd915f89593c$var$getTargetNode(event) {
    if ($91fcfd915f89593c$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $91fcfd915f89593c$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $91fcfd915f89593c$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $91fcfd915f89593c$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$91fcfd915f89593c$var$handlers) {
        $91fcfd915f89593c$var$handlers = [];
        $91fcfd915f89593c$var$monkeyPatchWindowOpen();
    }
    $91fcfd915f89593c$var$handlers.push(cb);
    return ()=>{
        const pos = $91fcfd915f89593c$var$handlers ? $91fcfd915f89593c$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $91fcfd915f89593c$var$handlers.splice(pos, 1);
    };
}
function $91fcfd915f89593c$var$monkeyPatchWindowOpen() {
    (0, $9Nu6W.fill)($91fcfd915f89593c$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($91fcfd915f89593c$var$handlers) try {
                $91fcfd915f89593c$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($91fcfd915f89593c$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $91fcfd915f89593c$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $91fcfd915f89593c$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $91fcfd915f89593c$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $91fcfd915f89593c$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $91fcfd915f89593c$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($91fcfd915f89593c$var$ignoreElement(node, this._ignoreSelector) || !$91fcfd915f89593c$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $91fcfd915f89593c$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $91fcfd915f89593c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $91fcfd915f89593c$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $91fcfd915f89593c$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $91fcfd915f89593c$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $91fcfd915f89593c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $91fcfd915f89593c$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $91fcfd915f89593c$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $91fcfd915f89593c$var$ignoreElement(node, ignoreSelector) {
    if (!$91fcfd915f89593c$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $91fcfd915f89593c$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $91fcfd915f89593c$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $91fcfd915f89593c$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$91fcfd915f89593c$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $91fcfd915f89593c$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $91fcfd915f89593c$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($91fcfd915f89593c$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $91fcfd915f89593c$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $91fcfd915f89593c$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $91fcfd915f89593c$var$isIncrementalEvent(event) {
    return event.type === $91fcfd915f89593c$var$ReplayEventTypeIncrementalSnapshot;
}
function $91fcfd915f89593c$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $91fcfd915f89593c$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $91fcfd915f89593c$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $91fcfd915f89593c$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($91fcfd915f89593c$var$NodeType || ($91fcfd915f89593c$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $91fcfd915f89593c$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $91fcfd915f89593c$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) attributes["data-sentry-component"] = attributes["data-sentry-element"];
    for(const key in attributes)if ($91fcfd915f89593c$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $91fcfd915f89593c$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $91fcfd915f89593c$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $91fcfd915f89593c$var$handleClick(replay.clickDetector, result, $91fcfd915f89593c$var$getClickTargetNode(handlerData.event));
        $91fcfd915f89593c$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $91fcfd915f89593c$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $91fcfd915f89593c$var$record.mirror.getId(target);
    const node = nodeId && $91fcfd915f89593c$var$record.mirror.getNode(nodeId);
    const meta = node && $91fcfd915f89593c$var$record.mirror.getMeta(node);
    const element = meta && $91fcfd915f89593c$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $91fcfd915f89593c$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $91fcfd915f89593c$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $91fcfd915f89593c$var$handleDom(handlerData) {
    const { target: target, message: message } = $91fcfd915f89593c$var$getDomTarget(handlerData);
    return $91fcfd915f89593c$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$91fcfd915f89593c$var$getBaseDomBreadcrumb(target, message)
    });
}
function $91fcfd915f89593c$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $91fcfd915f89593c$var$getClickTargetNode(handlerData.event) : $91fcfd915f89593c$var$getTargetNode(handlerData.event);
        message = (0, $bwpQP.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $91fcfd915f89593c$var$isElement(node) {
    return node.type === $91fcfd915f89593c$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $91fcfd915f89593c$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $91fcfd915f89593c$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $91fcfd915f89593c$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $91fcfd915f89593c$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $91fcfd915f89593c$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $bwpQP.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $91fcfd915f89593c$var$getBaseDomBreadcrumb(target, message);
    return $91fcfd915f89593c$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $91fcfd915f89593c$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $91fcfd915f89593c$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $91fcfd915f89593c$var$createResourceEntry,
    paint: $91fcfd915f89593c$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $91fcfd915f89593c$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $91fcfd915f89593c$var$createPerformanceEntries(entries) {
    return entries.map($91fcfd915f89593c$var$createPerformanceEntry).filter(Boolean);
}
function $91fcfd915f89593c$var$createPerformanceEntry(entry) {
    if (!$91fcfd915f89593c$var$ENTRY_TYPES[entry.entryType]) return null;
    return $91fcfd915f89593c$var$ENTRY_TYPES[entry.entryType](entry);
}
function $91fcfd915f89593c$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $iYIMl.browserPerformanceTimeOrigin) || $91fcfd915f89593c$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $91fcfd915f89593c$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $91fcfd915f89593c$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $91fcfd915f89593c$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $91fcfd915f89593c$var$getAbsoluteTime(startTime),
        end: $91fcfd915f89593c$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $91fcfd915f89593c$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $91fcfd915f89593c$var$getAbsoluteTime(startTime),
        end: $91fcfd915f89593c$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $91fcfd915f89593c$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $91fcfd915f89593c$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $91fcfd915f89593c$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $91fcfd915f89593c$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $jmEwm.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, $jmEwm.addLcpInstrumentationHandler)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($91fcfd915f89593c$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $91fcfd915f89593c$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $91fcfd915f89593c$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(J)return J.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $91fcfd915f89593c$var$e() {
    const e = new Blob([
        $91fcfd915f89593c$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $91fcfd915f89593c$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$91fcfd915f89593c$var$DEBUG_BUILD) return;
    (0, $eN7RA.logger).info(message);
    if (shouldAddBreadcrumb) $91fcfd915f89593c$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $91fcfd915f89593c$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$91fcfd915f89593c$var$DEBUG_BUILD) return;
    (0, $eN7RA.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $91fcfd915f89593c$var$addLogBreadcrumb(message);
    }, 0);
}
function $91fcfd915f89593c$var$addLogBreadcrumb(message) {
    (0, $jdjqN.addBreadcrumb)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $91fcfd915f89593c$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$91fcfd915f89593c$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $91fcfd915f89593c$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $91fcfd915f89593c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $91fcfd915f89593c$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $91fcfd915f89593c$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $91fcfd915f89593c$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $91fcfd915f89593c$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $91fcfd915f89593c$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $91fcfd915f89593c$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $91fcfd915f89593c$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $91fcfd915f89593c$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $91fcfd915f89593c$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $91fcfd915f89593c$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $91fcfd915f89593c$var$EventBufferArray();
        this._compression = new $91fcfd915f89593c$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $91fcfd915f89593c$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $91fcfd915f89593c$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $91fcfd915f89593c$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $91fcfd915f89593c$var$logInfo("[Replay] Using simple buffer");
    return new $91fcfd915f89593c$var$EventBufferArray();
}
function $91fcfd915f89593c$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $91fcfd915f89593c$var$_getWorkerUrl();
        if (!workerUrl) return;
        $91fcfd915f89593c$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $91fcfd915f89593c$var$EventBufferProxy(worker);
    } catch (error) {
        $91fcfd915f89593c$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $91fcfd915f89593c$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $91fcfd915f89593c$var$e();
    return "";
}
/** If sessionStorage is available. */ function $91fcfd915f89593c$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $91fcfd915f89593c$var$WINDOW && !!$91fcfd915f89593c$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $91fcfd915f89593c$var$clearSession(replay) {
    $91fcfd915f89593c$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $91fcfd915f89593c$var$deleteSession() {
    if (!$91fcfd915f89593c$var$hasSessionStorage()) return;
    try {
        $91fcfd915f89593c$var$WINDOW.sessionStorage.removeItem($91fcfd915f89593c$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $91fcfd915f89593c$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $91fcfd915f89593c$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $ieXhv.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $91fcfd915f89593c$var$saveSession(session) {
    if (!$91fcfd915f89593c$var$hasSessionStorage()) return;
    try {
        $91fcfd915f89593c$var$WINDOW.sessionStorage.setItem($91fcfd915f89593c$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $91fcfd915f89593c$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $91fcfd915f89593c$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $91fcfd915f89593c$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $91fcfd915f89593c$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $91fcfd915f89593c$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $91fcfd915f89593c$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $91fcfd915f89593c$var$fetchSession(traceInternals) {
    if (!$91fcfd915f89593c$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $91fcfd915f89593c$var$WINDOW.sessionStorage.getItem($91fcfd915f89593c$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $91fcfd915f89593c$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $91fcfd915f89593c$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $91fcfd915f89593c$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $91fcfd915f89593c$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $91fcfd915f89593c$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $91fcfd915f89593c$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $91fcfd915f89593c$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$91fcfd915f89593c$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $91fcfd915f89593c$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $91fcfd915f89593c$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $91fcfd915f89593c$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $91fcfd915f89593c$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$91fcfd915f89593c$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $91fcfd915f89593c$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $91fcfd915f89593c$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $91fcfd915f89593c$var$isCustomEvent(event) {
    return event.type === $91fcfd915f89593c$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $91fcfd915f89593c$var$addEventSync(replay, event, isCheckout) {
    if (!$91fcfd915f89593c$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $91fcfd915f89593c$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $91fcfd915f89593c$var$addEvent(replay, event, isCheckout) {
    if (!$91fcfd915f89593c$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $91fcfd915f89593c$var$_addEvent(replay, event, isCheckout);
}
async function $91fcfd915f89593c$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $91fcfd915f89593c$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $91fcfd915f89593c$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $gKECY.getClient)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $91fcfd915f89593c$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $91fcfd915f89593c$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $91fcfd915f89593c$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $91fcfd915f89593c$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $91fcfd915f89593c$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $91fcfd915f89593c$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $91fcfd915f89593c$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $91fcfd915f89593c$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $91fcfd915f89593c$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $91fcfd915f89593c$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$91fcfd915f89593c$var$isErrorEvent(event) && !$91fcfd915f89593c$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($91fcfd915f89593c$var$isTransactionEvent(event)) {
            $91fcfd915f89593c$var$handleTransactionEvent(replay, event);
            return;
        }
        $91fcfd915f89593c$var$handleErrorEvent(replay, event);
    };
}
function $91fcfd915f89593c$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $91fcfd915f89593c$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $91fcfd915f89593c$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$91fcfd915f89593c$var$isErrorEvent(event)) return;
        $91fcfd915f89593c$var$handleHydrationError(replay, event);
    };
}
function $91fcfd915f89593c$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $91fcfd915f89593c$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $91fcfd915f89593c$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $91fcfd915f89593c$var$handleBreadcrumbs(replay) {
    const client = (0, $gKECY.getClient)();
    if (!client) return;
    client.on("beforeAddBreadcrumb", (breadcrumb)=>$91fcfd915f89593c$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $91fcfd915f89593c$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$91fcfd915f89593c$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $91fcfd915f89593c$var$normalizeBreadcrumb(breadcrumb);
    if (result) $91fcfd915f89593c$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $91fcfd915f89593c$var$normalizeBreadcrumb(breadcrumb) {
    if (!$91fcfd915f89593c$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        "fetch",
        "xhr",
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        "sentry.event",
        "sentry.transaction"
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith("ui.")) return null;
    if (breadcrumb.category === "console") return $91fcfd915f89593c$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $91fcfd915f89593c$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $91fcfd915f89593c$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $91fcfd915f89593c$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $91fcfd915f89593c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $91fcfd915f89593c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $32A7B.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $91fcfd915f89593c$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $91fcfd915f89593c$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $91fcfd915f89593c$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
function $91fcfd915f89593c$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $91fcfd915f89593c$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $91fcfd915f89593c$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $91fcfd915f89593c$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $91fcfd915f89593c$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $91fcfd915f89593c$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $91fcfd915f89593c$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $91fcfd915f89593c$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($91fcfd915f89593c$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$91fcfd915f89593c$var$isErrorEvent(event) && !$91fcfd915f89593c$var$isTransactionEvent(event) && !$91fcfd915f89593c$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($91fcfd915f89593c$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $91fcfd915f89593c$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($91fcfd915f89593c$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $91fcfd915f89593c$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $91fcfd915f89593c$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $91fcfd915f89593c$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $91fcfd915f89593c$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $91fcfd915f89593c$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $91fcfd915f89593c$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $91fcfd915f89593c$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $91fcfd915f89593c$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($91fcfd915f89593c$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $d4yBm.isSentryRequestUrl)(url, (0, $gKECY.getClient)());
}
/** Add a performance entry breadcrumb */ function $91fcfd915f89593c$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($91fcfd915f89593c$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $91fcfd915f89593c$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $91fcfd915f89593c$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $91fcfd915f89593c$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $91fcfd915f89593c$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $91fcfd915f89593c$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $91fcfd915f89593c$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $91fcfd915f89593c$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $91fcfd915f89593c$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $9Nu6W.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $91fcfd915f89593c$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $91fcfd915f89593c$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $91fcfd915f89593c$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $91fcfd915f89593c$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $91fcfd915f89593c$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $91fcfd915f89593c$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $91fcfd915f89593c$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $91fcfd915f89593c$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $91fcfd915f89593c$var$urlMatches(url, urls) {
    const fullUrl = $91fcfd915f89593c$var$getFullUrl(url);
    return (0, $l5pHy.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $91fcfd915f89593c$var$getFullUrl(url, baseURI = $91fcfd915f89593c$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($91fcfd915f89593c$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $91fcfd915f89593c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $91fcfd915f89593c$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $91fcfd915f89593c$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $91fcfd915f89593c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $91fcfd915f89593c$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $91fcfd915f89593c$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $91fcfd915f89593c$var$getBodySize(body);
    const resSize = response ? $91fcfd915f89593c$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $91fcfd915f89593c$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $91fcfd915f89593c$var$urlMatches(url, options.networkDetailAllowUrls) && !$91fcfd915f89593c$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $91fcfd915f89593c$var$_getRequestInfo(options, hint.input, requestBodySize) : $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $91fcfd915f89593c$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $91fcfd915f89593c$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $91fcfd915f89593c$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $91fcfd915f89593c$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $91fcfd915f89593c$var$getBodyString(requestBody);
    const data = $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $91fcfd915f89593c$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $91fcfd915f89593c$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $91fcfd915f89593c$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $91fcfd915f89593c$var$_parseFetchResponseBody(response);
    const result = $91fcfd915f89593c$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $91fcfd915f89593c$var$mergeWarning(result, warning);
    return result;
}
function $91fcfd915f89593c$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $91fcfd915f89593c$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $91fcfd915f89593c$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $91fcfd915f89593c$var$_parseFetchResponseBody(response) {
    const res = $91fcfd915f89593c$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $91fcfd915f89593c$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $91fcfd915f89593c$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $91fcfd915f89593c$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $91fcfd915f89593c$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $91fcfd915f89593c$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $91fcfd915f89593c$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $91fcfd915f89593c$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $91fcfd915f89593c$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $91fcfd915f89593c$var$getAllowedHeaders(headers, allowedHeaders);
}
function $91fcfd915f89593c$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $91fcfd915f89593c$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $91fcfd915f89593c$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $91fcfd915f89593c$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $91fcfd915f89593c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $91fcfd915f89593c$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $91fcfd915f89593c$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $91fcfd915f89593c$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $91fcfd915f89593c$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $91fcfd915f89593c$var$getBodySize(input);
    const resSize = xhr.getResponseHeader("content-length") ? $91fcfd915f89593c$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $91fcfd915f89593c$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $91fcfd915f89593c$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$91fcfd915f89593c$var$urlMatches(url, options.networkDetailAllowUrls) || $91fcfd915f89593c$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $91fcfd915f89593c$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $9WwUc.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $91fcfd915f89593c$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $91fcfd915f89593c$var$getAllowedHeaders($91fcfd915f89593c$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $91fcfd915f89593c$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $91fcfd915f89593c$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $91fcfd915f89593c$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $91fcfd915f89593c$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $91fcfd915f89593c$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $91fcfd915f89593c$var$mergeWarning(response, responseWarning) : response
    };
}
function $91fcfd915f89593c$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $91fcfd915f89593c$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $91fcfd915f89593c$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $91fcfd915f89593c$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $91fcfd915f89593c$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $91fcfd915f89593c$var$getBodySize(bodyStr);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $91fcfd915f89593c$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $gKECY.getClient)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$91fcfd915f89593c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $91fcfd915f89593c$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($91fcfd915f89593c$var$_isXhrBreadcrumb(breadcrumb) && $91fcfd915f89593c$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $91fcfd915f89593c$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $91fcfd915f89593c$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($91fcfd915f89593c$var$_isFetchBreadcrumb(breadcrumb) && $91fcfd915f89593c$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $91fcfd915f89593c$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $91fcfd915f89593c$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("Error when enriching network breadcrumb");
    }
}
function $91fcfd915f89593c$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $91fcfd915f89593c$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $91fcfd915f89593c$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $91fcfd915f89593c$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $91fcfd915f89593c$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $gKECY.getClient)();
    (0, $cBSFr.addClickKeypressInstrumentationHandler)($91fcfd915f89593c$var$handleDomListener(replay));
    (0, $eshwa.addHistoryInstrumentationHandler)($91fcfd915f89593c$var$handleHistorySpanListener(replay));
    $91fcfd915f89593c$var$handleBreadcrumbs(replay);
    $91fcfd915f89593c$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $91fcfd915f89593c$var$handleGlobalEventListener(replay);
    (0, $aYSwx.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on("beforeSendEvent", $91fcfd915f89593c$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $91fcfd915f89593c$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("spanStart", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on("spanEnd", (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $91fcfd915f89593c$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($91fcfd915f89593c$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $91fcfd915f89593c$var$createMemoryEntry($91fcfd915f89593c$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $91fcfd915f89593c$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $91fcfd915f89593c$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $91fcfd915f89593c$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $91fcfd915f89593c$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$91fcfd915f89593c$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $91fcfd915f89593c$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $91fcfd915f89593c$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $91fcfd915f89593c$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $91fcfd915f89593c$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $91fcfd915f89593c$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $91fcfd915f89593c$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $91fcfd915f89593c$var$addEventSync(replay, $91fcfd915f89593c$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $91fcfd915f89593c$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $lTsFS.createEnvelope)((0, $lTsFS.createEventEnvelopeHeaders)(replayEvent, (0, $lTsFS.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $91fcfd915f89593c$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $91fcfd915f89593c$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $bUnIF.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $gKECY.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $91fcfd915f89593c$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $91fcfd915f89593c$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $gKECY.getClient)();
    const scope = (0, $gKECY.getCurrentScope)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $3Yj72.resolvedSyncPromise)({});
    const baseEvent = {
        type: $91fcfd915f89593c$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $91fcfd915f89593c$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $91fcfd915f89593c$var$logInfo("An event processor returned `null`, will not send event.");
        return (0, $3Yj72.resolvedSyncPromise)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $91fcfd915f89593c$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($91fcfd915f89593c$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $91fcfd915f89593c$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $l3hVr.updateRateLimits)({}, response);
    if ((0, $l3hVr.isRateLimited)(rateLimits, "replay")) throw new $91fcfd915f89593c$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $91fcfd915f89593c$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $91fcfd915f89593c$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $91fcfd915f89593c$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $91fcfd915f89593c$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $91fcfd915f89593c$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $91fcfd915f89593c$var$TransportStatusCodeError || err instanceof $91fcfd915f89593c$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $aYSwx.setContext)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($91fcfd915f89593c$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $aYSwx.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $91fcfd915f89593c$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$91fcfd915f89593c$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $91fcfd915f89593c$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $91fcfd915f89593c$var$THROTTLED = "__THROTTLED";
const $91fcfd915f89593c$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $91fcfd915f89593c$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $91fcfd915f89593c$var$SKIPPED : $91fcfd915f89593c$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $91fcfd915f89593c$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init.call(this);
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init2.call(this);
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init3.call(this);
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init4.call(this);
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init5.call(this);
        $91fcfd915f89593c$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $91fcfd915f89593c$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $91fcfd915f89593c$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $91fcfd915f89593c$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $91fcfd915f89593c$var$throttle((event, isCheckout)=>$91fcfd915f89593c$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($91fcfd915f89593c$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $91fcfd915f89593c$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $91fcfd915f89593c$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $91fcfd915f89593c$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $91fcfd915f89593c$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $91fcfd915f89593c$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $91fcfd915f89593c$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $91fcfd915f89593c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $91fcfd915f89593c$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $91fcfd915f89593c$var$BUFFER_CHECKOUT_TIME
                },
                emit: $91fcfd915f89593c$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $91fcfd915f89593c$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $91fcfd915f89593c$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $91fcfd915f89593c$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $91fcfd915f89593c$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $91fcfd915f89593c$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $91fcfd915f89593c$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$91fcfd915f89593c$var$WINDOW.location.pathname}${$91fcfd915f89593c$var$WINDOW.location.hash}${$91fcfd915f89593c$var$WINDOW.location.search}`;
        const url = `${$91fcfd915f89593c$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $91fcfd915f89593c$var$THROTTLED) {
            const breadcrumb = $91fcfd915f89593c$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$91fcfd915f89593c$var$addEventSync(this, {
                    type: $91fcfd915f89593c$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $2jO8g.getActiveSpan)();
        const lastRootSpan = lastActiveSpan && (0, $2jO8g.getRootSpan)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $2jO8g.spanToJSON)(lastRootSpan).data || {};
        const source = attributes[0, $f2mxj.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastRootSpan || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $2jO8g.spanToJSON)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $91fcfd915f89593c$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay]", error);
        if ($91fcfd915f89593c$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $aYSwx.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $91fcfd915f89593c$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($91fcfd915f89593c$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $91fcfd915f89593c$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $91fcfd915f89593c$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $91fcfd915f89593c$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $91fcfd915f89593c$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $91fcfd915f89593c$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $91fcfd915f89593c$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $91fcfd915f89593c$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $91fcfd915f89593c$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $91fcfd915f89593c$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $91fcfd915f89593c$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($91fcfd915f89593c$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $91fcfd915f89593c$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $91fcfd915f89593c$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $91fcfd915f89593c$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $91fcfd915f89593c$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $91fcfd915f89593c$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $91fcfd915f89593c$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $91fcfd915f89593c$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($91fcfd915f89593c$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $91fcfd915f89593c$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $91fcfd915f89593c$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $gKECY.getClient)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $91fcfd915f89593c$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $91fcfd915f89593c$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $91fcfd915f89593c$var$DEBUG_BUILD && (0, $eN7RA.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $91fcfd915f89593c$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $91fcfd915f89593c$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $91fcfd915f89593c$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $91fcfd915f89593c$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $91fcfd915f89593c$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ]);
    const unmaskSelector = $91fcfd915f89593c$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $91fcfd915f89593c$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ]),
        unblockSelector: $91fcfd915f89593c$var$getOption(unblock, []),
        ignoreSelector: $91fcfd915f89593c$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $91fcfd915f89593c$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $91fcfd915f89593c$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $91fcfd915f89593c$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $91fcfd915f89593c$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $91fcfd915f89593c$export$d7706faf7ab354bf = (options)=>{
    return new $91fcfd915f89593c$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $91fcfd915f89593c$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $91fcfd915f89593c$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $91fcfd915f89593c$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $91fcfd915f89593c$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $91fcfd915f89593c$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling } = {}){
        this.name = $91fcfd915f89593c$var$Replay.id;
        const privacyOptions = $91fcfd915f89593c$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$91fcfd915f89593c$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $91fcfd915f89593c$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $91fcfd915f89593c$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $91fcfd915f89593c$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $91fcfd915f89593c$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $91fcfd915f89593c$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$91fcfd915f89593c$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $evu26.isBrowser)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $91fcfd915f89593c$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $91fcfd915f89593c$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $evu26.isBrowser)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $91fcfd915f89593c$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $91fcfd915f89593c$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $gKECY.getClient)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$91fcfd915f89593c$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $91fcfd915f89593c$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $gKECY.getClient)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $9Nu6W.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        (0, $eN7RA.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    const replaysSessionSampleRate = (0, $bkih4.parseSampleRate)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $bkih4.parseSampleRate)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $eN7RA.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $91fcfd915f89593c$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$91fcfd915f89593c$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $91fcfd915f89593c$export$b28310b2f161456b() {
    const client = (0, $gKECY.getClient)();
    return client && client.getIntegrationByName("Replay");
}

});
parcelRegister("fFkWd", function(module, exports) {

$parcel$export(module.exports, "_nullishCoalesce", function () { return $b67aed31b87ba6f8$export$8db64e83cc1a933c; });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $b67aed31b87ba6f8$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

});

parcelRegister("6ZXTI", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", function () { return $5186e700158f6041$export$3cc482e6b02f32f7; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $5186e700158f6041$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("evu26", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $a8fb41de3d0a68b9$export$4e09c449d6c407f7; });

var $lTIog = parcelRequire("lTIog");

var $inoaW = parcelRequire("inoaW");
/**
 * Returns true if we are in the browser.
 */ function $a8fb41de3d0a68b9$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $lTIog.isNodeEnv)() || $a8fb41de3d0a68b9$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $a8fb41de3d0a68b9$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $inoaW.GLOBAL_OBJ).process !== undefined && (0, $inoaW.GLOBAL_OBJ).process.type === "renderer");
}

});
parcelRegister("lTIog", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $2w0uK = parcelRequire("2w0uK");

var $tmjiR = parcelRequire("tmjiR");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $2w0uK.isBrowserBundle)() && Object.prototype.toString.call(typeof $tmjiR !== "undefined" ? $tmjiR : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});


parcelRegister("d4yBm", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", function () { return $98467d3aff0ee14b$export$d92e61f5600202af; });
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $98467d3aff0ee14b$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $98467d3aff0ee14b$var$checkDsn(url, dsn) || $98467d3aff0ee14b$var$checkTunnel(url, tunnel);
}
function $98467d3aff0ee14b$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $98467d3aff0ee14b$var$removeTrailingSlash(url) === $98467d3aff0ee14b$var$removeTrailingSlash(tunnel);
}
function $98467d3aff0ee14b$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $98467d3aff0ee14b$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}

});

parcelRegister("jmEwm", function(module, exports) {

$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $e18f8108c82e059b$export$3fd4b53331200102; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $e18f8108c82e059b$export$69816c1a049f8db6; });

var $fW2sf = parcelRequire("fW2sf");
var $eN7RA = parcelRequire("eN7RA");

var $cBmDR = parcelRequire("cBmDR");

var $cj1V8 = parcelRequire("cj1V8");

var $4q8ks = parcelRequire("4q8ks");

var $gPu8B = parcelRequire("gPu8B");

var $4GtA9 = parcelRequire("4GtA9");

var $gaCcC = parcelRequire("gaCcC");

var $5quKy = parcelRequire("5quKy");
const $e18f8108c82e059b$var$handlers = {};
const $e18f8108c82e059b$var$instrumented = {};
let $e18f8108c82e059b$var$_previousCls;
let $e18f8108c82e059b$var$_previousFid;
let $e18f8108c82e059b$var$_previousLcp;
let $e18f8108c82e059b$var$_previousTtfb;
let $e18f8108c82e059b$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $e18f8108c82e059b$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $e18f8108c82e059b$var$addMetricObserver("cls", callback, $e18f8108c82e059b$var$instrumentCls, $e18f8108c82e059b$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $e18f8108c82e059b$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $e18f8108c82e059b$var$addMetricObserver("lcp", callback, $e18f8108c82e059b$var$instrumentLcp, $e18f8108c82e059b$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $e18f8108c82e059b$export$2707d7471c0b918f(callback) {
    return $e18f8108c82e059b$var$addMetricObserver("fid", callback, $e18f8108c82e059b$var$instrumentFid, $e18f8108c82e059b$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $e18f8108c82e059b$export$699d9529c099a797(callback) {
    return $e18f8108c82e059b$var$addMetricObserver("ttfb", callback, $e18f8108c82e059b$var$instrumentTtfb, $e18f8108c82e059b$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $e18f8108c82e059b$export$da3b76aa2022cbd7(callback) {
    return $e18f8108c82e059b$var$addMetricObserver("inp", callback, $e18f8108c82e059b$var$instrumentInp, $e18f8108c82e059b$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $e18f8108c82e059b$export$69816c1a049f8db6(type, callback) {
    $e18f8108c82e059b$var$addHandler(type, callback);
    if (!$e18f8108c82e059b$var$instrumented[type]) {
        $e18f8108c82e059b$var$instrumentPerformanceObserver(type);
        $e18f8108c82e059b$var$instrumented[type] = true;
    }
    return $e18f8108c82e059b$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $e18f8108c82e059b$var$triggerHandlers(type, data) {
    const typeHandlers = $e18f8108c82e059b$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $cBmDR.DEBUG_BUILD) && (0, $eN7RA.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $fW2sf.getFunctionName)(handler)}\nError:`, e);
    }
}
function $e18f8108c82e059b$var$instrumentCls() {
    return (0, $cj1V8.onCLS)((metric)=>{
        $e18f8108c82e059b$var$triggerHandlers("cls", {
            metric: metric
        });
        $e18f8108c82e059b$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $e18f8108c82e059b$var$instrumentFid() {
    return (0, $4q8ks.onFID)((metric)=>{
        $e18f8108c82e059b$var$triggerHandlers("fid", {
            metric: metric
        });
        $e18f8108c82e059b$var$_previousFid = metric;
    });
}
function $e18f8108c82e059b$var$instrumentLcp() {
    return (0, $4GtA9.onLCP)((metric)=>{
        $e18f8108c82e059b$var$triggerHandlers("lcp", {
            metric: metric
        });
        $e18f8108c82e059b$var$_previousLcp = metric;
    });
}
function $e18f8108c82e059b$var$instrumentTtfb() {
    return (0, $5quKy.onTTFB)((metric)=>{
        $e18f8108c82e059b$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $e18f8108c82e059b$var$_previousTtfb = metric;
    });
}
function $e18f8108c82e059b$var$instrumentInp() {
    return (0, $gPu8B.onINP)((metric)=>{
        $e18f8108c82e059b$var$triggerHandlers("inp", {
            metric: metric
        });
        $e18f8108c82e059b$var$_previousInp = metric;
    });
}
function $e18f8108c82e059b$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $e18f8108c82e059b$var$addHandler(type, callback);
    let stopListening;
    if (!$e18f8108c82e059b$var$instrumented[type]) {
        stopListening = instrumentFn();
        $e18f8108c82e059b$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $e18f8108c82e059b$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $e18f8108c82e059b$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $gaCcC.observe)(type, (entries)=>{
        $e18f8108c82e059b$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $e18f8108c82e059b$var$addHandler(type, handler) {
    $e18f8108c82e059b$var$handlers[type] = $e18f8108c82e059b$var$handlers[type] || [];
    $e18f8108c82e059b$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $e18f8108c82e059b$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $e18f8108c82e059b$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("cBmDR", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $92ca80ef5bb22d6b$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $92ca80ef5bb22d6b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("cj1V8", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $8f58bfc860efeb65$export$a7873055838e5ad8; });

var $c0jrI = parcelRequire("c0jrI");

var $huzU2 = parcelRequire("huzU2");

var $gaCcC = parcelRequire("gaCcC");

var $jF8Ji = parcelRequire("jF8Ji");

var $cJft3 = parcelRequire("cJft3");

var $glQSA = parcelRequire("glQSA");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $8f58bfc860efeb65$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $8f58bfc860efeb65$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $glQSA.onFCP)((0, $cJft3.runOnce)(()=>{
        const metric = (0, $huzU2.initMetric)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $gaCcC.observe)("layout-shift", handleEntries);
        if (po) {
            report = (0, $c0jrI.bindReporter)(onReport, metric, $8f58bfc860efeb65$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $jF8Ji.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};

});
parcelRegister("c0jrI", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $8bd491b0a131e41c$export$17679dccdd551979; });
const $8bd491b0a131e41c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $8bd491b0a131e41c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $8bd491b0a131e41c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("huzU2", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $cbc11690960ce881$export$3c29b44508a0612b; });

var $7iN0o = parcelRequire("7iN0o");

var $3UOoe = parcelRequire("3UOoe");

var $9gCSf = parcelRequire("9gCSf");

var $vekss = parcelRequire("vekss");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $cbc11690960ce881$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $vekss.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.prerendering || (0, $9gCSf.getActivationStart)() > 0) navigationType = "prerender";
        else if ((0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $3UOoe.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("3UOoe", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $2d9db070a5035bdb$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $2d9db070a5035bdb$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("9gCSf", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $6bf3c341b1f8d178$export$d3e828b3c7b5b845; });

var $vekss = parcelRequire("vekss");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6bf3c341b1f8d178$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $vekss.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("vekss", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $05de02ccc2cc4def$export$6431553786c94949; });

var $7iN0o = parcelRequire("7iN0o");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $05de02ccc2cc4def$export$6431553786c94949 = ()=>{
    return (0, $7iN0o.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("gaCcC", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $bc5b36c37b39f2a0$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $bc5b36c37b39f2a0$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("jF8Ji", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $e5089e288fb8cdb0$export$91ec2be6fdd8f1b4; });

var $7iN0o = parcelRequire("7iN0o");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e5089e288fb8cdb0$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $7iN0o.WINDOW).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};

});

parcelRegister("cJft3", function(module, exports) {

$parcel$export(module.exports, "runOnce", function () { return $9445af89cdc96f55$export$b841d51e31c12bab; });
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9445af89cdc96f55$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return (arg)=>{
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};

});

parcelRegister("glQSA", function(module, exports) {

$parcel$export(module.exports, "onFCP", function () { return $be77a03cef9d36cc$export$fe3c86b74e15d5de; });

var $c0jrI = parcelRequire("c0jrI");

var $9gCSf = parcelRequire("9gCSf");

var $czLae = parcelRequire("czLae");

var $huzU2 = parcelRequire("huzU2");

var $gaCcC = parcelRequire("gaCcC");

var $e9Iav = parcelRequire("e9Iav");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $be77a03cef9d36cc$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $be77a03cef9d36cc$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $e9Iav.whenActivated)(()=>{
        const visibilityWatcher = (0, $czLae.getVisibilityWatcher)();
        const metric = (0, $huzU2.initMetric)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $9gCSf.getActivationStart)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $gaCcC.observe)("paint", handleEntries);
        if (po) report = (0, $c0jrI.bindReporter)(onReport, metric, $be77a03cef9d36cc$export$e610c735b5510cec, opts.reportAllChanges);
    });
};

});
parcelRegister("czLae", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $927d56b3fbe3e627$export$443f86b2c77012c4; });

var $7iN0o = parcelRequire("7iN0o");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $927d56b3fbe3e627$var$firstHiddenTime = -1;
const $927d56b3fbe3e627$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    $927d56b3fbe3e627$var$firstHiddenTime = (0, $7iN0o.WINDOW).document.visibilityState === "hidden" && !(0, $7iN0o.WINDOW).document.prerendering ? 0 : Infinity;
};
const $927d56b3fbe3e627$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $7iN0o.WINDOW).document.visibilityState === "hidden" && $927d56b3fbe3e627$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $927d56b3fbe3e627$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        removeEventListener("visibilitychange", $927d56b3fbe3e627$var$onVisibilityUpdate, true);
        removeEventListener("prerenderingchange", $927d56b3fbe3e627$var$onVisibilityUpdate, true);
    }
};
const $927d56b3fbe3e627$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $927d56b3fbe3e627$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $927d56b3fbe3e627$var$onVisibilityUpdate, true);
};
const $927d56b3fbe3e627$export$443f86b2c77012c4 = ()=>{
    if ((0, $7iN0o.WINDOW).document && $927d56b3fbe3e627$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $927d56b3fbe3e627$var$initHiddenTime();
        $927d56b3fbe3e627$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $927d56b3fbe3e627$var$firstHiddenTime;
        }
    };
};

});

parcelRegister("e9Iav", function(module, exports) {

$parcel$export(module.exports, "whenActivated", function () { return $a4e42ae859609dce$export$8bdb38a5671b594e; });

var $7iN0o = parcelRequire("7iN0o");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a4e42ae859609dce$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};

});



parcelRegister("4q8ks", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $33800d19b6c98eb4$export$39705a25c49af873; });

var $c0jrI = parcelRequire("c0jrI");

var $czLae = parcelRequire("czLae");

var $huzU2 = parcelRequire("huzU2");

var $gaCcC = parcelRequire("gaCcC");

var $jF8Ji = parcelRequire("jF8Ji");

var $cJft3 = parcelRequire("cJft3");

var $e9Iav = parcelRequire("e9Iav");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $33800d19b6c98eb4$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $33800d19b6c98eb4$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $e9Iav.whenActivated)(()=>{
        const visibilityWatcher = (0, $czLae.getVisibilityWatcher)();
        const metric = (0, $huzU2.initMetric)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $gaCcC.observe)("first-input", handleEntries);
        report = (0, $c0jrI.bindReporter)(onReport, metric, $33800d19b6c98eb4$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $jF8Ji.onHidden)((0, $cJft3.runOnce)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};

});

parcelRegister("gPu8B", function(module, exports) {

$parcel$export(module.exports, "onINP", function () { return $c408c97e807c061d$export$7df4b36ecaed99e1; });

var $7iN0o = parcelRequire("7iN0o");

var $c0jrI = parcelRequire("c0jrI");

var $huzU2 = parcelRequire("huzU2");

var $gaCcC = parcelRequire("gaCcC");

var $jF8Ji = parcelRequire("jF8Ji");

var $cvLON = parcelRequire("cvLON");

var $e9Iav = parcelRequire("e9Iav");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c408c97e807c061d$export$7f4cb060ded9173c = [
    200,
    500
];
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
const $c408c97e807c061d$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $c408c97e807c061d$var$getInteractionCountForNavigation = ()=>{
    return (0, $cvLON.getInteractionCount)() - $c408c97e807c061d$var$prevInteractionCount;
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $c408c97e807c061d$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $c408c97e807c061d$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $c408c97e807c061d$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $c408c97e807c061d$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $c408c97e807c061d$var$longestInteractionList[$c408c97e807c061d$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $c408c97e807c061d$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $c408c97e807c061d$var$longestInteractionList.length < $c408c97e807c061d$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $c408c97e807c061d$var$longestInteractionMap[interaction.id] = interaction;
            $c408c97e807c061d$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $c408c97e807c061d$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $c408c97e807c061d$var$longestInteractionList.splice($c408c97e807c061d$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $c408c97e807c061d$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $c408c97e807c061d$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($c408c97e807c061d$var$longestInteractionList.length - 1, Math.floor($c408c97e807c061d$var$getInteractionCountForNavigation() / 50));
    return $c408c97e807c061d$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c408c97e807c061d$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    (0, $e9Iav.whenActivated)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cvLON.initInteractionCountPolyfill)();
        const metric = (0, $huzU2.initMetric)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.interactionId) $c408c97e807c061d$var$processEntry(entry);
                // Entries of type `first-input` don't currently have an `interactionId`,
                // so to consider them in INP we have to first check that an existing
                // entry doesn't match the `duration` and `startTime`.
                // Note that this logic assumes that `event` entries are dispatched
                // before `first-input` entries. This is true in Chrome (the only browser
                // that currently supports INP).
                // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
                if (entry.entryType === "first-input") {
                    const noMatchingEntry = !$c408c97e807c061d$var$longestInteractionList.some((interaction)=>{
                        return interaction.entries.some((prevEntry)=>{
                            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                        });
                    });
                    if (noMatchingEntry) $c408c97e807c061d$var$processEntry(entry);
                }
            });
            const inp = $c408c97e807c061d$var$estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        const po = (0, $gaCcC.observe)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : 40
        });
        report = (0, $c0jrI.bindReporter)(onReport, metric, $c408c97e807c061d$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // If browser supports interactionId (and so supports INP), also
            // observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            if ("PerformanceEventTiming" in (0, $7iN0o.WINDOW) && "interactionId" in PerformanceEventTiming.prototype) po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $jF8Ji.onHidden)(()=>{
                handleEntries(po.takeRecords());
                // If the interaction count shows that there were interactions but
                // none were captured by the PerformanceObserver, report a latency of 0.
                if (metric.value < 0 && $c408c97e807c061d$var$getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
        }
    });
};

});
parcelRegister("cvLON", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", function () { return $91bd7903d884b744$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $91bd7903d884b744$export$67d90cda6b78a2eb; });

var $gaCcC = parcelRequire("gaCcC");
let $91bd7903d884b744$var$interactionCountEstimate = 0;
let $91bd7903d884b744$var$minKnownInteractionId = Infinity;
let $91bd7903d884b744$var$maxKnownInteractionId = 0;
const $91bd7903d884b744$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $91bd7903d884b744$var$minKnownInteractionId = Math.min($91bd7903d884b744$var$minKnownInteractionId, e.interactionId);
            $91bd7903d884b744$var$maxKnownInteractionId = Math.max($91bd7903d884b744$var$maxKnownInteractionId, e.interactionId);
            $91bd7903d884b744$var$interactionCountEstimate = $91bd7903d884b744$var$maxKnownInteractionId ? ($91bd7903d884b744$var$maxKnownInteractionId - $91bd7903d884b744$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $91bd7903d884b744$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $91bd7903d884b744$export$8a962f2683a476d1 = ()=>{
    return $91bd7903d884b744$var$po ? $91bd7903d884b744$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $91bd7903d884b744$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $91bd7903d884b744$var$po) return;
    $91bd7903d884b744$var$po = (0, $gaCcC.observe)("event", $91bd7903d884b744$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("4GtA9", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $36920808aad0b92d$export$947b1626ab8d5632; });

var $7iN0o = parcelRequire("7iN0o");

var $c0jrI = parcelRequire("c0jrI");

var $9gCSf = parcelRequire("9gCSf");

var $czLae = parcelRequire("czLae");

var $huzU2 = parcelRequire("huzU2");

var $gaCcC = parcelRequire("gaCcC");

var $jF8Ji = parcelRequire("jF8Ji");

var $cJft3 = parcelRequire("cJft3");

var $e9Iav = parcelRequire("e9Iav");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $36920808aad0b92d$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $36920808aad0b92d$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $36920808aad0b92d$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $e9Iav.whenActivated)(()=>{
        const visibilityWatcher = (0, $czLae.getVisibilityWatcher)();
        const metric = (0, $huzU2.initMetric)("LCP");
        let report;
        const handleEntries = (entries)=>{
            const lastEntry = entries[entries.length - 1];
            if (lastEntry) // Only report if the page wasn't hidden prior to LCP.
            {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(lastEntry.startTime - (0, $9gCSf.getActivationStart)(), 0);
                    metric.entries = [
                        lastEntry
                    ];
                    report();
                }
            }
        };
        const po = (0, $gaCcC.observe)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $c0jrI.bindReporter)(onReport, metric, $36920808aad0b92d$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $cJft3.runOnce)(()=>{
                if (!$36920808aad0b92d$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $36920808aad0b92d$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                if ((0, $7iN0o.WINDOW).document) // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                addEventListener(type, ()=>setTimeout(stopListening, 0), true);
            });
            (0, $jF8Ji.onHidden)(stopListening);
        }
    });
};

});

parcelRegister("5quKy", function(module, exports) {

$parcel$export(module.exports, "onTTFB", function () { return $3f373bc4d4152e33$export$33a01e6c5f2c7e33; });

var $7iN0o = parcelRequire("7iN0o");

var $c0jrI = parcelRequire("c0jrI");

var $9gCSf = parcelRequire("9gCSf");

var $vekss = parcelRequire("vekss");

var $huzU2 = parcelRequire("huzU2");

var $e9Iav = parcelRequire("e9Iav");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $3f373bc4d4152e33$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $3f373bc4d4152e33$var$whenReady = (callback)=>{
    if ((0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.prerendering) (0, $e9Iav.whenActivated)(()=>$3f373bc4d4152e33$var$whenReady(callback));
    else if ((0, $7iN0o.WINDOW).document && (0, $7iN0o.WINDOW).document.readyState !== "complete") addEventListener("load", ()=>$3f373bc4d4152e33$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $3f373bc4d4152e33$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $huzU2.initMetric)("TTFB");
    const report = (0, $c0jrI.bindReporter)(onReport, metric, $3f373bc4d4152e33$export$65c59ea8064668fc, opts.reportAllChanges);
    $3f373bc4d4152e33$var$whenReady(()=>{
        const navEntry = (0, $vekss.getNavigationEntry)();
        if (navEntry) {
            const responseStart = navEntry.responseStart;
            // In some cases no value is reported by the browser (for
            // privacy/security reasons), and in other cases (bugs) the value is
            // negative or is larger than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            // https://github.com/GoogleChrome/web-vitals/issues/275
            if (responseStart <= 0 || responseStart > performance.now()) return;
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(responseStart - (0, $9gCSf.getActivationStart)(), 0);
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

});




parcelRegister("gNcK4", function(module, exports) {

var $692Hc = parcelRequire("692Hc");

var $8doNm = parcelRequire("8doNm");
function $c39b1b3c0c0909ca$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $692Hc)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $8doNm(rnds);
}
module.exports = $c39b1b3c0c0909ca$var$v4;

});
parcelRegister("692Hc", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $4795aca88f53f22b$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($4795aca88f53f22b$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $4795aca88f53f22b$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $4795aca88f53f22b$var$getRandomValues($4795aca88f53f22b$var$rnds8);
        return $4795aca88f53f22b$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $4795aca88f53f22b$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $4795aca88f53f22b$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $4795aca88f53f22b$var$rnds;
    };
}

});

parcelRegister("8doNm", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $018b243765051142$var$byteToHex = [];
for(var $018b243765051142$var$i = 0; $018b243765051142$var$i < 256; ++$018b243765051142$var$i)$018b243765051142$var$byteToHex[$018b243765051142$var$i] = ($018b243765051142$var$i + 0x100).toString(16).substr(1);
function $018b243765051142$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $018b243765051142$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $018b243765051142$var$bytesToUuid;

});


parcelRegister("55kZq", function(module, exports) {

$parcel$export(module.exports, "deviceIdKey", function () { return $d42a121d7af8a6fa$export$37d7f5dc77f27ca7; });
const $d42a121d7af8a6fa$export$37d7f5dc77f27ca7 = "__TOMIS__device_id";

});

parcelRequire("hCUQ1");

var $7gLyp = parcelRequire("7gLyp");
// This code runs on the parent window, to create iframe
parcelRequire("2uMsc");

var $9mZp7 = parcelRequire("9mZp7");
var $85b59a1fc86645b9$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $85b59a1fc86645b9$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$85b59a1fc86645b9$var$debounce.debounce = $85b59a1fc86645b9$var$debounce;
$85b59a1fc86645b9$exports = $85b59a1fc86645b9$var$debounce;



var $j9Ew9 = parcelRequire("j9Ew9");

var $4Hdep = parcelRequire("4Hdep");

var $e3viL = parcelRequire("e3viL");

var $btdOp = parcelRequire("btdOp");

var $8grFr = parcelRequire("8grFr");

var $40gi4 = parcelRequire("40gi4");

var $9mZp7 = parcelRequire("9mZp7");

var $gNcK4 = parcelRequire("gNcK4");

var $55kZq = parcelRequire("55kZq");

var $e3viL = parcelRequire("e3viL");
async function $a2f7229942f34023$export$62a69605ae92a0a9() {
    try {
        const siteDeviceId = localStorage.getItem((0, $55kZq.deviceIdKey));
        if (siteDeviceId) {
            /** Set iframe device id to match parent window */ await $a2f7229942f34023$var$setCrossSiteDeviceIdToIframeLocalStorage(siteDeviceId);
            return siteDeviceId;
        } else {
            const existingCrossSiteDeviceId = await $a2f7229942f34023$var$getAndSyncCrossSiteDeviceId();
            if (existingCrossSiteDeviceId) return existingCrossSiteDeviceId;
            // create new device id and set in both parent and iframe local storage
            return $a2f7229942f34023$var$createAndSyncTomisDeviceId();
        }
    } catch (error) {
        console.warn("[TOMIS ChatBot] Could not get TOMIS Device ID: ", error);
        return "";
    }
}
/** Generate new uuid, then set in parent window local storage
 * and iframe local storage. */ async function $a2f7229942f34023$var$createAndSyncTomisDeviceId() {
    const newDeviceId = (0, (/*@__PURE__*/$parcel$interopDefault($gNcK4)))();
    localStorage.setItem((0, $55kZq.deviceIdKey), newDeviceId);
    await $a2f7229942f34023$var$setCrossSiteDeviceIdToIframeLocalStorage(newDeviceId);
    return newDeviceId;
}
/** Get TOMIS Device ID from TOMIS Bot iframe
 * and set in local storage for parent window.
 *
 * NOTE: only use this if parent window doesn't have
 * TOMIS device id in local storage */ async function $a2f7229942f34023$var$getAndSyncCrossSiteDeviceId() {
    const connection = $a2f7229942f34023$var$getIframeConnection();
    const { getDeviceIdIframeLocalStorage: getDeviceIdIframeLocalStorage } = await connection.promise;
    const crossSiteDeviceId = await getDeviceIdIframeLocalStorage();
    connection.destroy();
    /**
   * We always want to keep local site deviceId in sync with the
   * cross-site deviceId, so if the cross-site deviceId exists, we
   * set the local site deviceId to its value.
   */ if (crossSiteDeviceId) localStorage.setItem((0, $55kZq.deviceIdKey), crossSiteDeviceId);
    return crossSiteDeviceId;
}
/** Attempt to set TOMIS Device ID inside iframe.
 * If iframe local storage is blocked, this will fail silently. */ async function $a2f7229942f34023$var$setCrossSiteDeviceIdToIframeLocalStorage(id) {
    const connection = $a2f7229942f34023$var$getIframeConnection();
    const { setDeviceIdIframeLocalStorage: setDeviceIdIframeLocalStorage } = await connection.promise;
    const result = await setDeviceIdIframeLocalStorage(id);
    connection.destroy();
    return result;
}
/** Create connection to chatbot iframe, used to sync device ID */ function $a2f7229942f34023$var$getIframeConnection() {
    const connection = (0, (/*@__PURE__*/$parcel$interopDefault($9mZp7))).connectToChild({
        url: (0, $e3viL.IS_DEV) ? `${0, $e3viL.DEV_ORIGIN}/src/tomis-device-id/index.html` : `https://${0, $e3viL.PROJECT_ID}.firebaseapp.com/tomis-device-id/index.html`
    });
    connection.iframe.style.display = "none";
    return connection;
}


// Manage session storage for parent window

var $gNcK4 = parcelRequire("gNcK4");
function $36d3e2e8454dd135$var$getWebSessionIdKey(siteSlug) {
    return `${siteSlug}_webSessionId`;
}
const $36d3e2e8454dd135$export$9b7413b028ac1e39 = (siteSlug)=>{
    try {
        const sessionId = window.sessionStorage.getItem($36d3e2e8454dd135$var$getWebSessionIdKey(siteSlug));
        if (sessionId) return sessionId;
        else {
            const newId = (0, (/*@__PURE__*/$parcel$interopDefault($gNcK4)))();
            window.sessionStorage.setItem($36d3e2e8454dd135$var$getWebSessionIdKey(siteSlug), newId);
            return newId;
        }
    } catch (error) {
        console.warn("TOMIS ChatBot cannot load without access to browser local/session storage");
        throw error;
    }
};
function $36d3e2e8454dd135$var$getConversationIdKey(siteSlug) {
    return `${siteSlug}_conversationId`;
}
const $36d3e2e8454dd135$export$68fe9fb28e9ff89d = (siteSlug)=>window.sessionStorage.getItem($36d3e2e8454dd135$var$getConversationIdKey(siteSlug)) || "";
const $36d3e2e8454dd135$export$32d51d89016870be = (siteSlug, conversationId)=>{
    window.sessionStorage.setItem($36d3e2e8454dd135$var$getConversationIdKey(siteSlug), conversationId);
};
const $36d3e2e8454dd135$export$91124bb58bc04465 = {
    getOrCreateWebSessionIdSessionStorage: /** Parent window - get Web Session ID from `sessionStorage`, or
   * create & set a new uuid to `sessionStorage` if none exists.
   *
   * @throws Error if cannot access session storage */ $36d3e2e8454dd135$export$9b7413b028ac1e39,
    getConversationIdSessionStorage: /** Parent window - get conversationId from `sessionStorage`.
   * If none exists, returns empty string.
   *
   * @throws Error if cannot access sessionStorage */ $36d3e2e8454dd135$export$68fe9fb28e9ff89d,
    setConversationIdSessionStorage: /** Parent window - Set Conversation ID to `sessionStorage`
   *
   * @throws Error if cannot access sessionStorage */ $36d3e2e8454dd135$export$32d51d89016870be
};


async function $5138b3e73d40a3d7$export$4f9771e1107b6fcb(site) {
    /** TOMIS device ID from one of:
   * - Parent window (local storage)
   * - Iframe (local storage) = has visited another site w/ TOMIS Bot
   * - Create new = first-time visitor to any TOMIS site */ const tomisDeviceId = await (0, $a2f7229942f34023$export$62a69605ae92a0a9)();
    if (!tomisDeviceId) throw new Error("Unable to initialize TOMIS ChatBot - cannot get/set TOMIS device id to localStorage");
    const searchParameters = new URLSearchParams({
        site: site,
        initialParentWidth: String(window.innerWidth),
        initialParentHeight: String(window.innerHeight)
    });
    const connectionToChild = (0, (/*@__PURE__*/$parcel$interopDefault($9mZp7))).connectToChild({
        url: (0, $e3viL.IS_DEV) ? `${0, $e3viL.DEV_ORIGIN}/src/bot/index.html?${searchParameters}` : `https://${0, $e3viL.PROJECT_ID}.firebaseapp.com/bot/index.html?${searchParameters}`,
        methods: {
            async getGa4ClientId () {
                return (0, $j9Ew9.getGa4ClientId)(site);
            },
            async setConversationIdSessionStorage (id) {
                try {
                    return (0, $36d3e2e8454dd135$export$91124bb58bc04465).setConversationIdSessionStorage(site, id);
                } catch (error) {
                    console.warn(error);
                }
            },
            async getCurrentPageView () {
                return (0, $j9Ew9.createNewPageView)({
                    title: document.title,
                    url: (0, $j9Ew9.urlToObject)(new URL(window.location.href))
                });
            },
            async setPosition ([[width, height], [bottom, right]], view) {
                connectionToChild.iframe.style.width = (0, $8grFr.toPx)(width);
                connectionToChild.iframe.style.height = (0, $8grFr.toPx)(height);
                connectionToChild.iframe.style.bottom = (0, $8grFr.toPx)(bottom);
                connectionToChild.iframe.style.right = (0, $8grFr.toPx)(right);
                if (view === (0, $4Hdep.View).ChatWindowOpen) connectionToChild.iframe.className = "open";
                else if (view === (0, $4Hdep.View).ClosedWithPreview) connectionToChild.iframe.className = "closed-with-preview";
                else if (view === (0, $4Hdep.View).ClosedWithoutPreview) connectionToChild.iframe.className = "closed";
            },
            goToUrl (url) {
                const cleanUrl = !url.includes("https") && url.includes("http") && !url.includes("localhost") ? /**
         * Make sure URL is https to comply with Mixed Content Security:
         * https://developers.google.com/web/fundamentals/security/prevent-mixed-content/fixing-mixed-content
         */ url.replace("http", "https") : url;
                function navigate(url) {
                    // if iframed (AMP), navigate top window
                    if (window.top !== window) window.top.location.href = url;
                    else {
                        /** Try to open link in a new tab.
             * If link is categorized as a popup and blocked by browser,
             * redirect the parent window */ const popupWindow = window.open(url, "_blank");
                        if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === "undefined") window.location.href = url;
                    }
                }
                const destination = new URL(cleanUrl);
                if (destination.hostname !== window.location.hostname) try {
                    /** URL decorated w/ GA4 parameters */ const ga4Decorated = (0, $btdOp.decorateCrossDomainLink)(destination.href);
                    return navigate(ga4Decorated);
                } catch (e) {
                    (0, $40gi4.logError)(e, {
                        level: "warning",
                        message: "Could not decorate URL for Google Analytics 4 cross-domain tracking"
                    });
                }
                // if error or same domain, navigate normally
                return navigate(cleanUrl);
            },
            iframeResizeAMP (height) {
                window.parent.postMessage({
                    sentinel: "amp",
                    type: "embed-size",
                    height: height
                }, "*");
            },
            async getParentWindowDimensions () {
                return {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    isMobile: (0, $4Hdep.getIsMobile)(window.innerWidth)
                };
            }
        }
    });
    const [initialBottom, initialRight] = (0, $4Hdep.getIframePosition)((0, $4Hdep.View).ClosedWithoutPreview, (0, $4Hdep.getIsMobile)(window.innerWidth))[1];
    connectionToChild.iframe.id = "tomis-bot";
    connectionToChild.iframe.scrolling = "no";
    connectionToChild.iframe.style.position = "fixed";
    connectionToChild.iframe.style.zIndex = "9999998";
    connectionToChild.iframe.style.top = "auto";
    connectionToChild.iframe.style.left = "auto";
    connectionToChild.iframe.style.bottom = `${initialBottom}px`;
    connectionToChild.iframe.style.right = `${initialRight}px`;
    connectionToChild.iframe.style.border = "none";
    connectionToChild.iframe.style.overflow = "hidden";
    connectionToChild.iframe.style.width = "0px";
    connectionToChild.iframe.style.maxWidth = "100%";
    connectionToChild.iframe.style.height = "0px";
    connectionToChild.iframe.style.maxHeight = "100vh";
    connectionToChild.iframe.className = "closed";
    const conversationId = (0, $36d3e2e8454dd135$export$91124bb58bc04465).getConversationIdSessionStorage(site);
    const webSessionId = (0, $36d3e2e8454dd135$export$91124bb58bc04465).getOrCreateWebSessionIdSessionStorage(site);
    const iframeMethods = await connectionToChild.promise;
    // These values be sent to iframe before chatbot can load
    await iframeMethods.setIframeStorage({
        tomisDeviceId: tomisDeviceId,
        webSessionId: webSessionId,
        conversationId: conversationId
    });
    /** Inform chatbot iframe of parent window size, so that iframe can resize if necessary */ const dispatchUpdateParentWindowSize = (0, (/*@__PURE__*/$parcel$interopDefault($85b59a1fc86645b9$exports)))(()=>{
        try {
            iframeMethods.updateParentWindowSize([
                window.innerWidth,
                window.innerHeight
            ]);
        } catch (error) {
            // iframe was likely destroyed & thus 'updateParentWindowSize' cannot be called
            console.warn(error);
            console.warn("Removing window 'resize' event listener, which informs TOMIS ChatBot of updated window size. TOMIS ChatBot iframe has been removed from the page or cannot be reached.");
            window.removeEventListener("resize", dispatchUpdateParentWindowSize);
        }
    }, 100);
    window.addEventListener("resize", dispatchUpdateParentWindowSize);
    return iframeMethods;
}


/** Entry point for JavaScript loaded on client site, which will create the bot iframe */ function $9101ec146c468044$var$TOMIS({ site: site, googleAnalyticsId: googleAnalyticsId }) {
    (0, $7gLyp.initializeTracking)(site, googleAnalyticsId);
    /**
   * These are the methods tomis-fire exposes to the website it's used in:
   */ return {
        /**  Initializes the bot */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        async setupBot (cb) {
            // Errors will be fatal
            await (0, $5138b3e73d40a3d7$export$4f9771e1107b6fcb)(site);
        },
        /** **TODO**: Log event in BigQuery. This used to be done in Amplitude.
     *
     * NOTE: The following events are tracked automatically:
     * - page_view
     * - website_tel_clicked
     * - website_sms_clicked
     * - website_email_clicked
     * - website_link_clicked
     * The only reason to log them manually is if they happen in some non-standard way, i.e.
     * they're not from a semantic <a href="..."> element.
     */ async logEvent (event) {
            // TODO: Add runtime validation on the event passed to this function.
            // We should make it hard to mess up the type of events passed, otherwise
            // our data will get messy.
            return (0, $7gLyp.logEvent)(event);
        }
    };
}
window.TOMIS = $9101ec146c468044$var$TOMIS;

})();
//# sourceMappingURL=index.js.map
